import { Injectable } from "@angular/core";
import { EnumService } from "./enum.service";
import { NavController, Platform } from "@ionic/angular";
import { Profile } from "../_models/profile";
import { CheckinDetail } from "../_models/checkinDetail";
import { LocationItem } from "../_models/locationItem";
import { FileOpener } from "@ionic-native/file-opener/ngx";
import { SocialSharing } from "@awesome-cordova-plugins/social-sharing/ngx";

import { Capacitor } from "@capacitor/core";
import { Position } from '@capacitor/geolocation';
import {
  ActionPerformed,
  PushNotificationSchema,
  Token,
  PushNotifications
} from '@capacitor/push-notifications';

import { Device } from '@capacitor/device';

import { ActivityListItem } from "../_models/activityListItem";
import { DocumentDetail } from "../_models/documentDetail";
import { CheckInPostData } from "../_models/checkInPostData";
import { SignOffDetailsPostData } from "../_models/signOffDetailsPostData";
import { checkInFormItem } from "../_models/checkInFormItem";
import { UtilService } from "./util.service";
import { ApiService } from "./api.service";
import { Response, User } from "../_models";
import { ObservablesService } from "./observables.service";
import { CheckedInDetailItem } from "../_models/checkedInDetailItem";
import { SignOffFormDetail } from "../_models/signOffFormDetail";
import { HavAnswerObject } from "../_models/havAnswerObject";
import { FormAnswerObject } from "../_models/formAnswerObject";
import { SubmitAnswersObject } from "../_models/submitAnswersObject";
import { UntypedFormGroup } from "@angular/forms";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import * as moment from "moment/moment";
import { WorkPermitAnswer } from "../_models/workPermitAnswer";
import { ArAnswerObject } from "../_models/arAnswerObject";
import { StaticDataService } from "./static-data.service";
import { RiskRatingItem } from "../_models/riskRatingItem";
import { DedicatedModeDeviceDetailData } from "../_models/dedicatedModeDeviceDetailData";
import { DeviceEntityDetail } from "../_models/deviceEntityDetail";
import { DedicatedModeGuestDetail } from "../_models/dedicatedModeGuestDetail";
import { UserDetail } from "../_models/userDetail";
import {
  FileTransfer,
  FileUploadOptions,
} from "@ionic-native/file-transfer/ngx";
import { environment } from "../../environments/environment";
import { RiskRatingSeverityOption } from "../_models/riskRatingSeverityOption";
import { RiskRatingProbabilityOption } from "../_models/riskRatingProbabilityOption";
import { RAtaskTemplateItem } from "../_models/RAtaskTemplateItem";
import { HavAnswerDetail } from "../_models/havAnswerDetail";
import { TranslateService } from "@ngx-translate/core";
import { EntityItem } from "../_models/entityItem";
import { AccountService } from "./account.service";
import { OfflineManagerService } from "./offline-manager.service";
import { DeviceUserDetail } from "../_models/offline/DeviceUserDetail";
import { File } from "@ionic-native/file/ngx";
import { InductionItem } from "../_models/inductionItem";
import { FilehandlerService } from "./filehandler.service";
import { Insomnia } from "@ionic-native/insomnia/ngx";
import { Storage } from "@ionic/storage-angular";
import { BehaviorSubject, Subscriber, of } from "rxjs";
import { Observable } from 'rxjs';
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { map, catchError } from 'rxjs/operators';
//const { PushNotifications, Permissions } = Plugins;

const apiPath: string = "/x4wnyp56gow2ffl/api";
const apiPathInactive: string = "/y3k4rzp8lqx7vtsu/api";
const apiPathRefactored: string = "/q8sd2hj5rp9z6xv/api";

const allEnvironmentSiteUrl = {
  prod: "https://login.be-safetech.com",
  staging: "https://cg-dev.furnessinternet.uk",
  dev: "https://localhost:51847",
};
const webAppAllEnvironmentDomain = {
  prod: "https://access.be-safetech.com",
  staging: "https://cg-access-dev.furnessinternet.uk",
  dev: "http://localhost:8100",
};

@Injectable({
  providedIn: "root",
})
export class SharedDataService {
  apiServiceRerence: ApiService;
  accountServiceRef: AccountService;
  private headerColorSubject = new BehaviorSubject<string>(undefined);
  private menuColorSubject = new BehaviorSubject<string>(undefined);
  private subMenuColorSubject = new BehaviorSubject<string>(undefined);
  private logoPathSubject = new BehaviorSubject<string>(undefined);


  apiBaseUrl = environment.siteBaseUrl + apiPath;
  apiBaseUrlInactive = environment.siteBaseUrl + apiPathInactive;
  apiBaseUrlRefactored = environment.siteBaseUrl + apiPathRefactored;
  siteBaseUrl = environment.siteBaseUrl;

  myCurrentGeoLocation: Position;

  isNavigationTypeDeepLink = false;
  isLoginAfterAppOpen = false;

  annotationImage;
  annotationColor = "#98C16B";
  onAnnotationImageDone;
  headerColor$ = this.headerColorSubject.asObservable();
  menuColor$ = this.menuColorSubject.asObservable();
  subMenuColor$ = this.subMenuColorSubject.asObservable();
  logoPathSubject$ = this.logoPathSubject.asObservable();
  headerColor_P;
  menuColor_P;
  companyLogo;
  companyLogo_P;

  deviceUID = ""; // For simulator ipad
  // deviceUID = '33F3FF08-8A4E-4E24-84DC-D8AF80B8EAC1';
  // deviceUID = '5A8CD1FF-24AE-44B9-A2AD-65AA5309E2CE'; ipad
  // deviceUID = "33F3FF08-8A4E-4E24-14DC-D8AF80B8EAC1"; // For test dedicated mode
  // deviceUID = "33F3FF08-8A4E-4E24-14DC-D8AF80B8EAC12222"; // For test dedicated mode assign one location
  // deviceUID = 'f5aa72ed-21ca-4b12-8485-a24447cb420d'; // Arvin ipad device id
  // deviceUID = "f44ab87b-a2d6-8df0-8637-870495265348"; // SdevAndroid
  // deviceUID = "67DA70A1-FD31-4B48-81F6-74E9EB356632"; // SdevIphone
  // deviceUID = '0d98044b-6541-c58e-6353-935090075482'; // Rosana Tablet5.1

  pushToken = "000";
  isTablet = false;
  isDevelopmentMode = false;

  dedicatedMode =
    localStorage.getItem(EnumService.LocalStorageKeys.IS_DEDICATED_MODE) ===
    "true";
  offlineMode = true;
  // when open form or document , useful for next screens

  dedicatedModeDeviceDetailData: DedicatedModeDeviceDetailData;
  dedicatedModeAssignedEntities: Array<DeviceEntityDetail>;

  dedicatedModeGuestDetail: DedicatedModeGuestDetail;
  dedicatedModeUserDetail: UserDetail;

  // Data from Api
  checkedInPlaces: Array<CheckedInDetailItem> = [];
  currentSelectedCheckinPlace: CheckedInDetailItem;

  // Userful for personal mode dashbord
  activityList: Array<ActivityListItem>;
  activityOverviewData;

  userId: any;
  userProfile: Profile;
  timeZoneList;
  companyLanguageList;

  riskRatingsList: [RiskRatingItem];
  severityRatings: Array<RiskRatingSeverityOption>;
  probabilityRatings: Array<RiskRatingProbabilityOption>;
  raTaskTemplateList: Array<RAtaskTemplateItem>;

  locationItemList;

  // data for another pages
  checkInDetail: CheckinDetail;
  currentActivityOpen: ActivityListItem;
  signOffFormDetail: SignOffFormDetail; // For form activity signoff
  signOffDocumentDetail: DocumentDetail; // For activity document  signoff and current checkin document signoff
  viewFormDetail;

  /** Location selected on choose-location page**/
  dedicatedModeLocationUse: DeviceEntityDetail;

  // For dedicated mode
  dedicatedModeProcessType = ""; // EnumService.DedicatedModeProcessTypes
  checkinoutDmAs = ""; // EnumService.CheckInType
  signOffFor = ""; // EnumService.SignOffType
  dedicatedModeTempAuthFor = ""; // EnumService.DedicatedModeTempAuthType
  dedicatedModeTempAuthBy = ""; // EnumService.DedicatedModeTempAuthBy
  dedicatedModeCapturePhotoFor = ""; // EnumService.DedicatedModeCapturePhotoForType
  dedicatedModeCapturedSelfieForCheckinProcess; // photo name of uploaded captured selfie during checkin process, (For reuse it for signoff)
  dedicatedmodeRelaunchData = null; // For relaunch form or document

  viewFormFor; // View form for induction process or activity detail
  viewFormForActivityId; // View form for induction process or activity detail
  inductionContentItemIndex = 0;
  saveSateId = "";

  // Store location data for checkinout
  checkinLocationByOption; // EnumService.CheckInLocationByOptions
  checkInForLocation: LocationItem;
  checkOutForCheckedInDetail: CheckedInDetailItem;

  // Store  all screen checkin details for whole process and use this data on end of checkin data send to server
  checkInPostData: CheckInPostData;
  signOffDetailsPostData: SignOffDetailsPostData;
  private _networkCutPayloadJson: string = null;

  formBuilderDetails: any;
  savedFormStateData: any;
  savedFormStateScoreData: any;
  savedFormStateIndex: number = -1;
  relaunchFormStateData: any;
  relaunchFormBuilderStateData: any;

  // for use in next screen
  availableWorkPermits;

  isOpenSubScreen = false;
  isGalleryOrCameraOpened = false;

  workPermitAnswer: WorkPermitAnswer;

  currentLanguageId = 0;

  videoFileUpload;

  autocheckoutTimeoutRef = {};

  translateService: TranslateService;
  companyLangaugeTranslations = {};

  indexDbStorage: Storage = null;

  entityOwnerInfos: any;

  inSignatureUsersInfos: any[] = [];
  currentInformSignaturesData: any[] = [];

  relaunchInfo = {relaunch:false,userID:"",docID:0, management:false, same:false, diff:false}
  relaunchCheckin = false
  navigateFromRelaunch = false
  relaunchData = {} as any
  relaunchDiffFormId = {formId:0, docId:0}
  relaunchFormFoundInEntity = false
  relaunchSignoffCheck = false //TODO: find and delete refrences to this, this whole collection can probably be simplified
  private clearRelaunchStateAfterSignoff() {
    this.relaunchInfo = {relaunch:false,userID:"",docID:0, management:false, same:false, diff:false};
    this.relaunchCheckin = false;
    this.navigateFromRelaunch = false;
    this.relaunchData = {} as any;
    this.relaunchDiffFormId = {formId:0, docId:0};
    this.relaunchFormFoundInEntity = false;
    this.relaunchSignoffCheck = false;
    this.relaunchFormStateData = null;
    this.relaunchFormBuilderStateData = null;
  }



  submitEntityID = ""
  scoreData: any = {}
  savedScoreStateAvailable = false
  scoreStateData:any = {}

  isMobile = false

  checkinInductionData = {inProgress: false, id: 0, type:""}

  riskAssessmentNotifications = []

  formattedId=""
  
  isFormattedId=false

  isReviewal = false

  pmVisibleElements:{
    documents:{documentFolderIds:any[],documentIds:any[]},
    forms:{formFolderIds:any[],formIds:any[]},
    inventoryItems:{inventoryFolderIds:any[],inventoryIds:any[]},
    locations:{locationFolderIds:any[],locationIds:any[]},
    projects:{projectFolderIds:any[],projectIds:any[]}
}

  currentCheckinEntityFolderFiles = []
  checkinEntityFolderFiles = [{id:"",files:[]}]

  uploadProgress = 0
  fileUploadOngoing = true;
  loading = false;
  lastFormLaunch = 0
  lastSaveStateLaunch = 0;

  // hasCompanyRLPermission = [8,20,48,54,55,58,60,70,98,103,113,122,121,145,130,131,92,150]

  hasCompanyRLPermission = false;

  public isRestoring = false;

  public isUserClickingSingleChoice = false;

  private _selectedChoiceSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedChoice$ = this._selectedChoiceSubject.asObservable();

  set selectedChoice(value: any) {
    this._selectedChoiceSubject.next(value);
  }

  private _confirmBoxesSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  confirmBoxesState$ = this._confirmBoxesSubject.asObservable();
  

  updateConfirmBoxState(updatedState: any) {
    const currentStates = this._confirmBoxesSubject.getValue();
    const index = currentStates.findIndex((state) => state.confirmBoxId === updatedState.confirmBoxId);

    if (index !== -1) {
      currentStates[index] = updatedState;
    } else {
      currentStates.push(updatedState);
    }

    this._confirmBoxesSubject.next(currentStates);
  }

  private _checkboxStatesSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  checkboxStates$ = this._checkboxStatesSubject.asObservable();

  set checkboxStates(value: any[]) {
    this._checkboxStatesSubject.next(value);
  }

  addCheckboxState(state: any) {
    const currentStates = this._checkboxStatesSubject.getValue();
    const updatedStates = [...currentStates, state];
    this._checkboxStatesSubject.next(updatedStates);
  }

  updateCheckboxState(updatedState: any) {
    const currentStates = this._checkboxStatesSubject.getValue();
    const index = currentStates.findIndex((state) => state.answerChoiceAttributeId === updatedState.answerChoiceAttributeId);

    if (index !== -1) {
      currentStates[index] = updatedState;
      this._checkboxStatesSubject.next(currentStates);
    }
  }


  constructor(
    public platform: Platform,
    private fileTransfer: FileTransfer,
    private navCtrl: NavController,
    private observablesService: ObservablesService,
    private offlineManagerService: OfflineManagerService,
    public utilService: UtilService,
    public fileOpener: FileOpener,
    public file: File,
    private insomnia: Insomnia,
    private socialSharing: SocialSharing,
    private filehandlerService: FilehandlerService,
    private screenOrientation: ScreenOrientation //  private translateService: TranslateService
  ) {
    const currentHost = window.location.host;
    // Forpreview site domain
    const apiUrlDevHostname = new URL(allEnvironmentSiteUrl.dev).hostname;
    const apiUrlStagingHostname = new URL(allEnvironmentSiteUrl.staging)
      .hostname;
    const apiUrlProdHostname = new URL(allEnvironmentSiteUrl.prod).hostname;

    // Set dynamic api url for WebApp based on domain
    if (environment.isFormPreview || UtilService.isWebApp()) {
      // Webapp Site Domain
      const siteDevHostname = new URL(webAppAllEnvironmentDomain.dev).hostname;
      const siteStagingHostname = new URL(webAppAllEnvironmentDomain.staging)
        .hostname;
      const siteProdHostname = new URL(webAppAllEnvironmentDomain.prod)
        .hostname;

      if (
        currentHost === apiUrlDevHostname ||
        currentHost === siteDevHostname
      ) {
        this.apiBaseUrl = allEnvironmentSiteUrl.dev + apiPath;
        this.siteBaseUrl = allEnvironmentSiteUrl.dev;
        this.isDevelopmentMode = true;
      } else if (
        currentHost === apiUrlStagingHostname ||
        currentHost === siteStagingHostname
      ) {
        this.apiBaseUrl = allEnvironmentSiteUrl.staging + apiPath;
        this.siteBaseUrl = allEnvironmentSiteUrl.staging;
      } else if (
        currentHost === apiUrlProdHostname ||
        currentHost === siteProdHostname
      ) {
        this.apiBaseUrl = allEnvironmentSiteUrl.prod + apiPath;
        this.siteBaseUrl = allEnvironmentSiteUrl.prod;
      }
    } else {
      if (
        (!environment.production &&
          (currentHost === apiUrlDevHostname ||
            environment.siteBaseUrl.indexOf(apiUrlDevHostname) !== -1)) ||
        UtilService.isLocalHost()
      ) {
        this.isDevelopmentMode = true;
      }
    }

    this.isTablet = platform.is("tablet");
    this.dedicatedMode =
      localStorage.getItem(EnumService.LocalStorageKeys.IS_DEDICATED_MODE) ===
      "true";
    const dedicatedModeLocationUse = localStorage.getItem(
      EnumService.LocalStorageKeys.DEDICATED_MODE_LOCATION_USE
    );
    if (dedicatedModeLocationUse) {
      this.dedicatedModeLocationUse = JSON.parse(dedicatedModeLocationUse);
    }
    const dedicatedModeDeviceDetail = localStorage.getItem(
      EnumService.LocalStorageKeys.DEDICATED_MODE_DEVICE_DETAIL
    );
    if (dedicatedModeDeviceDetail) {
      this.dedicatedModeDeviceDetailData = JSON.parse(
        dedicatedModeDeviceDetail
      );
    }

    const dedicatedModeAssignedEntities = localStorage.getItem(
      EnumService.LocalStorageKeys.DEDICATED_MODE_ASSIGNED_ENTITIES
    );
    if (dedicatedModeAssignedEntities) {
      this.dedicatedModeAssignedEntities = JSON.parse(
        dedicatedModeAssignedEntities
      );
    }

    const userProfile = localStorage.getItem(
      EnumService.LocalStorageKeys.USER_PROFILE
    );
    if (userProfile) {
      this.userProfile = JSON.parse(userProfile);
    }

    const timeZoneList = localStorage.getItem(
      EnumService.LocalStorageKeys.TIMEZONE_LIST
    );
    if (timeZoneList) {
      this.timeZoneList = JSON.parse(timeZoneList);
    }

    const checkedInPlaces = localStorage.getItem(
      EnumService.LocalStorageKeys.CHECKED_IN_PLACES
    );
    if (checkedInPlaces) {
      this.checkedInPlaces = JSON.parse(checkedInPlaces);
    }

    const pushToken = localStorage.getItem(
      EnumService.LocalStorageKeys.PUSH_TOKEN
    );
    if (pushToken) {
      this.pushToken = pushToken;
    }

    const selectedCheckedInPlace = localStorage.getItem(
      EnumService.LocalStorageKeys.CURRENT_SELECTED_CHECKIN_PLACE
    );
    if (selectedCheckedInPlace) {
      this.currentSelectedCheckinPlace = JSON.parse(selectedCheckedInPlace);
    }
    this._confirmBoxesSubject.next([]);

    if(this.platform.is('iphone') || this.platform.is('ipad') || this.platform.is('android') || this.platform.is('mobile') ||this.platform.is('tablet')){
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  }

  loadCompanyRLPermissions(companyId: number): Observable<boolean> {
    return this.apiServiceRerence.GetPersonalModeRelaunchCompanies(companyId).pipe(
      map((res: any) => {
        this.hasCompanyRLPermission =
          res?.StatusCode === EnumService.ApiResponseCode.RequestSuccessful &&
          !!res.Result;
        return this.hasCompanyRLPermission;
      }),
      catchError(err => {
        this.hasCompanyRLPermission = false;
        return of(false);
      })
    );
  }

  getEntityOwnerId() {
    if(this.checkinInductionData?.inProgress){
     const loc = this.checkinInductionData
      this.apiServiceRerence.GetPersonalModeEntityOwnerId(loc.type === "L" ? loc.id : 0,loc.type === "P" ? loc.id : 0,loc.type === "I" ? loc.id : 0)
      .subscribe((res: any) => {
        this.entityOwnerInfos = res.Result;
      },
        (error) => {
          // Handle errors if any
          console.error('Error occurred:', error);
        })
      this.checkinInductionData.inProgress = false
    } else if (this.currentSelectedCheckinPlace) {
      this.apiServiceRerence.GetPersonalModeEntityOwnerId(
        this.currentSelectedCheckinPlace.locationID || 0, 
        this.currentSelectedCheckinPlace.projectID || 0, 
        this.currentSelectedCheckinPlace.inventoryItemID || 0
      )
      .subscribe((res: any) => {
        this.entityOwnerInfos = res.Result;
      },
        (error) => {
          // Handle errors if any
          console.error('Error occurred:', error);
        })
    } 
    
  }

  getParEntityOwnerId(locationId, projectId, inventoryItemId) {
    this.apiServiceRerence.GetPersonalModeEntityOwnerId(locationId, projectId, inventoryItemId)
      .subscribe((res: any) => {
        this.entityOwnerInfos = res.Result;
      },
        (error) => {
          // Handle errors if any
          console.error('Error occurred:', error);
        })
  }

  setCompanyColor(identity) {
    if (identity?.isEndUserColourEnabled) {
      this.subMenuColorSubject.next(UtilService.calculateLighterShade(UtilService.hexToRgb(identity?.headerColor), 0.25));
      this.headerColorSubject.next(identity?.headerColor);
      this.menuColorSubject.next(identity?.menuColor);
      this.menuColor_P = identity?.menuColor_P;
      this.headerColor_P = identity?.headerColor_P;
    }
    else if (!identity?.isEndUserColourEnabled) {
      this.headerColorSubject.next('#8A25B1');
      this.menuColorSubject.next('#fff');
      this.subMenuColorSubject.next('#AA39D6');
    }
    if (identity?.isEndUserLogoEnabled) {
      this.companyLogo = identity?.logoPath;
      this.companyLogo_P = identity?.logoPath;
      this.logoPathSubject.next(identity?.logoPath);
    }
    else if (!identity?.isEndUserLogoEnabled) {
      this.logoPathSubject.next('../../../assets/logoWhite.png');
    }

  }

  setAnnotationImage(image) {
    this.annotationImage = image;
  }

  getAnnotationImage() {
    return this.annotationImage;
  }

  isDedicatedModeEntityInAssignedList(
    entity: DeviceEntityDetail,
    assignedEntities: Array<DeviceEntityDetail>
  ): boolean {
    if (!entity || !assignedEntities?.length) {
      return false;
    }

    return assignedEntities.some(
      (item) =>
        (item.deviceEntityID &&
          item.deviceEntityID === entity.deviceEntityID) ||
        (item.locationID && item.locationID === entity.locationID) ||
        (item.projectID && item.projectID === entity.projectID) ||
        (item.inventoryItemID &&
          item.inventoryItemID === entity.inventoryItemID)
    );
  }

  clearDedicatedModeLocationUse() {
    this.dedicatedModeLocationUse = null;
    localStorage.removeItem(
      EnumService.LocalStorageKeys.DEDICATED_MODE_LOCATION_USE
    );
  }

  validateDedicatedModeLocationUse(
    assignedEntities?: Array<DeviceEntityDetail>
  ): boolean {
    if (!this.dedicatedModeLocationUse) {
      return true;
    }

    const entities =
      assignedEntities || this.dedicatedModeAssignedEntities || [];

    if (!entities.length) {
      this.clearDedicatedModeLocationUse();
      return false;
    }

    if (
      !this.isDedicatedModeEntityInAssignedList(
        this.dedicatedModeLocationUse,
        entities
      )
    ) {
      this.clearDedicatedModeLocationUse();
      return false;
    }

    return true;
  }

  redirectToChooseLocationIfCurrentEntityRemoved(
    assignedEntities?: Array<DeviceEntityDetail>
  ): boolean {
    if (this.validateDedicatedModeLocationUse(assignedEntities)) {
      return false;
    }

    this.navCtrl.navigateRoot("choose-location", { replaceUrl: true });
    return true;
  }

  dedicatedModeDeviceDeleted() {
    this.dedicatedModeDeviceDetailData = null;
    this.dedicatedModeAssignedEntities = null;
    this.dedicatedMode = false;
    localStorage.removeItem(EnumService.LocalStorageKeys.IS_DEDICATED_MODE);
    localStorage.removeItem(
      EnumService.LocalStorageKeys.DEDICATED_MODE_DEVICE_DETAIL
    );
    localStorage.removeItem(
      EnumService.LocalStorageKeys.DEDICATED_MODE_ASSIGNED_ENTITIES
    );
    localStorage.removeItem(
      EnumService.LocalStorageKeys.DEDICATED_MODE_LOCATION_USE
    );
    this.dedicatedModeLocationUse = null;
    this.navCtrl.navigateRoot("/login", { replaceUrl: true });
    if (!UtilService.isWebApp()) {
      this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
    }
    this.configureForPushNotification();
  }

  resetAllSharedVariable() {
    this.checkedInPlaces = [];
    this.currentSelectedCheckinPlace = null;
    this.userProfile = null;
    this.timeZoneList = null;
    this.companyLanguageList = null;
    this.locationItemList = null;
    this.checkInDetail = null;
    this.currentActivityOpen = null;
    this.signOffFormDetail = null;
    this.signOffDocumentDetail = null;
    this.dedicatedModeLocationUse = null;
    this.dedicatedModeCapturedSelfieForCheckinProcess = null;
    this.checkinoutDmAs = "";
    this.signOffFor = "";
    this.viewFormFor = null;
    this.inductionContentItemIndex = 0;
    this.checkInForLocation = null;
    this.checkOutForCheckedInDetail = null;
    this.checkInPostData = null;
    this.signOffDetailsPostData = null;
    this.formBuilderDetails = null;
    this.availableWorkPermits = null;
    this.isOpenSubScreen = false;
    this.workPermitAnswer = null;
  }

  getLoggedInUser() {
    const user: User = JSON.parse(
      localStorage.getItem(EnumService.LocalStorageKeys.USER_DATA)
    );
    return user;
  }

  getLanguageIdForForm() {
    const formBuilderDetail = this.formBuilderDetails;
    if (!this.dedicatedMode && this.currentLanguageId) {
      let sections = formBuilderDetail.sections;
      let selectedLanguageID = formBuilderDetail.defaultLanguageId;

      if (selectedLanguageID !== this.currentLanguageId) {
        const firstSection =
          sections && sections.length > 0 ? sections[0] : null;
        if (firstSection && firstSection.sectionTranslations?.length > 1) {
          firstSection.sectionTranslations.some((item) => {
            if (item.sectionTranslationLanguageId === this.currentLanguageId) {
              selectedLanguageID = this.currentLanguageId;
              return true;
            }
          });
        }
      }
      return selectedLanguageID;
    } else {
      return this.formBuilderDetails?.defaultLanguageId;
    }
  }

  configureForPushNotification = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        var device = await Device.getInfo();
        var isAndroid13 = (device.platform.toLowerCase() == "android" && device.osVersion.toLowerCase() == "13");
        console.log("Device Version: ", device.platform, device.osVersion);
        console.log("Checking for PushNotification Permission...");
        const notificationPermission = await PushNotifications.checkPermissions();
        console.log("PushNotification Permission: ", notificationPermission.receive);
        if (notificationPermission.receive !== "granted") {
          await PushNotifications.requestPermissions().then((result) => {
            if (result.receive === "granted") {
              localStorage.setItem(
                EnumService.LocalStorageKeys.PUSH_PERMISSION_ALLOWED,
                "true"
              );
              // Register with Apple / Google to receive push via APNS/FCM
              this.registerForPushNotification();
            } else {
              localStorage.setItem(
                EnumService.LocalStorageKeys.PUSH_PERMISSION_ALLOWED,
                "false"
              );
              this.updatePushSettingOnServer(false);
            }
          });
        } else {
          localStorage.setItem(
            EnumService.LocalStorageKeys.PUSH_PERMISSION_ALLOWED,
            "true"
          );
          this.registerForPushNotification();
        }

        // On success, we should be able to receive notifications
        PushNotifications.addListener(
          "registration",
          (token: Token) => {
            localStorage.setItem(
              EnumService.LocalStorageKeys.PUSH_TOKEN,
              token.value
            );
            this.pushToken = token.value;
          }
        );

        // Show us the notification payload if the app is open on our device
        PushNotifications.addListener(
          "pushNotificationReceived",
          (notification: PushNotificationSchema) => {
          }
        );

        // Method called when tapping on a notification
        PushNotifications.addListener(
          "pushNotificationActionPerformed",
          (notification: ActionPerformed) => {
            if (notification.actionId === "tap") {
              const notificationData = notification.notification.data;
              switch (notificationData.action) {
                case EnumService.NotificationActionType.NewActivityAssigned:
                case EnumService.NotificationActionType.SignOffRejected:
                case EnumService.NotificationActionType.ActivityOverdue:
                  if (
                    !this.dedicatedMode &&
                    this.getLoggedInUser() &&
                    this.getLoggedInUser()?.userId
                  ) {
                    setTimeout(() => {
                      const contentlink = notificationData.contentlink;
                      const activityId = contentlink.split("_").pop();

                      const activityList = this.activityList;
                      let currentActivityOpen: ActivityListItem;
                      if (activityList) {
                        activityList.map((item) => {
                          if (item.activityIndividualID === activityId) {
                            currentActivityOpen = item;
                            return;
                          }
                        });
                      }
                      if (!currentActivityOpen) {
                        currentActivityOpen = {
                          activityIndividualID: activityId,
                        } as ActivityListItem;
                      }

                      this.currentActivityOpen = currentActivityOpen;
                      this.navCtrl.navigateForward(["/activity-detail"]);
                    }, 100);
                  }
                  break;
              }
            }
            // {"actionId":"tap","notification":{"body":"You have a new Activity Assigned","badge":1,"id":"A50F97EA-2426-4407-B9B6-80E576527CD1","subtitle":"","data":{"google.c.a.e":"1","contentlink":"https://cg.utopia-test.com/Activity/ActivityDetail/0_1339","action":"New Activity Assigned","aps":{"alert":{"title":"ComplianceGenie","body":"You have a new Activity Assigned"},"sound":"default","category":"FCM_PLUGIN_ACTIVITY"},"content":"You have a new Activity Assigned","gcm.message_id":"1610621468120206","google.c.sender.id":"1005975349422"},"title":"ComplianceGenie"}}
          
          }
        );
      } catch (e) { }
    }
  };

  registerForPushNotification = () => {
    PushNotifications.register();
    this.updatePushSettingOnServer(true);
  };

  updatePushSettingOnServer = (isEnable) => {
    if (this.dedicatedMode) {
      this.apiServiceRerence
        .updatePushNotification(
          {
            isPushNotification: isEnable,
          },
          this.deviceUID
        )
        .subscribe(() => { });
    } else {
      if (this.getLoggedInUser()?.userId) {
        this.apiServiceRerence
          .updatePushNotification(
            {
              isPushNotification: isEnable,
            },
            this.getLoggedInUser()?.userId
          )
          .subscribe(() => { });
      }
    }
  };

  checkLocationArchiveForDedicatedMode = (callBack = null) => {
    if (!this.offlineMode) {
      const locationParam = {};
      if (this.dedicatedModeLocationUse?.locationID) {
        locationParam["locationID"] = this.dedicatedModeLocationUse?.locationID;
      } else if (this.dedicatedModeLocationUse?.inventoryItemID) {
        locationParam["inventoryItemID"] =
          this.dedicatedModeLocationUse.inventoryItemID;
      } else if (this.dedicatedModeLocationUse?.projectID) {
        locationParam["projectID"] = this.dedicatedModeLocationUse.projectID;
      }

      const timeoutRef = setTimeout(() => {
        callBack && callBack();
      }, 5000);

      this.apiServiceRerence.checkLocationArchive(locationParam).subscribe(
        (res: Response) => {
          if (
            res &&
            res.StatusCode === EnumService.ApiResponseCode.RequestSuccessful &&
            res.Result
          ) {
            this.resetAllSharedVariable();
            localStorage.removeItem(
              EnumService.LocalStorageKeys.DEDICATED_MODE_LOCATION_USE
            );
            this.navCtrl.navigateRoot("choose-location");
          }
          callBack && callBack();
          timeoutRef && clearTimeout(timeoutRef);
        },
        (error) => {
          callBack && callBack();
          timeoutRef && clearTimeout(timeoutRef);
        }
      );
    } else {
      callBack && callBack();
    }
  };

  checkLocationArchiveForPersonalMode = (callBack = null) => {
    if (this.currentSelectedCheckinPlace) {
      const locationParam = {};
      if (this.currentSelectedCheckinPlace?.locationID) {
        locationParam["locationID"] =
          this.currentSelectedCheckinPlace?.locationID;
      } else if (this.currentSelectedCheckinPlace?.inventoryItemID) {
        locationParam["inventoryItemID"] =
          this.currentSelectedCheckinPlace.inventoryItemID;
      } else if (this.currentSelectedCheckinPlace?.projectID) {
        locationParam["projectID"] = this.currentSelectedCheckinPlace.projectID;
      }

      const timeoutRef = setTimeout(() => {
        callBack && callBack();
      }, 3000);

      this.apiServiceRerence.checkLocationArchive(locationParam).subscribe(
        (res: Response) => {
          if (
            res &&
            res.StatusCode === EnumService.ApiResponseCode.RequestSuccessful &&
            res.Result
          ) {
            this.checkOutForCheckedInDetail = this.currentSelectedCheckinPlace;
            this.checkoutArchivedLocation();
          }

          callBack && callBack();
          timeoutRef && clearTimeout(timeoutRef);
        },
        (error) => {
          callBack && callBack();
          timeoutRef && clearTimeout(timeoutRef);
        }
      );
    } else {
      callBack && callBack();
    }
  };

  checkoutArchivedLocation = () => {
    if (this.checkOutForCheckedInDetail) {
      this.utilService.presentLoadingWithOptions();

      const timeOutRef = setTimeout(() => {
        this.utilService.hideLoading();
      }, 3000);

      this.apiServiceRerence
        .insertCheckOutDetails({
          userCheckInDetailID:
            this.checkOutForCheckedInDetail.userCheckInDetailID,
          userId: this.accountServiceRef?.userValue?.userId,
          checkOutLatitude: this.myCurrentGeoLocation?.coords?.latitude,
          checkOutLongitude: this.myCurrentGeoLocation?.coords?.longitude,
        })
        .subscribe(
          (response: Response) => {
            this.utilService.hideLoading();
            timeOutRef && clearTimeout(timeOutRef);
            if (
              response.StatusCode ===
              EnumService.ApiResponseCode.RequestSuccessful
            ) {
              if (this.checkOutForCheckedInDetail) {
                this.offlineManagerService
                  .removeEvacuationForCompanyUserAtEntity(
                    this.accountServiceRef?.userValue?.userId,
                    {
                      locationID:
                        this.checkOutForCheckedInDetail.locationID || 0,
                      projectID:
                        this.checkOutForCheckedInDetail.projectID || 0,
                      inventoryItemID:
                        this.checkOutForCheckedInDetail.inventoryItemID || 0,
                    } as DeviceEntityDetail
                  )
                  .catch(() => {});
              }
              this.observablesService.publishSomeData(
                EnumService.ObserverKeys.NEW_CHECKED_IN,
                true
              );
            }
          },
          (error) => {
            this.utilService.hideLoading();
            timeOutRef && clearTimeout(timeOutRef);
          }
        );
    }
  };

  /**
   * GetLangFileTranslation from api
   * @param callBack
   */
  getLangFileTranslation = (callBack, resetPassCode = null) => {
    const onSuccessCallBack = (response: Response) => {
      if (response) {
        this.translateService.setTranslation("en", response, true);
        this.translateService.use("en");
        this.companyLangaugeTranslations = response;
      }
      callBack && callBack();
    };

    const onErrorCallBack = (error) => {
      callBack && callBack();
    };

    if (resetPassCode) {
      this.apiServiceRerence
        .getCompanyLanguageTemplateByCode(resetPassCode)
        .subscribe(onSuccessCallBack, onErrorCallBack);
    } else {
      this.apiServiceRerence
        .getCompanyLanguageTemplate()
        .subscribe(onSuccessCallBack, onErrorCallBack);
    }
  };

  /**
   * checkAutoCheckOutForCurrentCheckin
   */
  public checkAutoCheckOutForCurrentCheckin() {
    const timeZoneList = this.timeZoneList;
    let userProfileTimeZone;
    timeZoneList?.some((item) => {
      if (item.timeZoneID === this.userProfile?.timeZoneID) {
        userProfileTimeZone = item;
        return true;
      }
    });

    //Clear previous timeout
    Object.keys(this.autocheckoutTimeoutRef).map((timeoutRef: any) => {
      clearTimeout(timeoutRef);
    });
    this.autocheckoutTimeoutRef = {};

    const currentCheckinList = this.checkedInPlaces;
    if (currentCheckinList && currentCheckinList.length > 0) {
      currentCheckinList.map((item) => {
        let autoCheckoutDateTime;
        const currentCheckinMyTime = moment(item.checkInDate).add(
          userProfileTimeZone?.timeDifference || 0,
          "minutes"
        );
        let isAutoCheckOut = false;

        if (
          (item.userAutoCheckOutTime &&
            item.userAutoCheckOutTime.indexOf(":") !== -1) ||
          (item.locationAutoCheckOutTime &&
            item.locationAutoCheckOutTime.indexOf(":") !== -1)
        ) {
          let parts;
          if (
            item.userAutoCheckOutTime &&
            item.userAutoCheckOutTime.indexOf(":") !== -1
          ) {
            parts = item.userAutoCheckOutTime.split(":");
          } else {
            parts = item.locationAutoCheckOutTime.split(":");
          }
          let hour = parseInt(parts[0]);
          let minute = parseInt(parts[1]);
          let checkInDate = moment(item.checkInDate);
          autoCheckoutDateTime = moment(
            checkInDate.format(
              "YYYY-MM-DDT" +
              UtilService.appendZero(hour) +
              ":" +
              UtilService.appendZero(minute) +
              ":00.00"
            )
          );

          isAutoCheckOut = true;
        }

        if (!isAutoCheckOut) {
          if (item.locationAutoCheckOutHour > 0) {
            autoCheckoutDateTime = moment(currentCheckinMyTime).add(
              item.locationAutoCheckOutHour,
              "hour"
            );
            isAutoCheckOut = true;
          }
        }

        if (isAutoCheckOut) {
          const userProfileCurrentDate = moment(item.currentUTCDate).add(
            userProfileTimeZone?.timeDifference || 0,
            "minutes"
          );
          if (userProfileCurrentDate < autoCheckoutDateTime) {
            const seconds = autoCheckoutDateTime.diff(
              userProfileCurrentDate,
              "seconds"
            );
            if (seconds > 0) {
              this.autocheckoutTimeoutRef[item.userCheckInDetailID] =
                setTimeout(() => {
                  if (this.checkedInPlaces) {
                    this.checkedInPlaces.some((place, placeIndex) => {
                      if (
                        place.userCheckInDetailID === item.userCheckInDetailID
                      ) {
                        this.checkedInPlaces.splice(placeIndex, 1);
                        this.observablesService.publishSomeData(
                          EnumService.ObserverKeys
                            .UPDATE_CURRENT_CHECKIN_LIST_IN_COMPONENT,
                          {}
                        );
                        return true;
                      }
                    });
                  }
                  setTimeout(() => {
                    this.observablesService.publishSomeData(
                      EnumService.ObserverKeys.REFRESH_CURRENT_CHECKIN_LIST,
                      {}
                    );
                  }, 1000 * 60 * 3);
                }, seconds * 1000);
            }
          }
        }
      });
    }
  }

  showLimitedAccessAlert = () => {
    this.translateService
      .get([
        "SHARED_TEXT.ERRORS.ALERT_TITLE_RESTRICTED_FILE",
        "SHARED_TEXT.ERRORS.ALERT_MESSAGE_RESTRICTED_FILE",
      ])
      .subscribe((res) => {
        this.utilService.showAlert(
          res["SHARED_TEXT.ERRORS.ALERT_MESSAGE_RESTRICTED_FILE"],
          res["SHARED_TEXT.ERRORS.ALERT_TITLE_RESTRICTED_FILE"]
        );
      });
  };

  /**
   * For dedicated mode
   */
  public getCurrentCheckedInEntityName = () => {
    return this.getEntityName(this.dedicatedModeLocationUse);
  };

  /**
   * For dedicated mode
   */
  public getEntityName = (deviceEntityDetail: DeviceEntityDetail) => {
    if (deviceEntityDetail?.locationID > 0) {
      return deviceEntityDetail?.locationName;
    } else if (deviceEntityDetail?.projectID > 0) {
      return deviceEntityDetail?.projectName;
    } else if (deviceEntityDetail?.inventoryItemID > 0) {
      return deviceEntityDetail?.itemName;
    }
    return "";
  };

  public getCheckinDetails = async (userId, apiService: ApiService) => {
    if (userId && this.checkInForLocation) {
      let ifAlreadyCheckedinPlace;
      if (this.checkedInPlaces) {
        this.checkedInPlaces.map((place) => {
          const entityIds = this.utilService.getRelevantEntityId(
            this.checkInForLocation?.locationID
          );
          if (
            (entityIds.InventoryID > 0 &&
              entityIds.InventoryID === place?.inventoryItemID) ||
            (entityIds.ProjectID > 0 &&
              entityIds.ProjectID === place?.projectID) ||
            (entityIds?.LocationID > 0 &&
              entityIds?.LocationID === place?.locationID)
          ) {
            ifAlreadyCheckedinPlace = place;
            return;
          }
        });
      }

      if (ifAlreadyCheckedinPlace && !this.relaunchFormFoundInEntity) {
        this.checkOutForCheckedInDetail = ifAlreadyCheckedinPlace;
        this.translateService
          .get([
            "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.CHECK_OUT",
            "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_ARE_CHECKING_OUT",
            "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.CHECK_OUT_NOW",
          ])
          .subscribe((res) => {
            this.navCtrl.navigateForward(["/checkinout-confirm"], {
              queryParams: {
                headerTitle:
                  res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.CHECK_OUT"],
                title:
                  res[
                  "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_ARE_CHECKING_OUT"
                  ],
                subtitle: ifAlreadyCheckedinPlace.entityName,
                buttonTitle:
                  res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.CHECK_OUT_NOW"],
                locationCheckType: EnumService.ConfirmForCheckType.CheckOut,
              },
              replaceUrl: true,
            });
          });
      } else if (this.relaunchCheckin && this.relaunchFormFoundInEntity && ifAlreadyCheckedinPlace){
        //select the entity and go to the form
        const targetID= this.checkInForLocation?.locationID?.split("|")[1]
        for (const entity of this.checkedInPlaces){
          if(entity?.locationID !=0 && entity?.locationID?.toString() === targetID){
            this.currentSelectedCheckinPlace = entity
          } else if (entity.projectID !=0 && entity.projectID.toString() === targetID){
            this.currentSelectedCheckinPlace = entity
          } else if (entity.inventoryItemID !=0 && entity.inventoryItemID.toString() === targetID){
            this.currentSelectedCheckinPlace = entity
          }
        }
        this.navCtrl.navigateForward(["/checkin-success"], {queryParams: {
            message: "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_HAVE_NOW_CHECKEDIN",
            nextPage: "/tabs/dashboard",
            actionBtnTitle:"SHARED_TEXT.CONTINUE",
            alreadyCheckedIn:"true"
          },
        })
      } else {
        this.utilService.presentLoadingWithOptions();
        this.submitEntityID = this.checkInForLocation?.locationID
        apiService
          .getCheckInDetails(userId, this.checkInForLocation?.locationID)
          .subscribe(
            (response: Response) => {
              this.utilService.hideLoading();
              if (
                response.StatusCode ===
                EnumService.ApiResponseCode.RequestSuccessful
              ) {
                this.checkInDetail = response.Result as CheckinDetail;
                this.checkInPostData = {
                  userId,
                  checkInLatitude: this.myCurrentGeoLocation?.coords?.latitude,
                  checkInLongitude:
                    this.myCurrentGeoLocation?.coords?.longitude,
                  isGuestReturning: false,
                  projectID: this.checkInDetail.checkInEntityDetail.projectID,
                  inventoryItemID:
                    this.checkInDetail.checkInEntityDetail.inventoryItemID,
                  locationID: this.checkInDetail?.checkInEntityDetail?.locationID,
                } as CheckInPostData;

                this.translateService
                  .get([
                    "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.CHECK_IN",
                    "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_ARE_CHECKING_IN",
                    "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.CHECK_IN_NOW",
                  ])
                  .subscribe((res) => {
                    this.navCtrl.navigateForward(["/checkinout-confirm"], {
                      queryParams: {
                        headerTitle:
                          res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.CHECK_IN"],
                        title:
                          res[
                          "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_ARE_CHECKING_IN"
                          ],
                        subtitle: this.checkInForLocation.locationName,
                        buttonTitle:
                          res[
                          "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.CHECK_IN_NOW"
                          ],
                        nextPageData: JSON.stringify({
                          locationDetail: JSON.stringify(
                            this.checkInForLocation
                          ),
                        }),
                        nextPagePath: "/checkin-induction",
                        locationCheckType:
                          EnumService.ConfirmForCheckType.CheckIn,
                      },
                      replaceUrl: true,
                    });
                  });
              }
            },
            (error: any) => {
              const errorField =
                error?.error?.ResponseException?.ValidationErrors[0].Field;

              this.utilService.hideLoading();
              if (errorField.indexOf("SimultaneousCheckIn") !== -1) {
                this.translateService
                  .get([
                    "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_CANNOT_CHECKIN",
                    "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.SIMULTANIOUS_CHECKIN_NOT_ALLOWED",
                    "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_ARE_ALREADY_CHECKEDIN_TO_ANOTHER_PLACE",
                  ])
                  .subscribe((res) => {
                    if(this.relaunchCheckin){
                      this.navCtrl.navigateForward(["/checkin-fail"], {
                        queryParams: {
                          title: res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_CANNOT_CHECKIN"],
                          errorTitle: res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.SIMULTANIOUS_CHECKIN_NOT_ALLOWED"],
                          errorMessage: res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_ARE_ALREADY_CHECKEDIN_TO_ANOTHER_PLACE"],
                          nextPage: "/tabs/dashboard/checkin-list", 
                          btnText:'PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.BACK_TO_CHECKIN_LIST'
                        },
                        replaceUrl: true,
                      });
                    } else{
                    this.navCtrl.navigateForward(["/checkin-fail"], {
                      queryParams: {
                        title: res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_CANNOT_CHECKIN"],
                        errorTitle: res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.SIMULTANIOUS_CHECKIN_NOT_ALLOWED" ],
                        errorMessage: res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_ARE_ALREADY_CHECKEDIN_TO_ANOTHER_PLACE"],
                        nextPage: "/tabs/dashboard",
                      },
                      replaceUrl: true,
                    });
                  }
                  });
              } else {
                this.translateService
                  .get([
                    "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_CANNOT_CHECKIN",
                    "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.NO_QUALIFICATION",
                    "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_DO_NOT_HAVE_THE_REQUIRED_QUALIFICATIONS",
                  ])
                  .subscribe((res) => {
                    this.navCtrl.navigateForward(["/checkin-fail"], {
                      queryParams: {
                        title:
                          res[
                          "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_CANNOT_CHECKIN"
                          ],
                        errorTitle:
                          res[
                          "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.NO_QUALIFICATION"
                          ],
                        errorMessage:
                          res[
                          "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_DO_NOT_HAVE_THE_REQUIRED_QUALIFICATIONS"
                          ],
                        nextPage: "/tabs/dashboard",
                      },
                      replaceUrl: true,
                    });
                  });
              }
            }
          );
      }
    }
  };

  /**
   * Get Checkin Details for Dedicated mode
   * @param userId temp auth user id
   * @param apiService ApiService class refrence
   * @param userPhoto userPhoto if captured and uploaded to CheckInPhotoUpload api
   * @param callBack call back to the block where it is called
   */
  public getCheckinDetailsForDedicatedMode = async (
    userId,
    apiService: ApiService,
    userPhoto = null,
    callBack = null
  ) => {
    if (userId && this.dedicatedModeLocationUse) {
      const onSuccess = (result) => {
        let canUserCheckinToLocation = true;
        if (
          this.dedicatedModeProcessType ===
          EnumService.DedicatedModeProcessTypes.CheckinOut &&
          this.checkinoutDmAs === EnumService.CheckInType.QrCode
        ) {
          const checkinDetail = result as CheckinDetail;
          if (
            checkinDetail &&
            !checkinDetail.checkInEntityDetail.checkInPersonalQR
          ) {
            canUserCheckinToLocation = false;
            UtilService.fireCallBack(callBack, {
              ischeckInPersonalQRNotAllowed: true,
            });
          }
        }

        if (canUserCheckinToLocation) {
          this.checkInDetail = result as CheckinDetail;
          this.checkInPostData = {
            userId,
            userPhoto,
            checkInLatitude: this.myCurrentGeoLocation?.coords?.latitude,
            checkInLongitude: this.myCurrentGeoLocation?.coords?.longitude,
            isGuestReturning: false,
            projectID: this.dedicatedModeLocationUse.projectID,
            inventoryItemID: this.dedicatedModeLocationUse.inventoryItemID,
            locationID: this.dedicatedModeLocationUse?.locationID,
            companyID: this.dedicatedModeDeviceDetailData?.companyID as any,
          } as CheckInPostData;

          this.processCheckinDetailsStepInitial(apiService, false);
        }
      };

      const entityId = this.utilService.getEntityIdFromId(
        this.dedicatedModeLocationUse
      );

      if (this.offlineMode) {
        this.offlineManagerService
          .getDeviceUserCheckinDetails(this.dedicatedModeLocationUse, userId)
          .then(async (response: any) => {
            onSuccess(response);
          })
          .catch((error) => {
            this.processCheckInError(error, "/dashboard-dm");
          });
      } else {
        this.utilService.presentLoadingWithOptions();
        apiService.getCheckInDetails(userId, entityId).subscribe(
          (response: Response) => {
            this.utilService.hideLoading();
            if (
              response.StatusCode ===
              EnumService.ApiResponseCode.RequestSuccessful
            ) {
              onSuccess(response.Result);
            }
          },
          (error: any) => {
            this.utilService.hideLoading();
            this.processCheckInError(error, "/dashboard-dm");
          }
        );
      }
    }
  };

  public getCheckinDetailsGuest = (
    apiService: ApiService,
    isGuestReturning = false
  ) => {
    const entityId = this.utilService.getEntityIdFromId(
      this.dedicatedModeLocationUse
    );
    const nextScreen = this.dedicatedMode ? "/dashboard-dm" : "/tabs/dashboard";

    const dedicatedModeDeviceDetailData = this.dedicatedModeDeviceDetailData;
    const dedicatedModeGuestDetail = this.dedicatedModeGuestDetail;
    const dedicatedModeLocationUse = this.dedicatedModeLocationUse;

    console.log('[GUEST-SCREEN] getCheckinDetailsGuest | offlineMode:', this.offlineMode, '| phone:', dedicatedModeGuestDetail?.guestPhone);

    const onSuccess = (data) => {
      console.log('[GUEST-SCREEN] onSuccess → proceeding to CHECK-IN screen | offlineMode:', this.offlineMode);
      this.checkInDetail = data;
      this.checkInPostData = {
        checkInLatitude: this.myCurrentGeoLocation?.coords?.latitude,
        checkInLongitude: this.myCurrentGeoLocation?.coords?.longitude,
        isGuestReturning,
        projectID: dedicatedModeLocationUse.projectID,
        inventoryItemID: dedicatedModeLocationUse.inventoryItemID,
        locationID: dedicatedModeLocationUse?.locationID,
        guestPhone: dedicatedModeGuestDetail?.guestPhone,
        guestFirsName: dedicatedModeGuestDetail?.guestFirsName,
        guestMiddleName: dedicatedModeGuestDetail?.guestMiddleName,
        guestLastName: dedicatedModeGuestDetail?.guestLastName,
        guestPhotoImageVideoFileId:
          dedicatedModeGuestDetail.guestPhotoImageVideoFileId,
        guestPhoto: dedicatedModeGuestDetail.guestPhoto,
        companyID: dedicatedModeDeviceDetailData?.companyID,
      } as unknown as CheckInPostData;

      this.processCheckinDetailsStepInitial(apiService, true);
    };

    if (this.offlineMode) {
      console.log('[GUEST-SCREEN] offline path → querying DeviceGuestUserCheckinDetails for phone:', dedicatedModeGuestDetail?.guestPhone);
      this.offlineManagerService
        .getDeviceUserCheckinDetails(
          this.dedicatedModeLocationUse,
          dedicatedModeGuestDetail.guestPhone,
          true
        )
        .then(async (response: any) => {
          console.log('[GUEST-SCREEN] offline DB resolved (guest NOT currently checked in here) → CHECK-IN screen');
          onSuccess(response);
        })
        .catch((error) => {
          const field = error?.error?.ResponseException?.ValidationErrors?.[0]?.Field;
          console.log('[GUEST-SCREEN] offline DB rejected | field:', field, '→ CHECKOUT/already-checked-in screen');
          this.processCheckInError(error, nextScreen);
        });
    } else {
      console.log('[GUEST-SCREEN] online path → calling getCheckInDetails_Guest API for phone:', dedicatedModeGuestDetail?.guestPhone);
      this.utilService.presentLoadingWithOptions();
      apiService
        .getCheckInDetails_Guest(
          dedicatedModeGuestDetail.guestPhone || "",
          dedicatedModeGuestDetail.guestFirsName || "",
          dedicatedModeGuestDetail.guestMiddleName || "",
          dedicatedModeGuestDetail.guestLastName || "",
          entityId
        )
        .subscribe(
          (res: Response) => {
            this.utilService.hideLoading();
            console.log('[GUEST-SCREEN] online API status:', res?.StatusCode, '→', res?.StatusCode === EnumService.ApiResponseCode.RequestSuccessful ? 'CHECK-IN screen' : 'no action');

            if (
              res.StatusCode === EnumService.ApiResponseCode.RequestSuccessful
            ) {
              onSuccess(res.Result);
            }
          },
          (error) => {
            this.utilService.hideLoading();
            const field = error?.error?.ResponseException?.ValidationErrors?.[0]?.Field;
            console.log('[GUEST-SCREEN] online API error | field:', field, '→ CHECKOUT/already-checked-in screen');
            this.processCheckInError(error, nextScreen);
          }
        );
    }
  };

  /**
   * Process checking for Dedicated mode
   * @param apiService ApiService Refrence
   * @param isGuest is CHeckin Type Guest User
   */
  processCheckinDetailsStepInitial = (apiService, isGuest) => {
    if (
      (this.checkinoutDmAs === EnumService.CheckInType.AS_GUEST &&
        this.checkInDetail?.checkInEntityDetail?.checkInGuestPhoto) ||
      ((this.checkinoutDmAs === EnumService.CheckInType.MY_NAME ||
        this.checkinoutDmAs === EnumService.CheckInType.QrCode) &&
        this.checkInDetail?.checkInEntityDetail?.checkInPersonalPhoto)
    ) {
      if (this.dedicatedModeCapturedSelfieForCheckinProcess) {
        if (this.checkinoutDmAs === EnumService.CheckInType.AS_GUEST) {
          if (this.offlineMode) {
            this.checkInPostData.guestPhotoImageVideoFileId =
              this.dedicatedModeCapturedSelfieForCheckinProcess;
          } else {
            this.checkInPostData.guestPhoto =
              this.dedicatedModeCapturedSelfieForCheckinProcess;
          }
        } else if (
          this.checkinoutDmAs === EnumService.CheckInType.MY_NAME ||
          this.checkinoutDmAs === EnumService.CheckInType.QrCode
        ) {
          if (this.offlineMode) {
            this.checkInPostData.userPhotoImageVideoFileId =
              this.dedicatedModeCapturedSelfieForCheckinProcess;
          } else {
            this.checkInPostData.userPhoto =
              this.dedicatedModeCapturedSelfieForCheckinProcess;
          }
        }
        this.processCheckinDetailsStepInduction(apiService, isGuest);
      } else {
        this.dedicatedModeCapturePhotoFor =
          EnumService.DedicatedModeCapturePhotoForType.LocationPhoto;
        this.navCtrl.navigateForward(["/checkinout-photoidentity-dm"]);
      }
    } else {
      this.processCheckinDetailsStepInduction(apiService, isGuest);
    }
  };

  processCheckinDetailsStepInduction = (apiService, isGuest) => {
    if (
      this.checkInDetail?.checkInEntityDetail?.processInduction &&
      this.checkInDetail?.checkInInductionItems?.length > 0
    ) {
      this.navCtrl.navigateForward(["checkin-induction"]);
    } else {
      this.processCheckinDetailsStepSubmit(apiService, isGuest);
    }
  };

  processCheckinDetailsStepSubmit = (apiService, isGuest) => {
    if (isGuest) {
      this.submitInductionCheckInDataGuest(apiService);
    } else {
      this.submitInductionCheckInData(apiService);
    }
  };

  uploadVideo = (selectedVideo, mimeType,filename, callBack, progress) => {
    const accessID = this.deviceUID;
    const token = localStorage.getItem(EnumService.LocalStorageKeys.API_TOKEN);

    const url =
      this.apiBaseUrl + "/" + EnumService.ApiMethods.FormPhotoOrVideoUploadFromDevice;
    const options: FileUploadOptions = {
      fileName: filename,
      fileKey: "file",
      mimeType,
      headers: {
        accessID,
        token,
      },
    };
    this.videoFileUpload = this.fileTransfer.create();
    console.log("starting upload")
    this.videoFileUpload
      .upload(selectedVideo, url, options)
      .then((data) => {
        UtilService.fireCallBack(progress, 0);
        return JSON.parse(data.response);
      })
      .then((data) => {
        UtilService.fireCallBack(progress, 10);
        UtilService.fireCallBack(callBack, {
          status: true,
          result: data,
        });
      })
      .catch((err) => {
        UtilService.fireCallBack(progress, 0);
        UtilService.fireCallBack(callBack, {
          status: false,
          result: err,
        });
      });
    this.videoFileUpload.onProgress((data) => {
      const uploadPercent = Math.round((data.loaded / data.total) * 100);
      //console.log("progress on " ,selectedVideo,  " : ", uploadPercent )
      this.uploadProgress = progress
      UtilService.fireCallBack(progress, uploadPercent);
    });
  };

  private getUserSavedSates(formId, callBack) {
    const userId = this.dedicatedMode
      ? this.dedicatedModeUserDetail?.userId
      : this.getLoggedInUser()?.userId;

    let uniqueKey = ""; // entityKey or activityId

    if (this.viewFormFor === EnumService.ViewFormForType.Activity) {
      uniqueKey = this.saveSateId;
    } else {
      if (this.dedicatedMode) {
        if (this.dedicatedModeLocationUse?.inventoryItemID) {
          uniqueKey =
            "inventoryItem_" + this.dedicatedModeLocationUse.inventoryItemID;
        } else if (this.dedicatedModeLocationUse?.locationID) {
          uniqueKey = "locationID_" + this.dedicatedModeLocationUse?.locationID;
        } else if (this.dedicatedModeLocationUse?.projectID) {
          uniqueKey = "projectID_" + this.dedicatedModeLocationUse?.projectID;
        }
      } else {
        if (this.currentSelectedCheckinPlace?.inventoryItemID) {
          uniqueKey =
            "inventoryItem_" + this.currentSelectedCheckinPlace.inventoryItemID;
        } else if (this.currentSelectedCheckinPlace?.locationID) {
          uniqueKey =
            "locationID_" + this.currentSelectedCheckinPlace?.locationID;
        } else if (this.currentSelectedCheckinPlace?.projectID) {
          uniqueKey = "projectID_" + this.currentSelectedCheckinPlace?.projectID;
        }
      }
     
    }

    uniqueKey = uniqueKey + "_" + formId;
    //console.log("fetch unique key: ", uniqueKey)

    this.indexDbStorage
      .get(userId)
      .then((res: any) => {
        if (res) {
          callBack(userId, uniqueKey, res);
        } else {
          callBack(userId, uniqueKey, {});
        }
      })
      .catch(() => {
        callBack(userId, uniqueKey, {});
      });
  }
  /**
   *
   * @param index
   */
  public async removeSavedFormStateForActivity(activityId, callBack) {
    const userId = this.dedicatedMode
      ? this.dedicatedModeUserDetail?.userId
      : this.getLoggedInUser()?.userId;

    this.indexDbStorage
      .get(userId)
      .then((res: any) => {
        if (res) {
          delete res[activityId];
          this.indexDbStorage.set(userId, res);
        }
        callBack();
      })
      .catch(() => {
        callBack();
      });
  }

  /**
   *
   * @param index
   */
  public async removeSavedFormState(formID, index: number, callBack) {
    this.getUserSavedSates(formID, (userId, uniqueKey, res) => {
      let savedForms = [];
      if (res[uniqueKey]) {
        savedForms = res[uniqueKey];
      }

      if (index >= 0) {
        savedForms.splice(index, 1);
      }

      res[uniqueKey] = savedForms;

      this.indexDbStorage.set(userId, res);

      callBack(savedForms);
    });
  }

  public async removeAllSavedFormState(callBack) {
    this.indexDbStorage
      .clear()
      .then((res: any) => {
        if (res) {
          callBack();
        }
      })
      .catch(() => { });
  }
  /**
   * Save Uncompleted form state to indexDb for mobile and webapp
   * @param formGroup
   * @param formBuilderDetail
   * @param personalModeLoggedUser
   * @param originalCallBack
   * @param havAnswerDetail
   * @param workPermitAnswer
   */
  public async saveFormState(
    formType,
    formGroup: UntypedFormGroup,
    formBuilderDetail,
    personalModeLoggedUser: User,
    originalCallBack,
    havAnswerDetail: HavAnswerDetail = null,
    workPermitAnswer: WorkPermitAnswer = null,
    scoreData ={},
    activities = []
  ) {
    const savedStateIndex = this.savedFormStateIndex;
    
    const saveToIndexDb = (formAnswerData) => {
      this.getUserSavedSates(
        formBuilderDetail.formId,
        (userId, uniqueKey, res) => {
          let savedForms = [];
          if (res[uniqueKey]) {
            savedForms = res[uniqueKey];
          }
          if (savedStateIndex >= 0) {
            console.log("test activities ------ ", savedForms[savedStateIndex].activities);
            savedForms[savedStateIndex].lastSave = moment().toISOString();
            savedForms[savedStateIndex].formBuilderDetail = formBuilderDetail;
            savedForms[savedStateIndex].formAnswerData = formAnswerData;
            savedForms[savedStateIndex].scoreData = scoreData;
            savedForms[savedStateIndex].activities = activities;
          } else {
            savedForms.push({
              formType,
              formAnswerData,
              formBuilderDetail,
              lastSave: moment().toISOString(),
              startSave: moment().toISOString(),
              scoreData: scoreData,
              activities: activities
            });
          }

          res[uniqueKey] = savedForms;

          this.indexDbStorage.set(userId, res);

          if (
            !this.dedicatedMode &&
            this.viewFormFor === EnumService.ViewFormForType.Activity
          ) {
            this.utilService.presentLoadingWithOptions();
            this.apiServiceRerence
              .activityInProgress(userId, this.viewFormForActivityId)
              .subscribe(
                (res) => {
                  this.utilService.hideLoading();
                  originalCallBack && originalCallBack(true);
                },
                (error) => {
                  this.utilService.hideLoading();
                }
              );
          } else {
            originalCallBack && originalCallBack(true);
          }
        }
      );
    };
    this.saveSavedStateFormAnswers(
      this.apiServiceRerence,
      formGroup,
      formBuilderDetail,
      personalModeLoggedUser,
      (formAnswerData) => {
        saveToIndexDb(formAnswerData);
      },
      havAnswerDetail,
      workPermitAnswer,
      scoreData,
    );
  }

  public async saveSavedStateFormAnswers(
    apiService: ApiService,
    formGroup: UntypedFormGroup,
    formBuilderDetail,
    personalModeLoggedUser: User,
    originalCallBack,
    havAnswerDetail: HavAnswerDetail = null,
    workPermitAnswer: WorkPermitAnswer = null,
    scoreData = null
  ) {
    if (!environment.isFormPreview) {
      // Prevent app sleep while submiting form
      this.insomnia.keepAwake().then(
        () => console.log("keepAwake success"),
        (error) => console.log("keepAwake error", error)
      );

      const callBack = (param1) => {
        originalCallBack(param1);

        // allow app sleep after for submiting form success or fail

        this.insomnia.allowSleepAgain().then(
          () => console.log("success"),
          (error) => console.log(" allowSleepAgain error", error)
        );
      };

      const sections = formBuilderDetail.sections;

      let attachmentCount = 0;
      let attachmentUploadedCount = 0;
      let innerAttachmentCountuploaded = 0;
      let innerAttachmentCount = 0;
      const attachemtUploaded = {};

      const onUploaded = () => {
        attachmentUploadedCount++;
        if (attachmentCount === attachmentUploadedCount) {
          this.utilService.hideLoading();
          this.submitSavedFormStateAnswers(
            apiService,
            formGroup,
            formBuilderDetail,
            personalModeLoggedUser,
            callBack,
            havAnswerDetail,
            workPermitAnswer,
            attachemtUploaded,
            scoreData
          );
        }
      };

      const innerUpload = () => {
        innerAttachmentCountuploaded++;
        if (innerAttachmentCount === innerAttachmentCountuploaded) {
          onUploaded()
        }
      };
      function countValidPhotoVideoUploadQuestions(questions, formGroup, section) {
        return questions.filter(question => {
            const controlName = UtilService.FCUniqueName(section, question);
            const control = formGroup.controls[controlName];
            return question.selectedAnswerTypeId === EnumService.CustomAnswerType.PhotoVideoUpload && control && control.value;
        }).length;
    }
        const totalAttachmentCount = sections.reduce((totalCount, section) => {
        return totalCount + countValidPhotoVideoUploadQuestions(section.questions, formGroup, section);
    }, 0);

    for (const section of sections) {
      if (this.utilService.shouldShowSection(section)) {
          const questions = section.questions;
          attachmentCount = totalAttachmentCount;
  
          for (const question of questions) {
              if (this.utilService.shouldShowQuestion(question)) {
                  const controlName = UtilService.FCUniqueName(section, question);
                  const control = formGroup.controls[controlName];
  
                  if (question.selectedAnswerTypeId === EnumService.CustomAnswerType.PhotoVideoUpload) {
                      if (control && control.value) {
                          innerAttachmentCountuploaded = 0;
                          let attachementsArray = [];
                          innerAttachmentCount = control.value.length;
  
                          for (let i = 0; i < control.value.length; i++) {
                              if (control.value[i].file) {
                                  control.value[i].attachement = control.value[i].file;
                              }
                              if (control.value[i].fileName) {
                                  control.value[i].name = control.value[i].fileName;
                              }
  
                              const controlValue = control.value[i].attachement;
                              const controlValueObject = control.value[i];
  
                              let fileName = "photo" + this.utilService.getCurrentTimeStamp() + ".jpeg";
                              let mimeType = "image/jpeg";
                              let isVideo = false;
                              let extension = "jpeg";
  
                              if (controlValue?.type) {
                                  extension = controlValue.name.split('.').pop() || '';
                                  isVideo = false;
                                  fileName = "document" + this.utilService.getCurrentTimeStamp() + "." + extension;
                                  mimeType = extension;
                              } else if (UtilService.IsBase64Sring(controlValue)) {
                                  try {
                                      extension = controlValue.match(/[^:/]\w+(?=;|,)/)[0];
                                      if (StaticDataService.videoFormats.indexOf(extension.toLowerCase()) !== -1) {
                                          isVideo = true;
                                          fileName = "video" + this.utilService.getCurrentTimeStamp() + "." + extension;
                                          mimeType = controlValue.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
                                      }
                                  } catch (error) { }
                              } else {
                                  extension = controlValue?.split(".").pop().toLowerCase();
                                  if (StaticDataService.videoFormats.indexOf(extension) !== -1) {
                                      isVideo = true;
                                      fileName = controlValueObject?.name ? controlValueObject?.name : controlValue.split('/').pop();
                                      mimeType = StaticDataService.fileMimeTypes[extension];
                                  }
                              }
  
  
                              let filePathOrBinaryData = controlValueObject;
                              if (UtilService.isWebApp() || UtilService.isLocalHost()) {
                                  attachementsArray.push(filePathOrBinaryData);
                                  attachemtUploaded[controlName] = attachementsArray;
                                  innerUpload();
                              } else {
                                  try {
                                      const res = await this.filehandlerService.saveFileOnDevicePath(
                                          filePathOrBinaryData,
                                          StaticDataService.formStateFileFolderName
                                      );
                                      attachementsArray.push({
                                          file: res,
                                          attachement: res,
                                          mimeType,
                                          fileName,
                                          isVideo,
                                          questionId: question.questionId,
                                          controlName,
                                      });
                                    attachemtUploaded[controlName] = attachementsArray;
                                      innerUpload()
                                  } catch (error) {
                                      attachementsArray.push(filePathOrBinaryData);
                                    attachemtUploaded[controlName] = attachementsArray;
                                    innerUpload();


                                  }
                              }
                          }
                          // onUploaded();
                      }
                  }
              }
          }
      }
  }
  

      if (attachmentCount === 0) {
        this.submitSavedFormStateAnswers(
          apiService,
          formGroup,
          formBuilderDetail,
          personalModeLoggedUser,
          callBack,
          havAnswerDetail,
          workPermitAnswer,
          null,
          scoreData
        );
      }
    }
  }

  removeCapacitorPrefixAndroid(url) {
        const prefix1 = 'http://localhost/_capacitor_file_';
        const prefix2 = 'https://localhost/_capacitor_file_';
        const prefix3 = 'file://https://localhost/_capacitor_file_';
      if (url.startsWith(prefix1)) {
        url = url.substring(prefix1.length);   
      } else  if (url.startsWith(prefix2)) {
        url = url.substring(prefix2.length);   
      }
      else  if (url.startsWith(prefix3)) {
        url = url.substring(prefix3.length);   
      }
      //console.log("url after prefix removed: ", url)
      return url;
    }

  private submitSavedFormStateAnswers = (
    apiService: ApiService,
    formGroup: UntypedFormGroup,
    formBuilderDetail,
    personalModeLoggedUser: User,
    callBack,
    havAnswerDetail: HavAnswerDetail = null,
    workPermitAnswer: WorkPermitAnswer = null,
    attachemtUploaded = {},
    scoreData = null
  ) => {
    const sections = formBuilderDetail.sections;
    const workPermitDetails = formBuilderDetail.workPermitDetails;
    const accidentReport = formBuilderDetail.accidentReport;
    const formVersionId = formBuilderDetail.formVersionId;

    const questionAnswers = [];
    const accidentReportQuestionAnswers = [];
    const riskAssessmentAnswers = [];
    const riskAssessmentAnswerDetails = { taskAnswers: [] };
    const ioshAssessmentAnswerDetails = { hazardAnswers: []};

    const selectedLanguageID = this.getLanguageIdForForm();

    const formattedSections = [];

    const userId = this.dedicatedMode
      ? this.dedicatedModeUserDetail?.userId
      : personalModeLoggedUser?.userId;
    const companyId = this.dedicatedMode
      ? this.dedicatedModeDeviceDetailData?.companyID
      : personalModeLoggedUser?.companyID;

    let savedStatesAnswerByFormControlName = {};
    sections.map((section, sectionIndex) => {
      if (this.utilService.shouldShowSection(section)) {
        const formattedAnswers = [];
        const sectionFormattedObject: any = JSON.parse(JSON.stringify(section));

        if (section.isRiskAssessmentSection) {
          const tasks = section.riskAssessmentAnswerDetails?.taskAnswers;
          riskAssessmentAnswerDetails.taskAnswers = tasks;
          tasks.map((task) => {
            if (this.utilService.shouldShowQuestion(task)) {
              const answerFormattedObject: any = JSON.parse(
                JSON.stringify(task)
              );
              const hazardsAnswers = task.hazardAnswers;

              answerFormattedObject.answerData = hazardsAnswers;
              formattedAnswers.push(answerFormattedObject);
            }
          });

          sectionFormattedObject.taskAnswerData = formattedAnswers;
        } else if (section.isIOSHRiskAssessmentSection){
          const hazards = section.ioshRiskAssessmentAnswerDetails?.hazardAnswers;
          ioshAssessmentAnswerDetails.hazardAnswers = hazards;
          hazards.map((issue) => {
            if (this.utilService.shouldShowQuestion(issue)) {
              const answerFormattedObject: any = JSON.parse(
                JSON.stringify(issue)
              );
              answerFormattedObject.answerData = issue;
              formattedAnswers.push(answerFormattedObject);
            }
          }); 
        }else if (section.isHAVSection) {
          const havAssessmentTools = section.havAssessmentTools;
          havAssessmentTools.some((havAssessmentTool) => {
            const questions = havAssessmentTool.questions;

            questions.some((question, questionIndex) => {
              const questionDisplayOrder = questionIndex + 1;
              const questionLabel = UtilService.findObj(
                question.questionTranslations,
                "questionTranslationLanguageId",
                selectedLanguageID
              ).questionTranslationTitle;
              const answerFormattedObject: any = JSON.parse(
                JSON.stringify(question)
              );

              const havQuestionAnswerObject: HavAnswerObject = {
                hAVQuestionAnswerId: 0,
                questionID: question.questionId,
                questionTitle: questionLabel,
                formVersionID: formVersionId,
                answerTypeID: question.selectedAnswerTypeId,
                hAVSequence: question.questionDisplayOrder,
                [EnumService.QuestionLogic.ActionTypeForForm.MarkAsFailed]:
                  question[
                  EnumService.QuestionLogic.ActionTypeForForm.MarkAsFailed
                  ],
                [EnumService.QuestionLogic.ActionTypeForForm.Notify]:
                  question[EnumService.QuestionLogic.ActionTypeForForm.Notify],
                [EnumService.QuestionLogic.ActionTypeForForm.CreateNewActivity]:
                  question[
                  EnumService.QuestionLogic.ActionTypeForForm
                    .CreateNewActivity
                  ],
              };

              let isValueFilled = false;
              switch (questionDisplayOrder) {
                case EnumService.HavFormFieldOrder.DateOfUsage:
                  if (question.value) {
                    havQuestionAnswerObject.dateOfUsage = moment(
                      question.value
                    ).format(StaticDataService.dateFormat);
                    isValueFilled = true;
                  }
                  break;
                case EnumService.HavFormFieldOrder.Manufacturer:
                  if (question.value) {
                    havQuestionAnswerObject.hAVManufacturerID = question.value;
                    isValueFilled = true;
                  }
                  break;
                case EnumService.HavFormFieldOrder.Type:
                  if (question.value) {
                    havQuestionAnswerObject.hAVTypeID = question.value;
                    isValueFilled = true;
                  }
                  break;
                case EnumService.HavFormFieldOrder.Model:
                  if (question.value) {
                    havQuestionAnswerObject.hAVModelID = question.value;
                    havQuestionAnswerObject.inventoryItemID =
                      question.inventoryItemID;
                    isValueFilled = true;
                  }
                  break;
                case EnumService.HavFormFieldOrder.PlannedTimeOfUsage:
                  if (question.value) {
                    isValueFilled = true;
                    havQuestionAnswerObject.plannedTimeOfUse = Number(
                      question.value
                    );
                  }
                  break;
              }

              if (isValueFilled) {
                answerFormattedObject.havAnswerData = havQuestionAnswerObject;
                formattedAnswers.push(answerFormattedObject);
              }
            });
          });

          sectionFormattedObject.answerData = formattedAnswers;
        } else {
          const questions = section.questions;

          questions.map((question, questionIndex) => {
            const questionDisplayOrder = questionIndex + 1;
            if (this.utilService.shouldShowQuestion(question)) {
              const answerFormattedObject: any = JSON.parse(
                JSON.stringify(question)
              );
              const controlName = UtilService.FCUniqueName(section, question);
              const control = formGroup.controls[controlName];
              let isValueFilled = false;

              if (control) {
                const questionLabel = UtilService.findObj(
                  question.questionTranslations,
                  "questionTranslationLanguageId",
                  selectedLanguageID
                ).questionTranslationTitle;

                if (section.isAccidentReportSection) {
                  const answerObject: ArAnswerObject = {
                    accidentReportQuestionAnswerId: 0,
                    questionID: question.questionId,
                    questionTitle: questionLabel,
                    formVersionID: formVersionId,
                    answerTypeID: question.selectedAnswerTypeId,
                    accidentAnswerSequence: question.questionDisplayOrder,
                    [EnumService.QuestionLogic.ActionTypeForForm.MarkAsFailed]:
                      question[
                      EnumService.QuestionLogic.ActionTypeForForm.MarkAsFailed
                      ],
                    [EnumService.QuestionLogic.ActionTypeForForm.Notify]:
                      question[
                      EnumService.QuestionLogic.ActionTypeForForm.Notify
                      ],
                    [EnumService.QuestionLogic.ActionTypeForForm
                      .CreateNewActivity]:
                      question[
                      EnumService.QuestionLogic.ActionTypeForForm
                        .CreateNewActivity
                      ],
                  };

                  switch (questionDisplayOrder) {
                    case EnumService.AccidentFormFieldOrder.AccidentDateTime:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.accidentDateTime = moment(
                          control.value
                        ).format(StaticDataService.dateTimeFormat);
                      }

                      savedStatesAnswerByFormControlName[controlName] =
                        control.value;
                      break;
                    case EnumService.AccidentFormFieldOrder.AccidentLocation:
                      const placeNotintheList =
                        formGroup.controls.placeNotintheList;
                      const locationName = formGroup.controls.locationName;

                      if (placeNotintheList.value) {
                        isValueFilled = true;
                        answerObject.accidentLocationName = locationName.value;

                        savedStatesAnswerByFormControlName[
                          EnumService.AccidentCustomLocationControlsName.PlaceNotintheList
                        ] = placeNotintheList.value;
                        savedStatesAnswerByFormControlName[
                          EnumService.AccidentCustomLocationControlsName.LocationName
                        ] = locationName.value;
                      } else if (control.value) {
                        isValueFilled = true;
                        const entityIds = this.utilService.getRelevantEntityId(
                          control.value
                        );
                        answerObject.accidentInventoryID =
                          entityIds.InventoryID;
                        answerObject.accidentProjectID = entityIds.ProjectID;
                        answerObject.accidentLocationID = entityIds?.LocationID;

                        savedStatesAnswerByFormControlName[controlName] =
                          control.value;
                      }
                      break;

                    case EnumService.AccidentFormFieldOrder.About:
                      const formGroups = control.value as UntypedFormGroup;
                      const multipleChoiceValueIDs = [];
                      const multipleChoiceValueAnswer = {};
                      question.answerChoiceAttributes.map((choice) => {
                        const subControlName = UtilService.SubFCName(
                          controlName,
                          choice.answerChoiceAttributeId
                        );
                        const choiceControl = formGroups[subControlName];
                        if (choiceControl) {
                          multipleChoiceValueIDs.push(
                            choice.answerChoiceAttributeId
                          );
                          multipleChoiceValueAnswer[subControlName] = true;
                        }
                      });
                      if (multipleChoiceValueIDs.length > 0) {
                        try{
                        isValueFilled = true;
                        answerObject.accidentAboutIDs =
                          multipleChoiceValueIDs.join(",");
                          }catch{}
                      }

                      savedStatesAnswerByFormControlName[controlName] =
                        multipleChoiceValueAnswer;
                      break;
                    case EnumService.AccidentFormFieldOrder.Type:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.accidentTypeID = control.value;
                        savedStatesAnswerByFormControlName[controlName] =
                          control.value;
                      }
                      break;
                    case EnumService.AccidentFormFieldOrder.Classification:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.accidentClassificationID = control.value;
                        savedStatesAnswerByFormControlName[controlName] =
                          control.value;
                      }
                      break;

                    case EnumService.AccidentFormFieldOrder.BodyPartEffected:
                      const bodyPartFormGroups = control.value as UntypedFormGroup;
                      const bodyPartsIDs = [];
                      const injuriesReported =
                        formGroup.controls.injuriesReported;

                      savedStatesAnswerByFormControlName[
                        EnumService.AccidentCustomLocationControlsName.InjuriesReported
                      ] = injuriesReported.value;

                      if (injuriesReported.value === "yes") {
                        const selectedBodyPartsValue = {};
                        StaticDataService.bodyParts.map((partGroup) => {
                          partGroup.parts.map((part) => {
                            const subControlName = UtilService.SubFCName(
                              controlName,
                              part.id
                            );

                            const choiceControl =
                              bodyPartFormGroups[subControlName];
                            if (choiceControl) {
                              bodyPartsIDs.push(part.id);

                              selectedBodyPartsValue[subControlName] = true;
                            }
                          });
                        });
                        if (bodyPartsIDs.length > 0) {
                          isValueFilled = true;
                          answerObject.accidentBodyPartIDs =
                            bodyPartsIDs.join(",");
                          savedStatesAnswerByFormControlName[controlName] =
                            selectedBodyPartsValue;
                        }
                      } else {
                        isValueFilled = true;
                        answerObject.accidentBodyPartIDs = "36";

                        savedStatesAnswerByFormControlName[controlName] = {};
                      }

                      break;
                    case EnumService.AccidentFormFieldOrder.Description:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.accidentDescription = control.value;
                        savedStatesAnswerByFormControlName[controlName] =
                          control.value;
                      }
                      break;
                    case EnumService.AccidentFormFieldOrder.Attachment:
                      try{
                        if (attachemtUploaded[controlName]) {
                          isValueFilled = true;

                          if (this.offlineMode) {
                            answerObject.accidentAttachmentFileId =
                              attachemtUploaded[controlName];
                          } else {
                            answerObject.accidentAttachmentFileName =
                              attachemtUploaded[controlName];
                          }

                          savedStatesAnswerByFormControlName[controlName] =
                            attachemtUploaded[controlName];
                        
                        }
                      } catch{}
                      break;
                  }

                  if (isValueFilled) {
                    accidentReportQuestionAnswers.push(answerObject);
                    answerFormattedObject.arAnswerData = answerObject;
                  }
                } else {
                  switch (question.selectedAnswerTypeId) {
                    case EnumService.CustomAnswerType.ClassicDropdown:

                    case EnumService.CustomAnswerType.SingleLineText:
                    case EnumService.CustomAnswerType.MultiLineText:
                    case EnumService.CustomAnswerType.SingleChoiceSet:
                    case EnumService.CustomAnswerType.ConfirmationBox:
                    case EnumService.CustomAnswerType.ScanQrCodeField:
                    case EnumService.CustomAnswerType.NumberFieldInteger:
                    case EnumService.CustomAnswerType.NumberFieldDecimal:
                    case EnumService.CustomAnswerType.DateField:
                    case EnumService.CustomAnswerType.TimeField:
                    case EnumService.CustomAnswerType.DateTimeField:
                      savedStatesAnswerByFormControlName[controlName] =
                        control.value;
                      break;

                    case EnumService.CustomAnswerType.MultipleChoiceSet:
                      const formGroups = control.value as UntypedFormGroup;
                      const subValues = {};
                      question.answerChoiceAttributes.map((choice) => {
                        const choiceControl =
                          formGroups[
                          UtilService.SubFCName(
                            controlName,
                            choice.answerChoiceAttributeId
                          )
                          ];

                        subValues[
                          UtilService.SubFCName(
                            controlName,
                            choice.answerChoiceAttributeId
                          )
                        ] = choiceControl ? true : false;
                      });

                      savedStatesAnswerByFormControlName[controlName] =
                        subValues;
                      break;

                    case EnumService.CustomAnswerType.Matrix3DField:
                      savedStatesAnswerByFormControlName[controlName] =
                        control.value;

                      break;

                    case EnumService.CustomAnswerType.InformSignature:
                      savedStatesAnswerByFormControlName[controlName] =
                        control.value;

                      break;

                    case EnumService.CustomAnswerType.BodyMapCustomQuestion:
                      const bodyMapGroup = formGroup.controls[controlName] as UntypedFormGroup;
  
                      const bodyMapSubValues = {};
                      if (bodyMapGroup && bodyMapGroup.controls) {
                        StaticDataService.bodyParts.map((partGroup) => {
                          partGroup.parts.map((part: any) => {
                            const subControlName = UtilService.SubFCName(controlName, part.id);
                            const subControl = bodyMapGroup.controls[subControlName];
                            
                            if (subControl && subControl.value === true) {
                              bodyMapSubValues[subControlName] = true;
                            }
                          });
                        });
                      }

                      savedStatesAnswerByFormControlName[controlName] = bodyMapSubValues;
                      break;

                    case EnumService.CustomAnswerType.PhotoVideoUpload:
                      try{
                      if (attachemtUploaded[controlName]) {
                        savedStatesAnswerByFormControlName[controlName] =
                          attachemtUploaded[controlName];
                      }
                    } catch(error){console.log("(ignore if blank)failed to save photo with error: ",error)}
                      break;
                  }

                  // if additional comment
                  if (question.shouldShowOptionalComment) {
                    const additionalControl =
                      formGroup.controls[
                      UtilService.FCNameAdditioanlNoteUq(controlName)
                      ];
                    if (additionalControl.value) {
                      savedStatesAnswerByFormControlName[
                        UtilService.FCNameAdditioanlNoteUq(controlName)
                      ] = additionalControl.value;
                    }
                  }
                  if (question.shouldShowOptionalAction) {
                    const additionalControl =
                      formGroup.controls[
                      UtilService.FCNameActionUq(controlName)
                      ];
                    if (additionalControl.value) {
                      savedStatesAnswerByFormControlName[
                        UtilService.FCNameActionUq(controlName)
                      ] = additionalControl.value;
                    }
                  }
                }
              }
            }
          });
        }
      }
    });

    callBack(savedStatesAnswerByFormControlName);
  };
  /**
   * getSavedFormStates
   */
  public getSavedFormStates(formId, callBack) {
    this.getUserSavedSates(formId, (userId, uniqueKey, res) => {
      let savedForms = [];
      if (res[uniqueKey]) {
        savedForms = res[uniqueKey];
      }
      callBack(savedForms);
    });
  }

  public async saveFormAnswers({
    apiService,
    formGroup,
    formBuilderDetail,
    personalModeLoggedUser,
    originalCallBack,
    havAnswerDetail = null,
    workPermitAnswer = null,
    isGenerateTestJsonFile = false,
  }: {
    apiService: ApiService;
    formGroup: UntypedFormGroup;
    formBuilderDetail: any;
    personalModeLoggedUser: User;
    originalCallBack: any;
    havAnswerDetail?: HavAnswerDetail;
    workPermitAnswer?: WorkPermitAnswer;
    isGenerateTestJsonFile?: boolean;
  }) {
    if (!environment.isFormPreview) {
      // Prevent app sleep while submiting form
      this.insomnia.keepAwake().then(
        () => console.log("keepAwake success"),
        (error) => console.log("keepAwake error", error)
      );

      if(this.entityOwnerInfos === undefined && !this.offlineMode){
        this.getEntityOwnerId()
      }

      const callBack = (param1, param2) => {
        originalCallBack(param1, param2);

        // allow app sleep after for submiting form success or fail

        this.insomnia.allowSleepAgain().then(
          () => console.log("success"),
          (error) => console.log(" allowSleepAgain error", error)
        );
      };

      const sections = formBuilderDetail.sections;

      let requiredFieldsCount = 0;
      let requiredFieldsValidCount = 0;
      let integerFieldInvalidCount = 0;

      let filledFieldsCount = 0;
      let filledFieldsValidCount = 0;
      this.loading = true;

      if (sections) {
        sections.map((section, sectionIndex) => {
          if (this.utilService.shouldShowSection(section)) {
            if (section.isRiskAssessmentSection) {
              const tasks = section.riskAssessmentAnswerDetails?.taskAnswers;
              tasks.map((task) => {
                if (task.isRequired) {
                  requiredFieldsCount++;
                  const hazards = task.hazardAnswers;
                  let isValid = true; 
                  if (!task.taskAnswerTitle) {
                    isValid = false;
                  }
                  hazards.map((hazard) => {
                    if (!hazard.hazardAnswerTitle) {
                      isValid = false;
                    }
                    if (!hazard.riskRatingSeverityID ||!hazard.riskRatingProbabilityID) { /*check caps*/
                      isValid = false;
                    }
                    if (!hazard.residualRiskRatingSeverityID || !hazard.residualRiskRatingProbabilityID) { /*check caps*/
                      isValid = false;
                    }

                    if (hazard.isMembersOfTheWorkForce) {
                      if (
                        !hazard.isMembersOfTheWorkForceUserIDs &&
                        !hazard.isMembersOfTheWorkForceUserGroupIDs
                      ) {
                        isValid = false;
                      }
                      if (hazard.hasPersonnelExposedNotification) {
                        if (
                          !hazard.personnelExposedNotificationUserIDs &&
                          !hazard.personnelExposedNotificationUserGroupIDs
                        ) {
                          isValid = false;
                        }
                      }
                    }

                    if (hazard.isMembersOfThePublic) {
                      if (!hazard.membersOfThePublicDescription) {
                        isValid = false;
                      }
                    }

                    const controlMeasures = hazard.controlMeasureAnswers;
                    if (controlMeasures && controlMeasures.length > 0) {
                      controlMeasures.map((controlMeasure) => {
                        if (!controlMeasure.controlMeasureAnswerTitle) {
                          isValid = false;
                        }
                      });
                    } else {
                      isValid = false;
                    }
                  });
                  if (isValid) {
                    requiredFieldsValidCount++;
                    filledFieldsCount++;
                  }
                }
              });
            } else if(section.isIOSHRiskAssessmentSection){
                if (this.utilService.shouldShowSection(section)) {
                  const hazards = section.ioshRiskAssessmentAnswerDetails?.hazardAnswers; 
                  hazards.map((hazard) => { 
                    requiredFieldsCount++;
                    let isValid = true;
                    if (!hazard.IOSHHazardAnswerTitle) {
                      isValid = false;
                    }
                    if (
                      !hazard.RiskRatingSeverityID ||
                      !hazard.RiskRatingProbabilityID
                    ) {
                      isValid = false;
                    }
                    const controlMeasures = hazard.existingControls;
                    if (controlMeasures && controlMeasures.length > 0) {
                      controlMeasures.map((controlMeasure) => {
                        if (!controlMeasure.controlMeasureAnswerTitle) {
                          isValid = false;
                        }
                      });
                    } else {
                      isValid = false;
                    }
                    if (isValid) {
                      requiredFieldsValidCount++;
                      filledFieldsCount++;
                    }
                  })
                }

            } else if (section.isHAVSection) {
              requiredFieldsCount++;
              filledFieldsCount++;
              requiredFieldsValidCount++;
              //skip
            } else {
              const questions = section.questions;
              questions.map((question, questionIndex) => {
                if (this.utilService.shouldShowQuestion(question)) {
                  const controlName = UtilService.FCUniqueName(
                    section,
                    question
                  );
                  const control = formGroup.controls[controlName];
                  if (question.questionIsRequired) {
                    requiredFieldsCount++;
                  }

                  if (
                    question.selectedAnswerTypeId ===
                    EnumService.CustomAnswerType.MultipleChoiceSet
                  ) {
                    const formGroups = control.value as UntypedFormGroup;
                    const multipleChoiceValueIDs = [];
                    question.answerChoiceAttributes.map((choice) => {
                      const choiceControl =
                        formGroups[
                        UtilService.SubFCName(
                          controlName,
                          choice.answerChoiceAttributeId
                        )
                        ];
                      if (choiceControl) {
                        multipleChoiceValueIDs.push(
                          choice.answerChoiceAttributeId
                        );
                      }
                    });
                    if (multipleChoiceValueIDs.length > 0) {
                      filledFieldsCount++;
                      filledFieldsValidCount++;
                      if (question.questionIsRequired) {
                        requiredFieldsValidCount++;
                      }
                    }
                  }else if (
                    question.selectedAnswerTypeId ===
                    EnumService.CustomAnswerType.BodyMapCustomQuestion
                  ) {
                    const bodyMapFormGroup = control.value as UntypedFormGroup;
                    let hasSelectedBodyPart = false;

                    if (bodyMapFormGroup) {
                      StaticDataService.bodyParts.some((partGroup) => {
                        return partGroup.parts.some((part: any) => {
                          const subControlName = UtilService.SubFCName(
                            controlName,
                            part.id
                          );
                          if (bodyMapFormGroup[subControlName] === true) {
                            hasSelectedBodyPart = true;
                            return true;
                          }
                          return false;
                        });
                      });
                    }

                    if (hasSelectedBodyPart) {
                      filledFieldsCount++;
                      filledFieldsValidCount++;
                      if (question.questionIsRequired) {
                        requiredFieldsValidCount++;
                      }
                    }
                  } else {
                    if (control.value) {
                      filledFieldsCount++;
                      if (control.valid) {
                        filledFieldsValidCount++;
                        if (question.questionIsRequired) {
                          requiredFieldsValidCount++;
                        }
                      } else {
                        // Check if filled is invalid for integer type field
                        if (
                          question.selectedAnswerTypeId ===
                          EnumService.CustomAnswerType.NumberFieldInteger
                        ) {
                          integerFieldInvalidCount++;
                        }
                      }
                    } else if (
                      section.isAccidentReportSection &&
                      question.selectedAnswerTypeId ===
                      EnumService.CustomAnswerType.LocationSelection
                    ) {
                      const locationNameControl =
                        formGroup.controls[
                        EnumService.AccidentCustomLocationControlsName
                          .LocationName
                        ];
                      if (
                        locationNameControl.value &&
                        locationNameControl.valid
                      ) {
                        if (question.questionIsRequired) {
                          requiredFieldsValidCount++;
                        }
                      }
                    }
                  }
                }
              });
            }
          }
        });
      }

      if (
        formGroup.valid &&
        requiredFieldsCount === requiredFieldsValidCount &&
        filledFieldsCount > 0
      ) {
        let uploadStartedIndex = -1;
        let attachmentCount = 0;
        let attachmentUploadedCount = 0;
        const attachemtUploaded = {};

        console.log('🟢 [ATTACHMENT TRACKING] Initialized - attachmentCount:', attachmentCount, 'attachmentUploadedCount:', attachmentUploadedCount);

        let loading;

        let fileToBeUploads = [];

        const uploadImageVideoFile = async (index) => {
          if(fileToBeUploads.length === 0){
            this.loading=false;
          }
          if (fileToBeUploads.length > index) {
            const data = fileToBeUploads[index];
            let uploadPromises = [];
            let formDataHasFiles = false;
            const formData = new FormData();
            const videoUploadResults: {[index: number]: string} = {};
            for (let i = 0; i < data.length; i++) {
              const currentFile = data[i];
              if (currentFile.isPreResolved) continue;
              if (currentFile?.isVideo && !UtilService.isWebApp()) {
                if(this.platform.is('android')){
                  currentFile.file = this.removeCapacitorPrefixAndroid(currentFile.file)
                }
                const itemIndex = i;
                const videoUploadPromise = new Promise<void>((resolve, reject) => {
                  this.uploadVideo(
                    currentFile.file,
                    currentFile.mimeType.toLowerCase(),
                    currentFile.fileName,
                    (response) => {
                      if (response.status) {
                        let responseObj = response.result.Result;
                        responseObj.originalName = responseObj.originalName.replaceAll(",", " ");
                        videoUploadResults[itemIndex] = `${responseObj.originalName}|${responseObj.uploadName}`;
                        resolve();
                      } else {
                        reject('Video upload failed');
                      }
                    },
                    (progress) => {}
                  );
                });

                uploadPromises.push(videoUploadPromise);

              } else {
                formData.append(`files`, currentFile.file, currentFile.fileName);
                formDataHasFiles = true;
              }
            }

            try {
              await Promise.all(uploadPromises);
              if (formDataHasFiles) {
                // Images/docs present — call multiplePhotosOrVideosUpload and merge with any video results
                await new Promise<void>((resolve, reject) => {
                  apiService
                    .multiplePhotosOrVideosUpload(formData)
                    .subscribe(
                      (response: any) => {
                        let uploadResultIndex = 0;
                        const orderedEntries = data.map((item, idx) => {
                          if (item.isPreResolved) return item.fileName;
                          if (item.isVideo && !UtilService.isWebApp()) return videoUploadResults[idx] || null;
                          const result = response.Result[uploadResultIndex++];
                          if (!result) return null;
                          result.originalName = result.originalName.replaceAll(",", " ");
                          return `${result.originalName}|${result.uploadName}`;
                        }).filter(Boolean);
                        const controlNameValue = orderedEntries.join(',');
                        attachemtUploaded[data[0].controlName] = controlNameValue;
                        resolve();
                      },
                      (error) => {
                        reject(error);
                      }
                    );
                });
              } else if (uploadPromises.length > 0) {
                // Only native videos — build ordered result from videoUploadResults and pre-resolved
                const orderedEntries = data.map((item, idx) => {
                  if (item.isPreResolved) return item.fileName;
                  return videoUploadResults[idx] || null;
                }).filter(Boolean);
                attachemtUploaded[data[0].controlName] = orderedEntries.join(',');
              } else if (data.length > 0) {
                // All items are pre-resolved (no actual upload needed) — set in order directly
                const controlNameValue = data.map(item => item.fileName).join(',');
                attachemtUploaded[data[0].controlName] = controlNameValue;
              }
              onUploaded();
            } catch (error) {
              console.error('One or more uploads failed:', error);
              this.loading = false;
              this.utilService.hideLoading();
              const errorMessage = error?.status === 0
                ? (this.offlineMode
                    ? 'Connection lost. Sign off interrupted. Please press SO again to continue offline.'
                    : 'Connection lost. Sign off interrupted.')
                : (error?.message || 'File upload failed.');
              callBack(false, errorMessage);
              return;
            }
            finally {
              // Ensure loading is set to false if an error occurs
              if (index === fileToBeUploads.length - 1 || fileToBeUploads.length === 0) {
                this.loading = false;
              //  this.utilService.hideLoading();
              }
            }
          }
        };
        




        const onUploaded = () => {
          attachmentUploadedCount++;
          console.log('🟢 [ATTACHMENT TRACKING] onUploaded() called - attachmentUploadedCount:', attachmentUploadedCount, 'attachmentCount:', attachmentCount);
          if (attachmentCount === attachmentUploadedCount) {
            console.log('✅ [ATTACHMENT TRACKING] All attachments processed! Proceeding with form submission.');
            if(attachmentCount >= 20){
              console.log("cannot have more than 20 attatchments")
            }
            loading = false;
        //    this.utilService.hideLoading();
            this.loading = false;

            console.log('🟢 [FORM SUBMISSION] Calling submitFormAnswers with attachemtUploaded:', attachemtUploaded);
            this.submitFormAnswers(
              apiService,
              formGroup,
              formBuilderDetail,
              personalModeLoggedUser,
              callBack,
              havAnswerDetail,
              workPermitAnswer,
              attachemtUploaded,
              isGenerateTestJsonFile
            );
          } else {
            console.log('🟡 [ATTACHMENT TRACKING] Still waiting for more attachments. Remaining:', attachmentCount - attachmentUploadedCount);
            if (!this.offlineMode) {
              uploadImageVideoFile(attachmentUploadedCount);
            }
          }
        };

        const discoveryPromises: Array<Promise<void>> = [];
        sections.map((section, sectionIndex) => {
          if (this.utilService.shouldShowSection(section)) {
            const questions = section.questions;
            questions.map((question, questionIndex) => {
              discoveryPromises.push((async () => {
              if (this.utilService.shouldShowQuestion(question)) {
                const controlName = UtilService.FCUniqueName(section, question);
                const control = formGroup.controls[controlName];

                if (
                  question.selectedAnswerTypeId ===
                  EnumService.CustomAnswerType.PhotoVideoUpload
                ) {
                  if (control && control.value) {
                    const attachementsArray =[]
                    for (let i = 0; i < control.value.length; i++) {
                      const currentControl = control.value[i];

                      if (currentControl.attachement &&
                          typeof currentControl.attachement === 'string' &&
                          (currentControl.attachement.includes('besafestorageaccount.file.core.windows.net') ||
                          currentControl.attachement.includes('blob.core.windows.net'))) {

                        let existingFileName;

                        if (currentControl.name && currentControl.name.includes('|')) {
                          existingFileName = currentControl.name;
                        } else if (currentControl.fileName && currentControl.fileName.includes('|')) {
                          existingFileName = currentControl.fileName;
                        } else {
                          const urlParts = currentControl.attachement.split('/');
                          const fileNameFromUrl = urlParts[urlParts.length - 1].split('?')[0];
                          existingFileName = (currentControl.name || currentControl.fileName || 'file') + '|' + fileNameFromUrl;
                        }

                        attachementsArray.push({
                          file: null,
                          fileName: existingFileName,
                          questionId: question.questionId,
                          controlName,
                          isPreResolved: true,
                        });
                        continue;
                      }

                      let currentName = currentControl.name?currentControl.name:currentControl.fileName;
                      let fileName =currentName + '|'+ 
                        "photo" +
                        this.utilService.getCurrentTimeStamp() +
                        ".jpeg";
                      let mimeType = "image/jpeg";
                      let isVideo = false;
                      let extension = "jpeg";
                      let document = null;
                      // if value is base64 format then find mimetype and extension
                      if (UtilService.IsBase64Sring(currentControl?.attachement)) {
                        try {
                          extension = currentControl.attachement.match(/[^:/]\w+(?=;|,)/)[0];
                          if (currentControl.attachement.type) {
                            document = currentControl.attachement;

                            // The ternary must be parenthesised. Without the brackets "+" binds
                            // tighter than "?:", so the whole concatenation became the condition
                            // - always truthy - and fileName collapsed to just the extension,
                            // e.g. "pdf". The server then saw a name with no extension at all
                            // and refused the upload as "File type not allowed", which is why no
                            // document attachment could be signed off (CG-1561).
                            //
                            // Falls back to the extension already parsed off the data URI above
                            // when the original name carries none, so the stored file is still
                            // named after its type.
                            const documentExtension =
                              currentName.includes('.') ? currentName.split('.').pop() : extension;

                            fileName = currentName + '|' +
                              "document" +
                              this.utilService.getCurrentTimeStamp() + "-" + i.toString() +
                              (documentExtension ? "." + documentExtension : "");
                            mimeType = currentName.includes('.') ? currentName.split('.').pop() : ''
                            isVideo = null;
                          extension = currentName.includes('.') ? currentName.split('.').pop() : '';
                            }
                          else if (
                            StaticDataService.videoFormats.indexOf(
                              extension.toLowerCase()
                            ) !== -1
                          ) {
                            isVideo = true;
                            fileName =currentName + '|'+ 
                              "video" +
                              this.utilService.getCurrentTimeStamp() +
                              "." +
                              extension;
                            mimeType = currentControl.attachement.match(
                              /[^:]\w+\/[\w-+\d.]+(?=;|,)/
                            )[0];
                            //console.log('this is video',currentControl.attachement)
                          }
                          else {

                            let imgExtension = currentControl.name.split('.').pop();
                            isVideo = false ;
                            fileName =currentName + '|'+ 
                        "photo" +
                        this.utilService.getCurrentTimeStamp()+"." +imgExtension;
                            mimeType = 'image/'+imgExtension;
                          }
                        } catch (error) { }
                      } else {
                        if (currentControl.attachement.type) {
                          document = currentControl.attachement;
                          fileName =currentName + "|document" +this.utilService.getCurrentTimeStamp() + "-"+ i.toString()+ "."+currentName.split('.').pop();
                          mimeType = currentControl.name.split('.').pop()
                          isVideo = null;
                        extension = currentControl.name.split('.').pop();
                         }
                        else if (
                          StaticDataService.videoFormats.indexOf(currentControl.attachement.split(".").pop().toLowerCase()) !== -1
                        ) {
                          extension = currentControl.attachement.split('.').pop().toLowerCase();
                          isVideo = true;
                          fileName = currentName + '|'+ currentControl.attachement.substr(
                            currentControl.attachement.lastIndexOf("/") + 1
                          );
                          mimeType = StaticDataService.fileMimeTypes[extension];


                        }
                        else {
                          isVideo = false ;
                          fileName =currentName + '|'+ 
                      "photo" +
                      this.utilService.getCurrentTimeStamp() +"."+currentName.split('.').pop().toLowerCase();
                          mimeType = currentName.split('.').pop().toLowerCase();

                        }
                      }
                      // --end
  
                      if (this.offlineMode) {
                        console.log('🟡 [OFFLINE ATTACHMENT] Processing attachment offline, index:', i, 'controlName:', controlName);
                        console.log('🟡 [OFFLINE ATTACHMENT] currentControl.attachement type:', typeof currentControl.attachement, 'value:', currentControl.attachement);
                        console.log('🟡 [OFFLINE ATTACHMENT] attachmentCount:', attachmentCount, 'attachmentUploadedCount:', attachmentUploadedCount);
                        
                        // Increment attachmentCount for each attachment in offline mode
                        attachmentCount++;
                        console.log('🟢 [ATTACHMENT TRACKING] attachmentCount incremented to:', attachmentCount, 'for attachment index:', i, 'controlName:', controlName);
                        
                        // Capture original file name before processing
                        let originalFileName = currentName || currentControl.fileName || '';
                        // If we have a File object, use its name property
                        if (currentControl.attachement instanceof File) {
                          originalFileName = currentControl.attachement.name || originalFileName;
                        } else if (typeof currentControl.attachement === 'object' && currentControl.attachement?.name) {
                          originalFileName = currentControl.attachement.name || originalFileName;
                        }
                        
                        const insertImageVideoFileToDb = (offlineFileName) => {
                          console.log('🟡 [OFFLINE ATTACHMENT] insertImageVideoFileToDb called with fileName:', offlineFileName, 'originalFileName:', originalFileName);
                          this.offlineManagerService
                            .insertImageVideoFile({
                              fileName: offlineFileName,
                              originalFileName: originalFileName || null,
                              fileUsedIn: "form",
                            })
                            .then((res) => {
                              console.log('✅ [OFFLINE ATTACHMENT] File inserted to DB, result:', res);
                              // Accumulate file IDs as comma-separated values (matching online behavior)
                              if (attachemtUploaded[controlName]) {
                                attachemtUploaded[controlName] = `${attachemtUploaded[controlName]},${res}`;
                                console.log('🟡 [OFFLINE ATTACHMENT] Accumulated file IDs:', attachemtUploaded[controlName]);
                              } else {
                                attachemtUploaded[controlName] = res;
                                console.log('🟡 [OFFLINE ATTACHMENT] First file ID:', attachemtUploaded[controlName]);
                              }
                              console.log('🟡 [OFFLINE ATTACHMENT] Calling onUploaded(), attachmentCount:', attachmentCount, 'attachmentUploadedCount:', attachmentUploadedCount);
                              onUploaded();
                            })
                            .catch((error) => {
                              console.error('❌ [OFFLINE ATTACHMENT] Failed to insert file to DB:', error);
                              console.log('🟡 [OFFLINE ATTACHMENT] Calling onUploaded() after error');
                              onUploaded();
                            });
                        };
  
                        let filePathOrBinaryData = currentControl.attachement;
                        
                        // Convert File object to base64 before calling saveFileOnDevice (base64 path works reliably)
                        if (filePathOrBinaryData instanceof File || (typeof filePathOrBinaryData === 'object' && filePathOrBinaryData.name && filePathOrBinaryData.type && !filePathOrBinaryData.path)) {
                          console.log('🟡 [OFFLINE ATTACHMENT] Converting File object to base64 before saving...');
                          try {
                            // Use Promise-based arrayBuffer() method instead of FileReader (more reliable)
                            const arrayBuffer = await filePathOrBinaryData.arrayBuffer();
                            console.log('✅ [OFFLINE ATTACHMENT] File read to ArrayBuffer, size:', arrayBuffer.byteLength);
                            
                            // Convert ArrayBuffer to base64
                            const bytes = new Uint8Array(arrayBuffer);
                            let binary = '';
                            for (let i = 0; i < bytes.byteLength; i++) {
                              binary += String.fromCharCode(bytes[i]);
                            }
                            const base64Data = 'data:' + (filePathOrBinaryData.type || 'application/pdf') + ';base64,' + btoa(binary);
                            console.log('✅ [OFFLINE ATTACHMENT] File converted to base64, length:', base64Data.length);
                            filePathOrBinaryData = base64Data; // Replace File with base64 string
                          } catch (error) {
                            console.error('❌ [OFFLINE ATTACHMENT] Error converting File to base64:', error);
                            callBack(false, error);
                            return;
                          }
                        }
                        
                        console.log('🟡 [OFFLINE ATTACHMENT] Calling saveFileOnDevice with:', typeof filePathOrBinaryData === 'string' ? 'base64 string' : filePathOrBinaryData);
  
                        // Wrap saveFileOnDevice in a Promise to enable sequential processing
                        await new Promise<void>((resolve) => {
                          this.filehandlerService.saveFileOnDevice(
                            filePathOrBinaryData,
                            (status, res) => {
                              console.log('🟡 [OFFLINE ATTACHMENT] saveFileOnDevice callback - status:', status, 'res:', res);
                              if (status) {
                                insertImageVideoFileToDb(res);
                              } else {
                                console.error('❌ [OFFLINE ATTACHMENT] saveFileOnDevice failed, calling onUploaded()');
                                onUploaded();
                              }
                              resolve(); // Resolve after callback is handled
                            }
                          );
                        });
                      } else {
                        if (isVideo) {
                          this.utilService
                            .dataUriToFile(currentControl.attachement, fileName, mimeType)
                            .then(async (file: any) => {
                              if (!loading) {
                                this.utilService.presentLoadingWithOptions();
                                loading = true;
                              }
                              attachementsArray.push({
                                file,
                                mimeType,
                                fileName,
                                isVideo,
                                questionId: question.questionId,
                                controlName,
                              });
                            })
                            .catch(() => {
                              let fixedPath = UtilService.fixDeviceDirPath(currentControl.attachement);
                              attachementsArray.push({
                                file :fixedPath,
                                mimeType,
                                fileName,
                                isVideo,
                                questionId: question.questionId,
                                controlName,
                              });
                              // onUploaded();
                            });
                          
                        } else if (isVideo === null) { 
                          attachementsArray.push({
                            file: document,
                            mimeType,
                            fileName,
                            isVideo:false,
                            questionId: question.questionId,
                            controlName,
                          });
                        } else {
                          const uploadImage = (file) => {
                            if (!loading) {
                              this.utilService.presentLoadingWithOptions();
                              loading = true;
                            }
  
                            attachementsArray.push({
                              file,
                              fileName,
                              questionId: question.questionId,
                              controlName,
                            });
                          };
  
                          const imageUrlOrBase64 = currentControl.attachement;
                          if (UtilService.IsBase64Sring(imageUrlOrBase64)) {
                            this.utilService
                              .dataUriToFile(imageUrlOrBase64, fileName, mimeType)
                              .then(async (file) => {
                                uploadImage(file);
                              })
                              .catch(() => {
                                onUploaded();
                              });
                          } else {
                            try {
                              const response = await fetch(
                                Capacitor.convertFileSrc(imageUrlOrBase64)
                              );
                              if (!response.ok) {
                                throw new Error(`Fetch failed: ${response.status}`);
                              }
                              const file = await response.blob();
                              uploadImage(file);
                            } catch (error) {
                              onUploaded();
                            }
                          }
                        }
                      }
                    }
                    // Only increment attachmentCount here for online mode (offline mode increments inside the loop)
                    if (!this.offlineMode) {
                      attachmentCount++;
                      console.log('🟢 [ATTACHMENT TRACKING] attachmentCount incremented to:', attachmentCount, 'for controlName:', controlName, 'attachments in this control:', control.value.length);
                    }
                    fileToBeUploads.push(attachementsArray)
                  }
                }
              }
              })());
            });
            console.log('🟢 [ATTACHMENT TRACKING] Final attachmentCount:', attachmentCount, 'fileToBeUploads:', fileToBeUploads)
            if (uploadStartedIndex === -1) {
              uploadStartedIndex = 0;
              setTimeout(() => {
                uploadImageVideoFile(0);
              }, 1000);
            }
          }
        });

        await Promise.all(discoveryPromises);
        console.log('llllll',fileToBeUploads)
        if (attachmentCount === 0) {
          this.loading = false;
          try {
            this.submitFormAnswers(
              apiService,
              formGroup,
              formBuilderDetail,
              personalModeLoggedUser,
              callBack,
              havAnswerDetail,
              workPermitAnswer,
              {},
              isGenerateTestJsonFile
            );
          } catch (e) {
            callBack(false, e.message || 'Attempted to assign to readonly property.');
          }
        }
      } else if (requiredFieldsCount === 0 && filledFieldsCount === 0) {
        this.translateService
          .get("SHARED_TEXT.ERRORS.ATLEAST_ONE_ANSWER_TO_BE_FILLED_IN")
          .subscribe((res) => {
            const errorMessage = res;
            callBack(false, errorMessage);
          });
      } else if (integerFieldInvalidCount > 0) {
        this.translateService
          .get("SHARED_TEXT.ERRORS.ENTER_VALID_DATA")
          .subscribe((res) => {
            const errorMessage = res;
            callBack(false, errorMessage);
          });
      } else if (requiredFieldsValidCount === 0) {
        this.translateService
          .get("SHARED_TEXT.ERRORS.ALL_FIELDS_REQUIRED")
          .subscribe((res) => {
            const errorMessage = res;
            callBack(false, errorMessage);
          });
      } else {
        const missingFieldCount =
          requiredFieldsCount - requiredFieldsValidCount;
        if (
          missingFieldCount === 0 &&
          filledFieldsCount !== filledFieldsValidCount
        ) {
          this.translateService
            .get("SHARED_TEXT.ERRORS.INCORRECT_DATA_FOUND_PLS_CHECK_ANSWERS")
            .subscribe((res) => {
              const errorMessage = res;
              callBack(false, errorMessage);
            });
        } else {
          console.log("validating error w/count: req - req valid:", requiredFieldsCount, "-", requiredFieldsValidCount)
          this.translateService
            .get("SHARED_TEXT.ERRORS.REQUIRED_FIELDS_NEED_TO_FILL")
            .subscribe((res) => {
              const errorMessage = missingFieldCount + " " + res;
              callBack(false, errorMessage);
            });
        }
      }
    }
  }
  private sigImagesUpload = () => {
    this.inSignatureUsersInfos.map((data) => {
      if (data.questionSigImage && data.questionSigImageName) {
        this.utilService
          .dataUriToFile(data.questionSigImage, data.questionSigImageName, "image/jpeg")
          .then((file) => {
            this.apiServiceRerence.inductionSignatureUpload(file, data.questionSigImageName + '.jpeg')
              .subscribe(
                (res: any) => {
                  console.log(res);
                  this.inSignatureUsersInfos = [];
                },
                (error: any) => {
                  console.error("Error uploading signature:", error);
                }
              );
          })
          .catch((error) => {
            console.error("Error converting data URI to file:", error);
          });
      }


    })
  }
  private sigImagesUploadTwo = (img, name) => {
    if (img && name) {
      this.utilService
        .dataUriToFile(img, name, "image/jpeg")
        .then((file) => {
          this.apiServiceRerence.inductionSignatureUpload(file, name + '.jpeg')
            .subscribe(
              (res: any) => {
                console.log(res);
              },
              (error: any) => {
                console.error("Error uploading signature:", error);
              }
            );
        })
        .catch((error) => {
          console.error("Error converting data URI to file:", error);
        });
    }
    console.log("sigs uploaded", name);
  }

  private submitFormAnswers = (
    apiService: ApiService,
    formGroup: UntypedFormGroup,
    formBuilderDetail,
    personalModeLoggedUser: User,
    callBack,
    havAnswerDetail: HavAnswerDetail = null,
    workPermitAnswer: WorkPermitAnswer = null,
    attachemtUploaded = {},
    isGenerateTestJsonFile = false
  ) => {
    const sections = formBuilderDetail.sections;
    const workPermitDetails = formBuilderDetail.workPermitDetails;
    const accidentReport = formBuilderDetail.accidentReport;
    const formVersionId = formBuilderDetail.formVersionId;

    const questionAnswers = [];
    const accidentReportQuestionAnswers = [];
    const riskAssessmentAnswers = [];
    const riskAssessmentAnswerDetails = { taskAnswers: [] };
    const ioshRiskAssessmentAnswerDetails = { hazardAnswers: []};

    const selectedLanguageID = this.getLanguageIdForForm();

    const formattedSections = [];

     const permitIssuedNotifUsers = workPermitDetails?.permitIssuedNotification?.selectedUsersAndGroups;
     if (permitIssuedNotifUsers && Array.isArray(permitIssuedNotifUsers)) {
       const entityOwner = permitIssuedNotifUsers.find(user => user?.userId === "6f545e05-72dc-471c-a352-95728c6cd261");
       const entityOwnerIndex = permitIssuedNotifUsers.findIndex(user => user?.userId === "6f545e05-72dc-471c-a352-95728c6cd261");

       if (entityOwnerIndex !== -1) {
         const matchingUser = permitIssuedNotifUsers.find(user => user?.userId === this.entityOwnerInfos?.userId && user.name !== "# Entity Owner");

         if (matchingUser) {
             permitIssuedNotifUsers.splice(entityOwnerIndex, 1);
         } else {
            entityOwner.userId = this.entityOwnerInfos?.userId;
         }
       }
     }


      const permitNotIssuedNotifUsers = workPermitDetails?.permitNotIssuedNotification?.selectedUsersAndGroups;
      if (permitNotIssuedNotifUsers && Array.isArray(permitNotIssuedNotifUsers)) {
        const entityOwner = permitNotIssuedNotifUsers.find(user => user?.userId === "6f545e05-72dc-471c-a352-95728c6cd261");
        const entityOwnerIndex = permitNotIssuedNotifUsers.findIndex(user => user?.userId === "6f545e05-72dc-471c-a352-95728c6cd261");

        if (entityOwnerIndex !== -1) {
          const matchingUser = permitNotIssuedNotifUsers.find(user => user?.userId === this.entityOwnerInfos?.userId && user.name !== "# Entity Owner");

          if (matchingUser) {
            permitNotIssuedNotifUsers.splice(entityOwnerIndex, 1);
          } else {
            entityOwner.userId = this.entityOwnerInfos?.userId;
          }
        }
      }

    const userId = this.dedicatedMode
      ? this.dedicatedModeUserDetail?.userId
      : personalModeLoggedUser?.userId;
    const companyId = this.dedicatedMode
      ? this.dedicatedModeDeviceDetailData?.companyID
      : personalModeLoggedUser?.companyID;

      const accidentReportSelectedUsersAndGroups = accidentReport?.accidentNotification?.selectedUsersAndGroups;
      if (accidentReportSelectedUsersAndGroups && Array.isArray(accidentReportSelectedUsersAndGroups)) {
        const entityOwner = accidentReportSelectedUsersAndGroups.find(user => user?.userId === "6f545e05-72dc-471c-a352-95728c6cd261");
        const entityOwnerIndex = accidentReportSelectedUsersAndGroups.findIndex(user => user?.userId === "6f545e05-72dc-471c-a352-95728c6cd261");

        if (entityOwnerIndex !== -1) {
          const matchingUser = accidentReportSelectedUsersAndGroups.find(user => user?.userId === this.entityOwnerInfos?.userId && user?.name !== "# Entity Owner");

          if (matchingUser) {
            accidentReportSelectedUsersAndGroups.splice(entityOwnerIndex, 1);
          } else {
            entityOwner.userId = this.entityOwnerInfos?.userId;
          }
        }
      }

      sections.map((section, sectionIndex) => {
        if (this.utilService.shouldShowSection(section)) {
          const formattedAnswers = [];
          const sectionFormattedObject: any = JSON.parse(JSON.stringify(section));

          if(sectionFormattedObject.achievedSectionScore === null){
            //TODO: delete this condition when the null handling is ready
            sectionFormattedObject.achievedSectionScore = "0"
          }
          if (section.isRiskAssessmentSection) {
            const tasks = section.riskAssessmentAnswerDetails?.taskAnswers;
            riskAssessmentAnswerDetails.taskAnswers = tasks;
            tasks.map((task) => {
              if (this.utilService.shouldShowQuestion(task)) {
                const answerFormattedObject: any = JSON.parse(
                  JSON.stringify(task)
                );
                const hazardsAnswers = task.hazardAnswers;

                answerFormattedObject.answerData = hazardsAnswers;
                formattedAnswers.push(answerFormattedObject);
              }
            });

          sectionFormattedObject.taskAnswerData = formattedAnswers;
        } else if (section.isIOSHRiskAssessmentSection){
          const hazards = section.ioshRiskAssessmentAnswerDetails?.hazardAnswers;
          ioshRiskAssessmentAnswerDetails.hazardAnswers = hazards;
          hazards.map((issue) => {
            if (this.utilService.shouldShowQuestion(issue)) {
              const answerFormattedObject: any = JSON.parse(
                JSON.stringify(issue)
              );
              answerFormattedObject.answerData = issue;
              formattedAnswers.push(answerFormattedObject);
              sectionFormattedObject.answerData = formattedAnswers;
            }
          });
        }else if (section.isHAVSection) {
          const havAssessmentTools = section.havAssessmentTools;
          havAssessmentTools.some((havAssessmentTool) => {
            const questions = havAssessmentTool.questions;

            questions.some((question, questionIndex) => {
              const questionDisplayOrder = questionIndex + 1;
              const questionLabel = UtilService.findObj(
                question.questionTranslations,
                "questionTranslationLanguageId",
                selectedLanguageID
              ).questionTranslationTitle;
              const answerFormattedObject: any = JSON.parse(
                JSON.stringify(question)
              );

              const havQuestionAnswerObject: HavAnswerObject = {
                hAVQuestionAnswerId: 0,
                questionID: question.questionId,
                questionTitle: questionLabel,
                formVersionID: formVersionId,
                answerTypeID: question.selectedAnswerTypeId,
                hAVSequence: question.questionDisplayOrder,
                [EnumService.QuestionLogic.ActionTypeForForm.MarkAsFailed]:
                  question[
                  EnumService.QuestionLogic.ActionTypeForForm.MarkAsFailed
                  ],
                [EnumService.QuestionLogic.ActionTypeForForm.Notify]:
                  question[EnumService.QuestionLogic.ActionTypeForForm.Notify],
                [EnumService.QuestionLogic.ActionTypeForForm.CreateNewActivity]:
                  question[
                  EnumService.QuestionLogic.ActionTypeForForm
                    .CreateNewActivity
                  ],
              };

              let isValueFilled = false;
              switch (questionDisplayOrder) {
                case EnumService.HavFormFieldOrder.DateOfUsage:
                  if (question.value) {
                    havQuestionAnswerObject.dateOfUsage = moment(
                      question.value
                    ).format(StaticDataService.dateFormat);
                    isValueFilled = true;
                  }
                  break;
                case EnumService.HavFormFieldOrder.Manufacturer:
                  if (question.value) {
                    havQuestionAnswerObject.hAVManufacturerID = question.value;
                    isValueFilled = true;
                  }
                  break;
                case EnumService.HavFormFieldOrder.Type:
                  if (question.value) {
                    havQuestionAnswerObject.hAVTypeID = question.value;
                    isValueFilled = true;
                  }
                  break;
                case EnumService.HavFormFieldOrder.Model:
                  if (question.value) {
                    havQuestionAnswerObject.hAVModelID = question.value;
                    havQuestionAnswerObject.inventoryItemID =
                      question.inventoryItemID;
                    isValueFilled = true;
                  }
                  break;
                case EnumService.HavFormFieldOrder.PlannedTimeOfUsage:
                  if (question.value) {
                    isValueFilled = true;
                    havQuestionAnswerObject.plannedTimeOfUse = Number(
                      question.value
                    );
                  }
                  break;
              }

              if (isValueFilled) {
                answerFormattedObject.havAnswerData = havQuestionAnswerObject;
                formattedAnswers.push(answerFormattedObject);
              }
            });
          });

          sectionFormattedObject.answerData = formattedAnswers;
        } else {
          const questions = section.questions;

          questions.map((question, questionIndex) => {
            const questionLogics = question.questionLogics;
            questionLogics.map((questionLogic, questionLogicIndex) => {
              if (questionLogic.activityOwnerID === "6f545e05-72dc-471c-a352-95728c6cd261") {
                questionLogic.activityOwnerID = this.entityOwnerInfos?.userId;
              }

              const questionLogicAssignees = questionLogic.questionLogicAssignees;
              const questionLogicNotification = questionLogic.questionLogicNotification;
              const assigneesSelectedUsersAndGroups = questionLogicAssignees.selectedUsersAndGroups;
              const notificationSelectedUsersAndGroups = questionLogicNotification.selectedUsersAndGroups;
              if (assigneesSelectedUsersAndGroups) {
                const entityOwner = assigneesSelectedUsersAndGroups.find(user => user?.userId === "6f545e05-72dc-471c-a352-95728c6cd261");
                const entityOwnerIndex = assigneesSelectedUsersAndGroups.findIndex(user => user?.userId === "6f545e05-72dc-471c-a352-95728c6cd261");

                if (entityOwnerIndex !== -1) {
                  const matchingUser = assigneesSelectedUsersAndGroups.find(user => user?.userId === this.entityOwnerInfos?.userId && user.name !== "# Entity Owner");

                  if (matchingUser) {
                    assigneesSelectedUsersAndGroups.splice(entityOwnerIndex, 1);
                  } else {
                    entityOwner.userId = this.entityOwnerInfos?.userId;
                  }
                }
              }
              if (notificationSelectedUsersAndGroups) {
                const entityOwner = notificationSelectedUsersAndGroups.find(user => user?.userId === "6f545e05-72dc-471c-a352-95728c6cd261");
                const entityOwnerIndex = notificationSelectedUsersAndGroups.findIndex(user => user?.userId === "6f545e05-72dc-471c-a352-95728c6cd261");

                if (entityOwnerIndex !== -1) {
                  const matchingUser = notificationSelectedUsersAndGroups.find(user => user?.userId === this.entityOwnerInfos?.userId && user.name !== "# Entity Owner");

                  if (matchingUser) {
                    notificationSelectedUsersAndGroups.splice(entityOwnerIndex, 1);
                  } else {
                    entityOwner.userId = this.entityOwnerInfos?.userId;
                  }
                }
              }



            })
            const questionDisplayOrder = questionIndex + 1;
            if (this.utilService.shouldShowQuestion(question)) {
              const answerFormattedObject: any = JSON.parse(
                JSON.stringify(question)
              );
              const controlName = UtilService.FCUniqueName(section, question);
              const control = formGroup.controls[controlName];
              let isValueFilled = false;

              if (control) {
                const questionLabel = UtilService.findObj(
                  question.questionTranslations,
                  "questionTranslationLanguageId",
                  selectedLanguageID
                ).questionTranslationTitle;

                if (section.isAccidentReportSection) {
                  const answerObject: ArAnswerObject = {
                    accidentReportQuestionAnswerId: 0,
                    questionID: question.questionId,
                    questionTitle: questionLabel,
                    formVersionID: formVersionId,
                    answerTypeID: question.selectedAnswerTypeId,
                    accidentAnswerSequence: question.questionDisplayOrder,
                    [EnumService.QuestionLogic.ActionTypeForForm.MarkAsFailed]:
                      question[
                      EnumService.QuestionLogic.ActionTypeForForm.MarkAsFailed
                      ],
                    [EnumService.QuestionLogic.ActionTypeForForm.Notify]:
                      question[
                      EnumService.QuestionLogic.ActionTypeForForm.Notify
                      ],
                    [EnumService.QuestionLogic.ActionTypeForForm
                      .CreateNewActivity]:
                      question[
                      EnumService.QuestionLogic.ActionTypeForForm
                        .CreateNewActivity
                      ],
                  };

                  switch (questionDisplayOrder) {
                    case EnumService.AccidentFormFieldOrder.AccidentDateTime:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.accidentDateTime = moment(
                          control.value
                        ).format(StaticDataService.dateTimeFormat);
                      }
                      break;
                    case EnumService.AccidentFormFieldOrder.AccidentLocation:
                      const placeNotintheList =
                        formGroup.controls.placeNotintheList;
                      const locationName = formGroup.controls.locationName;

                      if (placeNotintheList.value) {
                        isValueFilled = true;
                        answerObject.accidentLocationName = locationName.value;
                      } else if (control.value) {
                        isValueFilled = true;
                        const entityIds = this.utilService.getRelevantEntityId(
                          control.value
                        );
                        answerObject.accidentInventoryID =
                          entityIds.InventoryID;
                        answerObject.accidentProjectID = entityIds.ProjectID;
                        answerObject.accidentLocationID = entityIds?.LocationID;
                      }
                      break;

                    case EnumService.AccidentFormFieldOrder.About:
                      const formGroups = control.value as UntypedFormGroup;
                      const multipleChoiceValueIDs = [];
                      question.answerChoiceAttributes.map((choice) => {
                        const choiceControl =
                          formGroups[
                          UtilService.SubFCName(
                            controlName,
                            choice.answerChoiceAttributeId
                          )
                          ];
                        if (choiceControl) {
                          multipleChoiceValueIDs.push(
                            choice.answerChoiceAttributeId
                          );
                        }
                      });
                      if (multipleChoiceValueIDs.length > 0) {
                        try{
                        isValueFilled = true;
                        answerObject.accidentAboutIDs =
                          multipleChoiceValueIDs.join(",");
                        } catch{}
                      }
                      break;
                    case EnumService.AccidentFormFieldOrder.Type:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.accidentTypeID = control.value;
                      }
                      break;
                    case EnumService.AccidentFormFieldOrder.Classification:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.accidentClassificationID = control.value;
                      }
                      break;
                    case EnumService.AccidentFormFieldOrder.BodyPartEffected:
                      const bodyPartFormGroups = control.value as UntypedFormGroup;
                      const bodyPartsIDs = [];
                      const injuriesReported =
                        formGroup.controls.injuriesReported;
                      if (injuriesReported.value === "yes") {
                        StaticDataService.bodyParts.map((partGroup) => {
                          partGroup.parts.map((part) => {
                            const choiceControl =
                              bodyPartFormGroups[
                              UtilService.SubFCName(controlName, part.id)
                              ];
                            if (choiceControl) {
                              bodyPartsIDs.push(part.id);
                            }
                          });
                        });
                        if (bodyPartsIDs.length > 0) {
                          isValueFilled = true;
                          answerObject.accidentBodyPartIDs =
                            bodyPartsIDs.join(",");
                        }
                      } else {
                        isValueFilled = true;
                        answerObject.accidentBodyPartIDs = "36";
                      }

                      break;
                    case EnumService.AccidentFormFieldOrder.Description:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.accidentDescription = control.value;
                      }
                      break;
                    case EnumService.AccidentFormFieldOrder.Attachment:
                      if (attachemtUploaded[controlName]) {
                        isValueFilled = true;
                        if (this.offlineMode) {
                          answerObject.accidentAttachmentFileId =
                            attachemtUploaded[controlName];
                        } else {
                          answerObject.accidentAttachmentFileName =
                            attachemtUploaded[controlName];
                        }
                      }
                      break;
                  }

                  if (isValueFilled) {
                    accidentReportQuestionAnswers.push(answerObject);
                    answerFormattedObject.arAnswerData = answerObject;
                  }
                } else {
                  const answerObject: FormAnswerObject = {
                    questionAnswerId: 0,
                    questionID: question.questionId,
                    questionTitle: questionLabel,
                    formVersionID: formVersionId,
                    answerTypeID: question.selectedAnswerTypeId,
                    multipleChoiceAnswers: [],
                    matrixAnswer: {},
                    signatureAnswer: {},
                    [EnumService.QuestionLogic.ActionTypeForForm.MarkAsFailed]:
                      question[
                      EnumService.QuestionLogic.ActionTypeForForm.MarkAsFailed
                      ],
                    [EnumService.QuestionLogic.ActionTypeForForm.Notify]:
                      question[
                      EnumService.QuestionLogic.ActionTypeForForm.Notify
                      ],
                    [EnumService.QuestionLogic.ActionTypeForForm
                      .CreateNewActivity]:
                      question[
                      EnumService.QuestionLogic.ActionTypeForForm
                        .CreateNewActivity
                      ],
                  };

                  switch (question.selectedAnswerTypeId) {
                    case EnumService.CustomAnswerType.ClassicDropdown:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.singleChoiceValueID =
                          control.value[question.listValueKey];
                      }
                      break;
                    case EnumService.CustomAnswerType.SingleLineText:
                    case EnumService.CustomAnswerType.MultiLineText:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.textValue = control.value;
                      }
                      break;
                    case EnumService.CustomAnswerType.SingleChoiceSet:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.singleChoiceValueID = control.value;
                      }
                      break;

                    case EnumService.CustomAnswerType.MultipleChoiceSet:
                      const formGroups = control.value as UntypedFormGroup;
                      const multipleChoiceValueIDs = [];
                      question.answerChoiceAttributes.map((choice) => {
                        const choiceControl =
                          formGroups[
                          UtilService.SubFCName(
                            controlName,
                            choice.answerChoiceAttributeId
                          )
                          ];
                        if (choiceControl) {
                          multipleChoiceValueIDs.push(
                            choice.answerChoiceAttributeId
                          );
                        }
                      });
                      if (multipleChoiceValueIDs.length > 0) {
                        isValueFilled = true;
                        answerObject.multipleChoiceValueIDs =
                          multipleChoiceValueIDs.join(",");
                      }
                      break;
                    case EnumService.CustomAnswerType.ConfirmationBox:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.isConfirmBoxChecked = true;
                      }
                      break;
                    case EnumService.CustomAnswerType.ScanQrCodeField:
                      if (control.value) {
                        isValueFilled = true;
                        const entityItem: EntityItem =
                          control.value as EntityItem;
                        answerObject.selectedQRCodeType =
                          entityItem.entityType.replace(" ", "");
                        switch (entityItem.entityType) {
                          case EnumService.SelectedQRCodeType.Location:
                            answerObject.qrCodeLocationID = entityItem.entityID;
                            answerObject.qrCodeLocationName =
                              entityItem.entityName;
                            break;
                          case EnumService.SelectedQRCodeType.Project:
                            answerObject.qrCodeProjectID = entityItem.entityID;
                            answerObject.qrCodeProjectName =
                              entityItem.entityName;
                            break;
                          case EnumService.SelectedQRCodeType.InventoryItem:
                            answerObject.qrCodeInventoryItemID =
                              entityItem.entityID;
                            answerObject.qrCodeInventoryItemName =
                              entityItem.entityName;
                            break;
                          case EnumService.SelectedQRCodeType.Document:
                            answerObject.qrCodeDocumentID = entityItem.entityID;
                            answerObject.qrCodeDocumentName =
                              entityItem.entityName;
                            break;
                          case EnumService.SelectedQRCodeType.Form:
                            answerObject.qrCodeFormID = entityItem.entityID;
                            answerObject.qrCodeFormTitle =
                              entityItem.entityName;
                            break;
                          case EnumService.SelectedQRCodeType.User:
                            answerObject.qrCodeUserID = entityItem.entityID;
                            answerObject.qrCodeUserName = entityItem.entityName;
                            break;

                          default:
                            break;
                        }
                      }
                      break;
                    case EnumService.CustomAnswerType.Matrix3DField:
                      if (control.value) {
                        const matrixSelectedValues = control.value;
                        const matrixRows = question.matrixRows;
                        const matrixColumns = question.matrixColumns;
                        if (
                          matrixRows &&
                          matrixColumns &&
                          matrixSelectedValues &&
                          Object.keys(matrixSelectedValues).length > 0
                        ) {
                          isValueFilled = true;
                          const matrixRowsAnswer = [];

                          matrixRows.map((rowItem, rowIndex) => {
                            const matrixColsAnswer = [];

                            matrixColumns.map((colItem, colIndex) => {
                              const matKey = rowIndex + "_" + colIndex;
                              if (matrixSelectedValues[matKey]) {
                                matrixColsAnswer.push({
                                  matrixColumnId: colItem.matrixColumnId,
                                  matrixColumnName: UtilService.findObj(
                                    colItem.matrixColumnTranslations,
                                    "matrixColumnTranslationLanguageId",
                                    this.getLanguageIdForForm(),
                                    0
                                  ).matrixColumnTranslationName,
                                });
                              }
                            });

                            if (
                              matrixColsAnswer &&
                              matrixColsAnswer.length > 0
                            ) {
                              matrixRowsAnswer.push({
                                matrixRowId: rowItem.matrixRowId,
                                matrixRowName: UtilService.findObj(
                                  rowItem.matrixRowTranslations,
                                  "matrixRowTranslationLanguageId",
                                  this.getLanguageIdForForm(),
                                  0
                                ).matrixRowTranslationName,
                                matrixColumns: matrixColsAnswer,
                              });
                            }
                          });

                          answerObject.matrixAnswer = {
                            matrixRows: matrixRowsAnswer,
                          };
                        }
                      }

                      break;
                    case EnumService.CustomAnswerType.InformSignature:
                      if (control.value) {
                        let isValid = false;
                        control.value.map((sig) => {
                          if (sig.signatureImage) {
                            isValid = true;
                            this.sigImagesUploadTwo(sig.sigImage, sig.signatureImage) 
                          } else {
                            console.log('no image', sig.userName)
                          }
                        })
                        if (isValid) {
                          isValueFilled = true;
                          const controlValue = control.value.filter(user => user?.userId !== "" && user.userName !== "" && user.signatureImage !== "" && user.sigImage !== "");
                          answerObject.signatureAnswer = {
                            signatureAnswers: controlValue.map((el) => ({
                              userId: el?.userId,
                              userName: el.userName,
                              signatureImage: (el.signatureImage !== undefined ? el.signatureImage : el.questionSigImageName) + '.jpeg',
                              sigImage: el.sigImage || ''
                            }))
                          }
                          const concatenatedUserIds = control.value.map((el) => el?.userId).join('|');
                          const concatenatedUserNames = control.value.map((el) => el?.userName).join('|');
                          this.currentInformSignaturesData.push({
                            signatureUsersNames: concatenatedUserNames,
                            signatureUsersIds: concatenatedUserIds,
                            isNotifySignedUsers: control.value[0].isNotifySignedUsers,
                            isSystemNotification: control.value[0].isSystemNotification,
                            isEmailNotification: control.value[0].isEmailNotification,
                            isSMSNotification: control.value[0].isSMSNotification
                          });
                        }


                      }

                      break;

                      case EnumService.CustomAnswerType.BodyMapCustomQuestion:
                      const bodyMapFormGroup = formGroup.controls[controlName] as UntypedFormGroup;
                      if (bodyMapFormGroup && bodyMapFormGroup.controls) {
                        const bodyPartIDs = [];
                        StaticDataService.bodyParts.map((partGroup) => {
                          partGroup.parts.map((part: any) => {
                            const subControlName = UtilService.SubFCName(controlName, part.id);
                            const subControl = bodyMapFormGroup.controls[subControlName];
                            if (subControl && subControl.value === true) {
                              bodyPartIDs.push(part.id);
                            }
                          });
                        });
                        if (bodyPartIDs.length > 0) {
                          isValueFilled = true;
                          answerObject.bodyPartIDs = bodyPartIDs.join(',');
                        }
                      }
                      break;

                    case EnumService.CustomAnswerType.NumberFieldInteger:
                      if (control.value) {
                        isValueFilled = true;
                        // answerObject.integerValue =
                        //     Number(control.value);
                        answerObject.integerValueInString = control.value;
                      }
                      break;
                    case EnumService.CustomAnswerType.NumberFieldDecimal:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.decimalValue = Number(control.value);
                      }
                      break;
                    case EnumService.CustomAnswerType.DateField:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.dateValue = moment(control.value).format(
                          StaticDataService.dateFormat
                        );
                      }
                      break;
                    case EnumService.CustomAnswerType.TimeField:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.timeValue = moment(control.value).format(
                          StaticDataService.timeFormat
                        );
                      }
                      break;
                    case EnumService.CustomAnswerType.DateTimeField:
                      if (control.value) {
                        isValueFilled = true;
                        answerObject.dateTimeValue = moment(
                          control.value
                        ).format(StaticDataService.dateTimeFormat);
                      }
                      break;
                    case EnumService.CustomAnswerType.PhotoVideoUpload:
                      if (attachemtUploaded[controlName]) {
                        isValueFilled = true;
                        if (this.offlineMode) {
                          answerObject.imageVideoFileId =
                            attachemtUploaded[controlName];
                        } else {
                          answerObject.imageVideoFileName =
                            attachemtUploaded[controlName].replace(/,+$/, '');
                        }
                      }
                      break;
                  }

                  // if additional comment
                  if (question.shouldShowOptionalComment) {
                    const additionalControl =
                      formGroup.controls[
                      UtilService.FCNameAdditioanlNoteUq(controlName)
                      ];
                    if (additionalControl.value) {
                      answerObject.questionComment = additionalControl.value;
                    }
                  }

                  question.questionLogics.some((logic) => {
                    if (logic.questionActionTypeID === 21) {
                      const additionalControl =
                        formGroup.controls[
                        UtilService.FCNameActionUq(controlName)
                        ];
                      if (additionalControl.value) {
                        answerObject.questionAction = additionalControl.value;
                      }
                    }
                  })


                  if (isValueFilled) {
                    questionAnswers.push(answerObject);
                    answerFormattedObject.answerData = answerObject;
                  }
                }
              }

              if (isValueFilled) {
                formattedAnswers.push(answerFormattedObject);
              }
            }
          });

          formattedAnswers.map((answer) => {
              answer.questionLogics.map((logic) => {
                if (logic.questionActionTypeID === 21 && answer.answerData?.questionAction !== null) {
                  logic.activityTitle = answer.answerData.questionAction;
                }
              })
          })
          sectionFormattedObject.answerData = formattedAnswers;

        }

        if (
          (sectionFormattedObject.answerData &&
            sectionFormattedObject.answerData.length > 0) ||
          (sectionFormattedObject.taskAnswerData &&
            sectionFormattedObject.taskAnswerData.length > 0)
        ) {
          formattedSections.push(sectionFormattedObject);
        }
      }
    });
    
    const submitAnswersObject: SubmitAnswersObject = {
      formId: formBuilderDetail.formId,
      formVersionId,
      selectedLanguageID,
      formTypeId: formBuilderDetail.formTypeID,
      userId: userId || StaticDataService.userDefaultGuid,
      guest_FirstName: this.checkInPostData?.guestFirsName || "",
      guest_MiddleName: this.checkInPostData?.guestMiddleName || "",
      guest_LastName: this.checkInPostData?.guestLastName || "",
      guest_Phone: this.checkInPostData?.guestPhone || "",
      companyId,
      questionAnswers,
      accidentReportQuestionAnswers,
      riskAssessmentAnswers,
      havAnswerDetail: havAnswerDetail,
      workPermitAnswer: workPermitAnswer,
      formattedSections,
      workPermitDetails,
      accidentReport,
      riskAssessmentAnswerDetails,
      ioshRiskAssessmentAnswerDetails,
      entityId:this.signOffFormDetail.entityList && this.signOffFormDetail.entityList.length > 0
      ? this.signOffFormDetail.entityList[0]?.locationID
      : this.utilService.getEntityIdFromId(this.dedicatedModeLocationUse)
    };

    const saveFormSuccess = (result) => {
      if (
        this.viewFormFor === EnumService.ViewFormForType.Activity ||
        this.viewFormFor === EnumService.ViewFormForType.CurrentCheckin ||
        this.viewFormFor ===
        EnumService.ViewFormForType.CurrentCheckinWorkPermit ||
        this.viewFormFor === EnumService.ViewFormForType.FormDM ||
        this.viewFormFor === EnumService.ViewFormForType.WorkPermitDM
      ) {
        this.workPermitAnswer = workPermitAnswer;
        this.startFormSignOffProcess(userId, apiService, result);
      } else if (this.viewFormFor === EnumService.ViewFormForType.Induction) {
        if (this.checkInPostData) {
          if (this.offlineMode) {
            const formSubmitDataId = result;
            if (
              !this.checkInPostData.formSubmitDataId ||
              !Array.isArray(this.checkInPostData.formSubmitDataId)
            ) {
              this.checkInPostData.formSubmitDataId = [];
            }
            this.checkInPostData.formSubmitDataId.push(formSubmitDataId);
          } else {
            if (
              !this.checkInPostData.inductionFormList ||
              !Array.isArray(this.checkInPostData.inductionFormList)
            ) {
              this.checkInPostData.inductionFormList = [];
            }

            //It is old keys , not used now
            this.checkInPostData.inductionFormContent = "";
            this.checkInPostData.answerNotificationList = "";
            this.checkInPostData.groupUniqueID = result.groupUniqueID;
            this.checkInPostData.createdActivityList =
              result.questionLogicActivityList;

            // For support multiple induction forms list
            this.checkInPostData.inductionFormList.push({
              formId: formBuilderDetail.formId,
              inductionFormContent: result.formAnswerHtmlString,
              answerNotificationList: result.answerNotificationList,
              groupUniqueID: result.groupUniqueID,
              createdActivityList: result.questionLogicActivityList,
            });
          }
        }
        this.inductionNavigationProcess(userId, this.inductionContentItemIndex);
      }
      callBack(true, result);
    };
    // if (UtilService.isLocalHost()) {
    //   console.log("submitanswerobj", submitAnswersObject);
    //   return;
    // }
    this.utilService.presentLoadingWithOptions();

    for(const section of submitAnswersObject.formattedSections){
      if(!this.scoreData.enabled){
        section.formScore = 0
        section.maxFormScore = 0
        section.formPerScore = 0
        section.perSectionScore = 0
        section.achievedSectionScore = 0
        section.maximumSectionScore = 0
        try{this.signOffDetailsPostData.formPerScore  = 0} catch{}
        try{this.signOffDetailsPostData.formScore = 0} catch{}
        try{this.signOffDetailsPostData.maxFormScore = 0} catch{}
      } else{
        section.formScore = this.scoreData.formScore
        section.maxFormScore = this.scoreData.formPossibleScore
        section.isShowScoreInPDF = this.scoreData.showTotalScoreInPDF
        section.isShowSectionScoreInPDF = this.scoreData.showSectionScoreinPDF
        section.formPerScore = Math.round((this.scoreData.formScore/this.scoreData.formPossibleScore)*100)
        if(section.perSectionScore === null || section.perSectionScore === undefined || section.formPerScore.toString() == "NaN"){
          section.perSectionScore = 0
        }
        if(section.formPerScore === null || section.formPerScore === undefined || section.formPerScore.toString() == "NaN"){
          section.formPerScore = 0
        }
        if(section.formScore === null || section.formScore === undefined || section.formScore.toString() == "NaN"){
          section.formScore = 0
        }
        if(section.maxFormScore === null || section.maxFormScore === undefined || section.maxFormScore.toString() == "NaN"){
          section.maxFormScore = 0
        }
      }
    }

    if (this.offlineMode) {
      // Log all imageVideoFileIds being saved in formattedSections
      try {
        const savedImageVideoFileIds: number[] = [];
        if (submitAnswersObject.formattedSections && Array.isArray(submitAnswersObject.formattedSections)) {
          submitAnswersObject.formattedSections.forEach((section: any, sectionIndex: number) => {
            if (section.answerData && Array.isArray(section.answerData)) {
              section.answerData.forEach((answerData: any) => {
                if (answerData?.answerData?.imageVideoFileId) {
                  savedImageVideoFileIds.push(answerData.answerData.imageVideoFileId);
                  console.log('💾 [SAVE DEBUG] Found imageVideoFileId in formattedSections:', answerData.answerData.imageVideoFileId, 'sectionIndex:', sectionIndex);
                }
              });
            }
          });
        }
        // Also check questionAnswers
        if (submitAnswersObject.questionAnswers && Array.isArray(submitAnswersObject.questionAnswers)) {
          submitAnswersObject.questionAnswers.forEach((qa: any) => {
            if (qa?.imageVideoFileId) {
              savedImageVideoFileIds.push(qa.imageVideoFileId);
              console.log('💾 [SAVE DEBUG] Found imageVideoFileId in questionAnswers:', qa.imageVideoFileId);
            }
          });
        }
        // Also check accidentReportQuestionAnswers
        if (submitAnswersObject.accidentReportQuestionAnswers && Array.isArray(submitAnswersObject.accidentReportQuestionAnswers)) {
          submitAnswersObject.accidentReportQuestionAnswers.forEach((qa: any) => {
            if (qa?.accidentAttachmentFileId) {
              savedImageVideoFileIds.push(qa.accidentAttachmentFileId);
              console.log('💾 [SAVE DEBUG] Found accidentAttachmentFileId in accidentReportQuestionAnswers:', qa.accidentAttachmentFileId);
            }
          });
        }
        console.log('💾 [SAVE DEBUG] Total imageVideoFileIds being saved to database:', savedImageVideoFileIds.length, 'IDs:', savedImageVideoFileIds);
      } catch (e) {
        console.warn('💾 [SAVE DEBUG] Error logging saved imageVideoFileIds:', e);
      }
      this.offlineManagerService
        .insertFormSubmitData(submitAnswersObject)
        .then((formSubmitDataId) => {
          console.log('[SIGN-OFF ARCHIVE DEBUG] saveFormAnswers offline — FormSubmitData inserted:', {
            formSubmitDataId,
            offlineMode: this.offlineMode,
            dedicatedMode: this.dedicatedMode,
          });
          this.utilService.hideLoading();
          if (havAnswerDetail && havAnswerDetail.totalExposure) {
            this.offlineManagerService
              .insertHAVExposureForDate({
                userID: userId,
                isOfflineDone: true,
                exposurePoints: havAnswerDetail.calculatedExposure,
                modifiedDate: moment.utc().format("YYYY-MM-DDT00:00:00"),
              })
              .then((res) => { });
          }

          saveFormSuccess(formSubmitDataId);
        })
        .catch((error) => {
          callBack(false, error.message);
          this.utilService.hideLoading();
        });
    } else {
      if(submitAnswersObject.entityId === "" || submitAnswersObject.entityId === null || submitAnswersObject.entityId === undefined || !submitAnswersObject.entityId){
        submitAnswersObject.entityId =  this.utilService.getEntityIdFromId(this.currentSelectedCheckinPlace)
      }
      //console.log("final details: ", this.signOffDetailsPostData, submitAnswersObject)
      apiService.saveFormAnswers(submitAnswersObject).subscribe(
        (response: Response) => {
          this.loading = false;
          this.utilService.hideLoading();
          console.log('[SIGN-OFF ARCHIVE DEBUG] saveFormAnswers online success:', {
            statusCode: response?.StatusCode,
            resultType: typeof response?.Result,
            formSubmitDataId:
              typeof response?.Result === 'number'
                ? response.Result
                : response?.Result?.formSubmitDataId || response?.Result?.id || null,
            hasFormAnswerHtmlString: !!response?.Result?.formAnswerHtmlString,
            offlineMode: this.offlineMode,
            dedicatedMode: this.dedicatedMode,
          });
          saveFormSuccess(response.Result);
        },
        (error) => {
          this.loading = false;
          let errorMessage = error.message;
          if (error.status === 0) {
            errorMessage = this.offlineMode
              ? 'Connection lost. Sign off interrupted. Please press SO again to continue offline.'
              : 'Connection lost. Sign off interrupted.';
          }
          callBack(false, errorMessage);
          this.utilService.hideLoading();
        }
      );
    }
  };




  private startFormSignOffProcess = (
    userId,
    apiService: ApiService,
    saveAnswerResult
  ) => {
    const signOffFormDetail = this.signOffFormDetail;
    
    // Use mutable approach only in dedicated mode while offline
    // Use direct mutation approach in other cases (online or non-dedicated mode)
    if (this.dedicatedMode && this.offlineMode) {
      let mutableSaveAnswerResult;
      if (typeof saveAnswerResult === 'number') {
          mutableSaveAnswerResult = {
          formSubmitDataId: saveAnswerResult,
          answerNotificationList: [],
          groupUniqueID: '',
          questionLogicActivityList: [],
          formAnswerHtmlString: ''
        };
      } else if (saveAnswerResult && typeof saveAnswerResult === 'object') {
        try {
          mutableSaveAnswerResult = JSON.parse(JSON.stringify(saveAnswerResult));
        } catch (e) {
          try {
            mutableSaveAnswerResult = {
              ...saveAnswerResult,
              answerNotificationList: saveAnswerResult.answerNotificationList ? [...saveAnswerResult.answerNotificationList] : []
            };
          } catch (e2) {
            mutableSaveAnswerResult = {
              answerNotificationList: [],
              groupUniqueID: saveAnswerResult?.groupUniqueID || '',
              questionLogicActivityList: saveAnswerResult?.questionLogicActivityList || [],
              formAnswerHtmlString: saveAnswerResult?.formAnswerHtmlString || ''
            };
          }
        }
      } else {
        mutableSaveAnswerResult = {
          answerNotificationList: [],
          groupUniqueID: '',
          questionLogicActivityList: [],
          formAnswerHtmlString: ''
        };
      }
      
      const answerNotificationArray = mutableSaveAnswerResult.answerNotificationList || [];

      const mutableAnswerNotificationArray = answerNotificationArray.map((notif) => {
        const mutableNotif = { ...notif };
        const userList = notif.userList || [];

        mutableNotif.userList = userList.map((user) => {
          const mutableUser = { ...user };
          try {
            mutableUser.email = user.email? user.email :this.entityOwnerInfos?.email?  this.entityOwnerInfos?.email : "";
            mutableUser.userId = user.userId? user.userId : this.entityOwnerInfos?.userId? this.entityOwnerInfos?.userId : "";
            mutableUser.phone =  user.phone? user.phone : this.entityOwnerInfos?.phone? this.entityOwnerInfos?.phone : "";
            mutableUser.phoneCode = user.phoneCode? user.phoneCode : this.entityOwnerInfos?.phoneCode? this.entityOwnerInfos?.phoneCode : "";
          } catch (e) {
          }
          return mutableUser;
        });
        
        return mutableNotif;
      });

      mutableSaveAnswerResult.answerNotificationList = mutableAnswerNotificationArray;
      saveAnswerResult = mutableSaveAnswerResult;
    } else {
      // Original direct mutation approach for online or non-dedicated mode
      const answerNotificationArray = saveAnswerResult.answerNotificationList || [];
      
      answerNotificationArray.map((notif, notifIndex) => {
        const userList = notif.userList || [];
        userList.map((user, userIndex) => {
            user.email = user.email? user.email :this.entityOwnerInfos?.email?  this.entityOwnerInfos?.email : "" 
            user.userId = user.userId? user.userId : this.entityOwnerInfos?.userId? this.entityOwnerInfos?.userId : "";
            user.phone =  user.phone? user.phone : this.entityOwnerInfos?.phone? this.entityOwnerInfos?.phone : "";
            user.phoneCode = user.phoneCode? user.phoneCode : this.entityOwnerInfos?.phoneCode? this.entityOwnerInfos?.phoneCode : "";
        })
      })
      saveAnswerResult.answerNotificationList = answerNotificationArray;
    }

    if (this.dedicatedMode) {
      this.signOffDetailsPostData = {
        userId,
        formVersionID: signOffFormDetail?.formData?.formVersionID,
        latitude: this.myCurrentGeoLocation?.coords?.latitude,
        longitude: this.myCurrentGeoLocation?.coords?.longitude,
        locationID: this.dedicatedModeLocationUse?.locationID,
        projectID: this.dedicatedModeLocationUse?.projectID,
        inventoryItemID: this.dedicatedModeLocationUse?.inventoryItemID,
      } as SignOffDetailsPostData;

      try {
        //TODO: add any other required score info
        this.signOffDetailsPostData.formScore = this.scoreData.formScore
        this.signOffDetailsPostData.maxFormScore = this.scoreData.formPossibleScore
        const SectionData = []
        for (const section of this.scoreData.sectionScores){
          let maxScore = 0
          let scorePercent = 0
          for (const sectionMax of this.scoreData.sectionPossibleScores){
            if (sectionMax.Id === section.Id){
              maxScore = sectionMax.maxScore
              scorePercent = Math.round((section.score/sectionMax.maxScore)*100)
          }}
          let ShowSectionInPDF = false
          this.formBuilderDetails.sections.forEach(element => {
            if(element.sectionId === section.sectionId){
              ShowSectionInPDF = true
            }
          });
          
          SectionData.push({"FormSection_":[{
            FormVersionID:this.signOffDetailsPostData.formVersionID,
            sectionID: section.Id, 
            isSectionScoreEnabled:this.scoreData.showSectionScoreinPDF,
            MaximumSectionScore:maxScore,
            AchievedSectionScore:section.score,
            PerSectionScore:scorePercent,
            ShowSectionInPDF: ShowSectionInPDF
          }]})
        }
        
        this.signOffDetailsPostData._FormSection = SectionData  
        this.signOffDetailsPostData.formPerScore = this.scoreData.formScorePercent
        this.makeScoresSafe()
      } catch{}
      if (this.offlineMode) {
        // Extract the actual ID from saveAnswerResult
        // saveAnswerResult can be a number (ID) or an object with formSubmitDataId property
        let formSubmitDataId: any = null;
        if (typeof saveAnswerResult === 'number') {
          formSubmitDataId = saveAnswerResult;
        } else if (saveAnswerResult && typeof saveAnswerResult === 'object') {
          formSubmitDataId = saveAnswerResult.formSubmitDataId || saveAnswerResult.id || null;
        }
        this.signOffDetailsPostData.formSubmitDataId = formSubmitDataId;
        this.signOffDetailsPostData.formFilledOffline = true;
        // Store these fields even in offline mode if available (they might be empty)
        // They will be populated from form data during sync if needed
        this.signOffDetailsPostData.formContent = '';
        this.signOffDetailsPostData.answerNotificationList = '';
        this.signOffDetailsPostData.groupUniqueID = '';
        this.signOffDetailsPostData.createdActivityList = [];
      } else {
        this.signOffDetailsPostData.formContent =
          saveAnswerResult.formAnswerHtmlString;
        this.signOffDetailsPostData.answerNotificationList =
          saveAnswerResult.answerNotificationList;
        this.signOffDetailsPostData.groupUniqueID =
          saveAnswerResult.groupUniqueID;

        
        this.signOffDetailsPostData.createdActivityList =
          saveAnswerResult.questionLogicActivityList;
      }
    } else {
      this.signOffDetailsPostData = {
        userId,
        formVersionID: signOffFormDetail?.formData?.formVersionID,
        latitude: this.myCurrentGeoLocation?.coords?.latitude,
        longitude: this.myCurrentGeoLocation?.coords?.longitude,
        locationID: this.currentSelectedCheckinPlace?.locationID || 0,
        projectID: this.currentSelectedCheckinPlace?.projectID || 0,
        inventoryItemID: this.currentSelectedCheckinPlace?.inventoryItemID || 0,
        userCheckInDetailID:
          this.currentSelectedCheckinPlace?.userCheckInDetailID || 0,
        formContent: saveAnswerResult.formAnswerHtmlString,
        answerNotificationList: saveAnswerResult.answerNotificationList,
        groupUniqueID: saveAnswerResult.groupUniqueID,
        createdActivityList: saveAnswerResult.questionLogicActivityList,
      } as SignOffDetailsPostData;
      
      try {
        //TODO: add any other required score info
        this.signOffDetailsPostData.formScore = this.scoreData.formScore
        this.signOffDetailsPostData.maxFormScore = this.scoreData.formPossibleScore
        const SectionData = []
        for (const section of this.scoreData.sectionScores){
          let maxScore = 0
          let scorePercent = 0
          for (const sectionMax of this.scoreData.sectionPossibleScores){
            if (sectionMax.Id === section.Id){
              maxScore = sectionMax.maxScore
              scorePercent = Math.round((section.score/sectionMax.maxScore)*100)
          }}
          SectionData.push({"FormSection_":[{
            FormVersionID:this.signOffDetailsPostData.formVersionID,
            sectionID: section.Id, 
            isSectionScoreEnabled:this.scoreData.showSectionScoreinPDF,
            MaximumSectionScore:maxScore,
            AchievedSectionScore:section.score,
            PerSectionScore:scorePercent,
            FormScore:this.scoreData.formScore,
            MaxFormScore: this.scoreData.formPossibleScore,
            FormPerScore: scorePercent = Math.round((this.scoreData.formScore/this.scoreData.formPossibleScore)*100),
            isShowScoreInPDF: this.scoreData.showTotalScoreInPDF
          }]})
        }
        this.signOffDetailsPostData._FormSection = SectionData        
        this.signOffDetailsPostData.formPerScore = this.scoreData.formScorePercent
        this.makeScoresSafe()
      } catch{}
    }

    if (!this.offlineMode && this.signOffDetailsPostData?.formVersionID) {
      this.signOffDetailsPostData.formSubmittedOnline = true;
    }
    
 
    if (this.viewFormFor === EnumService.ViewFormForType.Activity) {
      this.signOffDetailsPostData.activityIndividualID =
        this.currentActivityOpen?.activityIndividualID;
      if (
        !this.currentSelectedCheckinPlace &&
        signOffFormDetail.entityList.length > 0
      ) {
        const locationItem = signOffFormDetail.entityList[0];
        const entityIds = this.utilService.getRelevantEntityId(
          locationItem?.locationID
        );
        this.signOffDetailsPostData.locationID = entityIds?.LocationID || 0;
        this.signOffDetailsPostData.projectID = entityIds?.ProjectID || 0;
        this.signOffDetailsPostData.inventoryItemID =
          entityIds.InventoryID || 0;
      }
      this.signOffFor = EnumService.SignOffType.FORM_ACTIVITY;
    } else if (
      this.viewFormFor === EnumService.ViewFormForType.CurrentCheckin
    ) {
      this.signOffFor = EnumService.SignOffType.FORM_CURRENT_CHECKIN;
    } else if (
      this.viewFormFor === EnumService.ViewFormForType.CurrentCheckinWorkPermit
    ) {
      this.signOffFor = EnumService.SignOffType.WORKPERMIT_FORM_CURRENT_CHECKIN;
    } else if (this.viewFormFor === EnumService.ViewFormForType.FormDM) {
      this.signOffFor = EnumService.SignOffType.FORMS_DM;
    } else if (this.viewFormFor === EnumService.ViewFormForType.WorkPermitDM) {
      this.signOffFor = EnumService.SignOffType.WORK_PERMIT_DM;
    }

    console.log('[SIGN-OFF ARCHIVE DEBUG] startFormSignOffProcess state:', {
      offlineMode: this.offlineMode,
      dedicatedMode: this.dedicatedMode,
      formFilledOffline: this.signOffDetailsPostData?.formFilledOffline,
      formSubmitDataId: this.signOffDetailsPostData?.formSubmitDataId,
      formVersionID: this.signOffDetailsPostData?.formVersionID,
      hasFormContent: !!this.signOffDetailsPostData?.formContent,
      signOffFor: this.signOffFor,
    });
 
    if (
      signOffFormDetail.formData.isDigitalSignOff ||
      signOffFormDetail.formData.isSignatureSignOff
    ) {
      this.navCtrl.navigateForward(["/signoff-digitalink"]);
    } else if (signOffFormDetail.formData.isPhotoSignOff) {
      if (this.dedicatedMode) {
        this.dedicatedModeCapturePhotoFor =
          EnumService.DedicatedModeCapturePhotoForType.Signoff;
        this.navCtrl.navigateForward(["/checkinout-photoidentity-dm"]);
      } else {
        this.navCtrl.navigateForward(["/signoff-photo"]);
      }
    } else {
      this.submitPersonalModeSignoffData(apiService);
    }
  };
  
  submitInductionCheckInData = async (apiService: ApiService) => {
    const nextScreen = this.dedicatedMode ? "/dashboard-dm" : "/tabs/dashboard";

    const onSuccess = (data) => {
      this.observablesService.publishSomeData(
        EnumService.ObserverKeys.NEW_CHECKED_IN,
        data
      );

      const successScreen = this.dedicatedMode
        ? "/checkinout-success-dm"
        : "/checkin-success";
      this.translateService
        .get([
          "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_HAVE_NOW_CHECKEDIN",
          "SHARED_TEXT.CONTINUE",
        ])
        .subscribe((res) => {
          this.navCtrl.navigateForward([successScreen], {
            queryParams: {
              message:
                res[
                "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_HAVE_NOW_CHECKEDIN"
                ],
              nextPage: nextScreen,
              actionBtnTitle: res["SHARED_TEXT.CONTINUE"],
            },
            replaceUrl: true,
          });
        });
    };

    if (this.offlineMode) {
      const utcDateTime = moment()
        .utc()
        .format(StaticDataService.dateTimeFormat);

      let entityData: any;
      if (this.dedicatedModeLocationUse?.locationID) {
        entityData = await this.offlineManagerService.getDeviceLocationDetail(
          this.dedicatedModeLocationUse?.locationID
        );
      } else if (this.dedicatedModeLocationUse.projectID) {
        entityData = await this.offlineManagerService.getDeviceProjectDetail(
          this.dedicatedModeLocationUse.projectID
        );
      } else if (this.dedicatedModeLocationUse.inventoryItemID) {
        entityData =
          await this.offlineManagerService.getDeviceInventoryItemDetail(
            this.dedicatedModeLocationUse.inventoryItemID
          );
      }

      const dedicatedModeUserDetail: DeviceUserDetail = this
        .dedicatedModeUserDetail as any;

      const checkinData = {
        checkInDate: utcDateTime || "",
        checkInLatitude: this.checkInPostData.checkInLatitude || "",
        checkInLongitude: this.checkInPostData.checkInLongitude || "",
        companyID: this.checkInPostData?.companyID || "",
        currentUTCDate: utcDateTime || "",
        digitalInkSignatureImageVideoFileId:
          this.checkInPostData.digitalInkSignatureImageVideoFileId || "",
        entityName:
          this.dedicatedModeLocationUse.projectName ||
          this.dedicatedModeLocationUse.locationName ||
          this.dedicatedModeLocationUse.itemName ||
          "",
        firstAndLastName:
          dedicatedModeUserDetail?.firstName +
          " " +
          (dedicatedModeUserDetail?.middleName
            ? dedicatedModeUserDetail?.middleName + " "
            : "") +
          dedicatedModeUserDetail?.lastName,
        firstName: dedicatedModeUserDetail?.firstName || "",
        lastName: dedicatedModeUserDetail?.lastName || "",
        isOfflineDone: true,
        isSimultaneousCheckIn: entityData.isSimultaneousCheckIn || false,
        inventoryItemID: this.dedicatedModeLocationUse.inventoryItemID || 0,
        projectID: this.dedicatedModeLocationUse.projectID || 0,
        locationID: this.dedicatedModeLocationUse?.locationID || 0,
        userDetailPhoto: dedicatedModeUserDetail.userPhoto || "",
        userId:
          this.checkInPostData?.userId || StaticDataService.userDefaultGuid,
        userSignaturePhotoImageVideoFileId:
          this.checkInPostData.userSignaturePhotoImageVideoFileId || "",
        locationAutoCheckOutHour: entityData.autoCheckOutHour || "",
        locationAutoCheckOutTime: entityData.autoCheckOutTime || "",
        userAutoCheckOutTime:
          dedicatedModeUserDetail?.userAutoCheckOutTime || "",
        formSubmitDataId: this.checkInPostData?.formSubmitDataId || "",
        processInductionsteps:
          this.checkInDetail?.checkInEntityDetail?.processInduction,
      };

      this.offlineManagerService
        .insertCheckinDetails(checkinData)
        .then((res) => {
          // Remove all form images directory if there was form filled
          try {
            this.filehandlerService
              .removeDirectory(
                this.filehandlerService.offlineFilesDirectory(),
                StaticDataService.formImagesFolderName
              )
              .then(() => { })
              .catch(() => { });
          } catch (error) { }

          if (this.checkInDetail?.checkInEntityDetail?.processInduction) {
            this.insertInductionItemsArchiveRecords(() => {
              this.observablesService.publishSomeData(
                EnumService.ObserverKeys.OFFLINE_DATA_SYNC_NEEDED,
                true
              );
              onSuccess(checkinData);
            });
          } else {
            onSuccess(checkinData);
          }
        })
        .catch((error) => {
          this.processCheckInError(error, nextScreen);
        });
    } else {
      const utcDateTime = moment().utc(false).format("DD.MM.YYYY HH:mm:ss");
      this.utilService.presentLoadingWithOptions();
      this.checkInPostData.signOffDate = utcDateTime;

      apiService.insertCheckInDetails(this.checkInPostData).subscribe(
        (response: Response) => {
          this.utilService.hideLoading();

          // Remove all form images directory if there was form filled
          try {
            this.filehandlerService
              .removeDirectory(
                this.filehandlerService.offlineFilesDirectory(),
                StaticDataService.formImagesFolderName
              )
              .then(() => { })
              .catch(() => { });
          } catch (error) { }

          if (
            response.StatusCode ===
            EnumService.ApiResponseCode.RequestSuccessful
          ) {
            if (
              this.dedicatedMode &&
              this.dedicatedModeLocationUse &&
              this.dedicatedModeUserDetail
            ) {
              const du = this.dedicatedModeUserDetail as any;
              this.offlineManagerService
                .upsertEvacuationAfterOnlineCompanyUserCheckIn({
                  userId: this.checkInPostData?.userId || '',
                  firstName: du?.firstName || '',
                  middleName: du?.middleName || '',
                  lastName: du?.lastName || '',
                  userDetailPhoto: du?.userPhoto || '',
                  userPhoto: du?.userPhoto || '',
                  userPhotoImageVideoFileId:
                    this.checkInPostData?.userSignaturePhotoImageVideoFileId ||
                    0,
                  locationID: this.dedicatedModeLocationUse?.locationID || 0,
                  projectID: this.dedicatedModeLocationUse?.projectID || 0,
                  inventoryItemID:
                    this.dedicatedModeLocationUse?.inventoryItemID || 0,
                })
                .catch(() => {});
              const entityName =
                this.dedicatedModeLocationUse?.locationName ||
                this.dedicatedModeLocationUse?.projectName ||
                (this.dedicatedModeLocationUse as any)?.itemName ||
                '';
              this.offlineManagerService
                .insertCheckinDetailAfterOnlineCheckIn({
                  userId: this.checkInPostData?.userId || '',
                  firstName: du?.firstName || '',
                  middleName: du?.middleName || '',
                  lastName: du?.lastName || '',
                  locationID: this.dedicatedModeLocationUse?.locationID || 0,
                  projectID: this.dedicatedModeLocationUse?.projectID || 0,
                  inventoryItemID:
                    this.dedicatedModeLocationUse?.inventoryItemID || 0,
                  entityName,
                  companyID:
                    (this.dedicatedModeDeviceDetailData?.companyID as number) ||
                    0,
                  checkInDate: utcDateTime,
                })
                .catch(() => {});
            }
            onSuccess(response.Result);
          }
        },
        (error) => {
          this.utilService.hideLoading();
          this.processCheckInError(error, nextScreen);
        }
      );
    }
  };

  private insertInductionItemsArchiveRecords(callBack) {
    // insert form signoff detail to form archive list

    const checkInInductionItems = this.checkInDetail?.checkInInductionItems;
    let insertCount = 0;
    const onRecordInserted = () => {
      if (checkInInductionItems.length === ++insertCount) {
        callBack();
      }
    };

    if (checkInInductionItems && checkInInductionItems.length > 0) {
      checkInInductionItems.forEach((item: InductionItem) => {
        let titlePrepend: string = "";
        switch (item.contentType) {
          case EnumService.InductionContentTypes.VISITOR_AGREEMENT:
            titlePrepend = "Visitor Agreement Sign-Off at";
            break;

          case EnumService.InductionContentTypes.RICH_TEXT:
          case EnumService.InductionContentTypes.VIDEO_FILE:
          case EnumService.InductionContentTypes.IMAGE_FILE:
          case EnumService.InductionContentTypes.FORM:
            titlePrepend = "Induction Sign-Off at";

            break;

          default:
            break;
        }

        let signedByName = "";
        if (this.checkinoutDmAs === EnumService.CheckInType.AS_GUEST) {
          signedByName =
            (this.dedicatedModeGuestDetail.guestFirsName || "") +
            " " +
            (this.dedicatedModeGuestDetail.guestMiddleName
              ? this.dedicatedModeGuestDetail.guestMiddleName + " "
              : "") +
            (this.dedicatedModeGuestDetail.guestLastName || "");
        } else {
          signedByName =
            (this.dedicatedModeUserDetail.firstName || "") +
            " " +
            (this.dedicatedModeUserDetail.middleName
              ? this.dedicatedModeUserDetail.middleName + " "
              : "") +
            (this.dedicatedModeUserDetail.lastName || "");
        }

        const inductionTitle =
          titlePrepend +
          " " +
          (this.dedicatedModeLocationUse.itemName ||
            this.dedicatedModeLocationUse.projectName ||
            this.dedicatedModeLocationUse.locationName) +
          " by " +
          signedByName;
        const createdDateStr = UtilService.todayCompanyDate(
          this.offlineManagerService.offlineDeviceDetailData.timeDifference,
          false
        ).format(StaticDataService.dateTimeFormatForDb);

        const archiveData = {
          documentID: item.checkInInductionItemID,
          documentTitle: inductionTitle,
          documentFileName: "",
          createdDate: createdDateStr,
          formattedCreatedDate: "",
          todayDate: "",
          documentFileIconURL: "",
          documentFileFormat: "",
          timeDifference: "",
          inventoryItemID: this.dedicatedModeLocationUse?.inventoryItemID,
          signedByName: signedByName,
          locationID: this.dedicatedModeLocationUse?.locationID,
          projectID: this.dedicatedModeLocationUse?.projectID,
          formSubmitDataId: (this.checkInPostData?.formSubmitDataId && Array.isArray(this.checkInPostData.formSubmitDataId) && this.checkInPostData.formSubmitDataId.length > 0) 
            ? this.checkInPostData.formSubmitDataId[this.checkInPostData.formSubmitDataId.length - 1] 
            : 0,
          signOffDetailId: 0,
        };

        if (item.contentType === EnumService.InductionContentTypes.FORM) {
          this.offlineManagerService
            .insertDeviceArchivedForms(archiveData)
            .then((res) => {
              onRecordInserted();
            })
            .catch(() => {
              onRecordInserted();
            });
        } else {
          this.offlineManagerService
            .insertDeviceArchivedDocuments(archiveData)
            .then((res) => {
              onRecordInserted();
            })
            .catch(() => {
              onRecordInserted();
            });
        }
      });
    } else {
      callBack();
    }
  }

  submitInductionCheckInDataGuest = async (apiService: ApiService) => {
    const nextScreen = this.dedicatedMode ? "/dashboard-dm" : "/tabs/dashboard";

    const onSuccess = () => {
      this.translateService
        .get([
          "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_HAVE_NOW_CHECKEDIN",
          "SHARED_TEXT.CONTINUE",
        ])
        .subscribe((res) => {
          this.navCtrl.navigateForward(["/checkinout-success-dm"], {
            queryParams: {
              message:
                res[
                "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_HAVE_NOW_CHECKEDIN"
                ],
              nextPage: nextScreen,
              actionBtnTitle: res["SHARED_TEXT.CONTINUE"],
            },
            replaceUrl: true,
          });
        });
    };

    if (this.offlineMode) {
      const utcDateTime = moment()
        .utc()
        .format(StaticDataService.dateTimeFormat);
      this.checkInPostData.signOffDate = utcDateTime;

      let entityData: any;
      if (this.dedicatedModeLocationUse?.locationID) {
        entityData = await this.offlineManagerService.getDeviceLocationDetail(
          this.dedicatedModeLocationUse?.locationID
        );
      } else if (this.dedicatedModeLocationUse.projectID) {
        entityData = await this.offlineManagerService.getDeviceProjectDetail(
          this.dedicatedModeLocationUse.projectID
        );
      } else if (this.dedicatedModeLocationUse.inventoryItemID) {
        entityData =
          await this.offlineManagerService.getDeviceInventoryItemDetail(
            this.dedicatedModeLocationUse.inventoryItemID
          );
      }

      const checkinData = {
        checkInDate: utcDateTime || "",
        checkInLatitude: this.checkInPostData.checkInLatitude || "",
        checkInLongitude: this.checkInPostData.checkInLongitude || "",
        companyID: this.checkInPostData?.companyID || "",
        currentUTCDate: utcDateTime || "",
        digitalInkSignatureImageVideoFileId:
          this.checkInPostData.digitalInkSignatureImageVideoFileId || "",
        userSignaturePhotoImageVideoFileId:
          this.checkInPostData.userSignaturePhotoImageVideoFileId || "",
        entityName:
          this.dedicatedModeLocationUse.projectName ||
          this.dedicatedModeLocationUse.locationName ||
          this.dedicatedModeLocationUse.itemName ||
          "",
        guestPhone: this.checkInPostData.guestPhone.toString() || "",
        guestFirsName: this.checkInPostData.guestFirsName || "",
        guestLastName: this.checkInPostData.guestLastName || "",
        guestMiddleName: this.checkInPostData.guestMiddleName || "",
        guestPhotoImageVideoFileId:
          this.dedicatedModeGuestDetail.guestPhotoImageVideoFileId || "",
        isOfflineDone: true,
        isGuestReturning: this.checkInPostData.isGuestReturning || false,
        isSimultaneousCheckIn: entityData.isSimultaneousCheckIn || false,
        inventoryItemID: this.dedicatedModeLocationUse.inventoryItemID || 0,
        projectID: this.dedicatedModeLocationUse.projectID || 0,
        locationID: this.dedicatedModeLocationUse?.locationID || 0,
        locationAutoCheckOutHour: entityData.autoCheckOutHour || "",
        locationAutoCheckOutTime: entityData.autoCheckOutTime || "",
        formSubmitDataId: this.checkInPostData?.formSubmitDataId || "",
        processInductionsteps:
          this.checkInDetail?.checkInEntityDetail?.processInduction,
      };

      this.offlineManagerService
        .insertGuestCheckinDetails(checkinData)
        .then((res) => {
          if (this.checkInDetail?.checkInEntityDetail?.processInduction) {
            this.insertInductionItemsArchiveRecords(() => {
              this.observablesService.publishSomeData(
                EnumService.ObserverKeys.OFFLINE_DATA_SYNC_NEEDED,
                true
              );
              onSuccess();
            });
          } else {
            onSuccess();
          }
        })
        .catch((error) => {
          this.processCheckInError(error, nextScreen);
        });
    } else {
      const utcDateTime = moment().utc().format("DD.MM.YYYY HH:mm:ss");
      this.checkInPostData.signOffDate = utcDateTime;

      this.utilService.presentLoadingWithOptions();
      apiService.insertCheckInDetailsGuest(this.checkInPostData).subscribe(
        (response: Response) => {
          this.utilService.hideLoading();

          // Remove all form images directory if there was form filled
          try {
            this.filehandlerService
              .removeDirectory(
                this.filehandlerService.offlineFilesDirectory(),
                StaticDataService.formImagesFolderName
              )
              .then(() => { })
              .catch(() => { });
          } catch (error) { }

          if (
            response.StatusCode ===
            EnumService.ApiResponseCode.RequestSuccessful
          ) {
            if (
              this.dedicatedMode &&
              this.dedicatedModeLocationUse &&
              this.dedicatedModeGuestDetail
            ) {
              const g = this.dedicatedModeGuestDetail;
              console.log('[EVAC] checkin:online | name:', (g?.guestFirsName || '') + ' ' + (g?.guestLastName || ''), '| phone:', g?.guestPhone, '| locationID:', this.dedicatedModeLocationUse?.locationID)
              this.offlineManagerService
                .upsertEvacuationAfterOnlineGuestCheckIn({
                  guestFirsName: g?.guestFirsName || '',
                  guestMiddleName: g?.guestMiddleName || '',
                  guestLastName: g?.guestLastName || '',
                  guestPhotoImageVideoFileId: g?.guestPhotoImageVideoFileId || 0,
                  locationID: this.dedicatedModeLocationUse?.locationID || 0,
                  projectID: this.dedicatedModeLocationUse?.projectID || 0,
                  inventoryItemID:
                    this.dedicatedModeLocationUse?.inventoryItemID || 0,
                })
                .catch(() => {});
              const guestEntityName =
                this.dedicatedModeLocationUse?.locationName ||
                this.dedicatedModeLocationUse?.projectName ||
                (this.dedicatedModeLocationUse as any)?.itemName ||
                '';
              this.offlineManagerService
                .insertGuestCheckinDetailAfterOnlineCheckIn({
                  guestPhone: g?.guestPhone,
                  guestFirsName: g?.guestFirsName || '',
                  guestMiddleName: g?.guestMiddleName || '',
                  guestLastName: g?.guestLastName || '',
                  locationID: this.dedicatedModeLocationUse?.locationID || 0,
                  projectID: this.dedicatedModeLocationUse?.projectID || 0,
                  inventoryItemID:
                    this.dedicatedModeLocationUse?.inventoryItemID || 0,
                  entityName: guestEntityName,
                  companyID:
                    (this.dedicatedModeDeviceDetailData?.companyID as number) ||
                    0,
                  checkInDate: utcDateTime,
                })
                .catch(() => {});
              this.offlineManagerService
                .insertGuestUserAfterOnlineCheckIn({
                  guestPhone: g?.guestPhone,
                  guestFirsName: g?.guestFirsName || '',
                  guestMiddleName: g?.guestMiddleName || '',
                  guestLastName: g?.guestLastName || '',
                  guestPhoto: g?.guestPhotoImageVideoFileId ? String(g.guestPhotoImageVideoFileId) : '',
                })
                .catch(() => {});
            }
            onSuccess();
          }
        },
        (error) => {
          this.utilService.hideLoading();
          this.processCheckInError(error, nextScreen);
        }
      );
    }
  };

  processCheckInError = (error, nextScreen) => {
    const exception = error.error as Response;
    const failScreen = this.dedicatedMode
      ? "/checkinout-fail-dm"
      : "/checkin-fail";
    if (exception?.ResponseException?.ValidationErrors?.length > 0) {
      const fieldsInfo =
        exception.ResponseException.ValidationErrors[0].Field.split("#");
      const fieldName = fieldsInfo[0];
      const message = exception.ResponseException.ValidationErrors[0].Message;

      if (fieldName === "SimultaneousCheckIn") {
        const locationName = message.match(/\'(.*)\'/).pop();
        this.navCtrl.navigateForward(["/checkinout-alreadycheckin-dm"], {
          queryParams: {
            locationName,
            locationId: fieldsInfo[1],
          },
          replaceUrl: true,
        });
      } else if (fieldName === "Location" && fieldsInfo.length > 1) {
        const locationName = this.getCurrentCheckedInEntityName();
        this.navCtrl.navigateForward(["/checkinout-alreadycheckin-dm"], {
          queryParams: {
            isAlreadyCheckedInSameLocation: 1,
            locationName,
            locationId: fieldsInfo[1],
          },
          replaceUrl: true,
        });
      } else if (fieldName === "Qualification") {
        this.translateService
          .get([
            "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_CANNOT_CHECKIN",
            "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.NO_QUALIFICATION",
            "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_DO_NOT_HAVE_THE_REQUIRED_QUALIFICATIONS",
          ])
          .subscribe((res) => {
            this.navCtrl.navigateForward([failScreen], {
              queryParams: {
                title:
                  res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_CANNOT_CHECKIN"],
                errorTitle:
                  res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.NO_QUALIFICATION"],
                errorMessage:
                  res[
                  "PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_DO_NOT_HAVE_THE_REQUIRED_QUALIFICATIONS"
                  ],
                nextPage: nextScreen,
              },
              replaceUrl: true,
            });
          });
      } else {
        this.translateService
          .get("PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_CANNOT_CHECKIN")
          .subscribe((res) => {
            this.navCtrl.navigateForward([failScreen], {
              queryParams: {
                title: res,
                errorTitle: fieldName,
                errorMessage: message,
                nextPage: nextScreen,
              },
              replaceUrl: true,
            });
          });
      }
    } else {
      this.translateService
        .get(["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_CANNOT_CHECKIN"])
        .subscribe((res) => {
          this.navCtrl.navigateForward([failScreen], {
            queryParams: {
              title:
                res["PAGESPECIFIC_TEXT.CHECK_IN_AND_OUT.YOU_CANNOT_CHECKIN"],
              errorTitle: "",
              errorMessage:
                exception?.ResponseException?.ExceptionMessage ||
                exception?.Message,
              nextPage: nextScreen,
            },
            replaceUrl: true,
          });
        });
    }
  };

  /**
   * This function is use for submit personal mode sign off data
   */
  submitPersonalModeSignoffData = async (apiService: ApiService) => {
    const checkInSuccessPage = this.dedicatedMode
      ? "/checkinout-success-dm"
      : "/checkin-success";
    const checkInFailPage = this.dedicatedMode
      ? "/checkinout-fail-dm"
      : "/checkin-fail";
    let nextPage = this.dedicatedMode ? "dashboard-dm" : "/tabs/dashboard";

    const isWorkPermitCurrentCheckin =
      this.signOffFor ===
      EnumService.SignOffType.WORKPERMIT_FORM_CURRENT_CHECKIN ||
      this.signOffFor === EnumService.SignOffType.WORK_PERMIT_DM;
    const isworkPermitActivity =
      this.signOffFor === EnumService.SignOffType.FORM_ACTIVITY &&
      this.signOffFormDetail?.formData?.formType ===
      EnumService.FormTypes.WORK_PERMIT;

    if (this.dedicatedMode) {
      switch (this.dedicatedModeProcessType) {
        case EnumService.DedicatedModeProcessTypes.Document:
          nextPage = "documents-dm";
          break;
        case EnumService.DedicatedModeProcessTypes.Form:
          nextPage = "forms-dm";
          break;
        case EnumService.DedicatedModeProcessTypes.WorkPermit:
          nextPage = "permits-dm";
          break;
      }
    } else {
      if (isWorkPermitCurrentCheckin) {
        nextPage = "/tabs/current-checkin/checkin-workpermit";
      } else if (isworkPermitActivity) {
        nextPage = "/tabs/dashboard";
      }
    }

    const checkInSuccessController = () => {
      if (this.dedicatedMode && this.offlineMode) {
        const todayDate = UtilService.todayCompanyDate(
          this.offlineManagerService.offlineDeviceDetailData
            .timeDifference
        );

        const todayDateTime = UtilService.todayCompanyDate(
          this.offlineManagerService.offlineDeviceDetailData
            .timeDifference,
          false
        );

        const dateTimeNow = todayDateTime.format(
          StaticDataService.dateTimeFormat
        );

        let expiryDate;
        if (
          this.formBuilderDetails?.workPermitDetails
            ?.whoDefinesDateType === "UserDefined"
        ) {
          const hasExpiresOn = this.workPermitAnswer.hasExpiresOn;
          const hasExpiresAfter = this.workPermitAnswer.hasExpiresAfter;
          expiryDate = moment(todayDate).add(60, "days");
          if (hasExpiresAfter) {
            const durations = ["days", "weeks", "months", "years"];
            const unit: any =
              durations[this.workPermitAnswer.durationTypeID - 1];
            expiryDate = moment(todayDate).add(
              this.workPermitAnswer.durationValue,
              unit
            );
          } else if (hasExpiresOn) {
            expiryDate = moment(
              UtilService.fixTimeString(
                this.workPermitAnswer.expiresOnDate
              ),
              StaticDataService.dateTimeFormat
            );
          }
        } else {
          const workPermitDetail =
            this.formBuilderDetails?.workPermitDetails;
          const hasExpiresOn = workPermitDetail.hasExpiresOn;
          const hasExpiresAfter = workPermitDetail.hasExpiresAfter;
          expiryDate = moment(todayDate).add(60, "days");
          if (hasExpiresAfter) {
            const durations = ["days", "weeks", "months", "years"];
            const unit: any =
              durations[workPermitDetail.durationTypeID - 1];
            expiryDate = moment(todayDate).add(
              workPermitDetail.durationValue,
              unit
            );
          } else if (hasExpiresOn) {
            expiryDate = moment(
              workPermitDetail.expiresOnDate,
              "DD/MM/YYYY"
            );
          }
        }

        const permitData = {
          locationID: this.dedicatedModeLocationUse?.locationID,
          projectID: this.dedicatedModeLocationUse.projectID,
          inventoryItemID: this.dedicatedModeLocationUse.inventoryItemID,
          expiryDate: expiryDate.format(
            StaticDataService.dateTimeFormatForDb
          ),
          firstName: this.dedicatedModeUserDetail.firstName,
          formTitle: this.formBuilderDetails.title,
          formattedExpiryDate: "",
          formattedIssuedDate: "",
          issuedDate: dateTimeNow,
          lastName: this.dedicatedModeUserDetail.lastName,
          middleName: this.dedicatedModeUserDetail.middleName,
          photo: this.dedicatedModeUserDetail.photo,
          timeDifference: "",
          todayDate: dateTimeNow,
          isOfflineDone: true,
        };
        this.offlineManagerService.insertLiveWorkPermit(permitData);
      }

      if(this.isReviewal){
  this.translateService
        .get([
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.WAITING_REVIEW",
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.PERMIT_WAITING_REVIEW",
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.YOUR_WORK_PERMIT_IS_WAITING_REVIEW",
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.WORK_PERMIT",
        ])
        .subscribe((res) => {
          this.navCtrl.navigateForward([checkInSuccessPage], {
            queryParams: {
              title:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.WAITING_REVIEW"
                ],
              message:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.PERMIT_WAITING_REVIEW"
                ],
              description:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.YOUR_WORK_PERMIT_IS_WAITING_REVIEW"
                ],
              nextPage,
              pageTitle:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.WORK_PERMIT"
                ],
            },
            replaceUrl: true,
          });
        });
}else{
  this.translateService
        .get([
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.PASSED",
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.PERMIT_ISSUED",
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.YOUR_WORK_PERMIT_IS_ACTIVE",
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.WORK_PERMIT",
        ])
        .subscribe((res) => {
          this.navCtrl.navigateForward([checkInSuccessPage], {
            queryParams: {
              title:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.PASSED"
                ],
              message:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.PERMIT_ISSUED"
                ],
              description:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.YOUR_WORK_PERMIT_IS_ACTIVE"
                ],
              nextPage,
              pageTitle:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.WORK_PERMIT"
                ],
            },
            replaceUrl: true,
          });
        });
}
    }

    const checkInFailController = () => {
      this.translateService
        .get([
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NOT_PASSED",
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NO_PERMIT",
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NOT_ELIGIBLE_FOR_WORK_PERMIT",
          "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.WORK_PERMIT",
        ])
        .subscribe((res) => {
          this.navCtrl.navigateForward([checkInFailPage], {
            queryParams: {
              title:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NOT_PASSED"
                ],
              errorTitle:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NO_PERMIT"
                ],
              errorMessage:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NOT_ELIGIBLE_FOR_WORK_PERMIT"
                ],
              nextPage,
              pageTitle:
                res[
                "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.WORK_PERMIT"
                ],
            },
            replaceUrl: true,
          });
        });
    }

    const onSuccessCallBack = async (status, errorMessage = "") => {
      if (status) {
        this.clearRelaunchStateAfterSignoff();
        if (
          this.signOffFor === EnumService.SignOffType.FORM_ACTIVITY ||
          this.signOffFor === EnumService.SignOffType.DOCUMENT_ACTIVITY
        ) {
          this.removeSavedFormStateForActivity(
            this.viewFormForActivityId,
            () => { }
          );
          this.observablesService.publishSomeData(
            EnumService.ObserverKeys.ACTIVITY_COMPLETED,
            true
          );
        }

        // show work permit issue success/fail for work permit type form filled from current checkin or activity list

        if (isWorkPermitCurrentCheckin || isworkPermitActivity) {
          if(typeof(this.workPermitAnswer.scoreAchieved) === "string" && this.workPermitAnswer.scoreAchieved === "/"){
            this.workPermitAnswer.scoreAchieved = 0
          }  
          //console.log(this.workPermitAnswer.scoreAchieved, this.workPermitAnswer.totalScore, typeof(this.workPermitAnswer.scoreAchieved), typeof(this.workPermitAnswer.totalScore))
          switch (this.workPermitAnswer.operatorTypeID) {
            case EnumService.QuestionLogic.OtherValueOperationType.GreaterThen:
              this.workPermitAnswer.scoreAchieved > this.workPermitAnswer.totalScore ? checkInSuccessController() : checkInFailController()
              break;
            case EnumService.QuestionLogic.OtherValueOperationType.GreaterThenEqualTo:
              this.workPermitAnswer.scoreAchieved >= this.workPermitAnswer.totalScore ? checkInSuccessController() : checkInFailController()
              break;
            case EnumService.QuestionLogic.OtherValueOperationType.LessThen:
              this.workPermitAnswer.scoreAchieved < this.workPermitAnswer.totalScore ? checkInSuccessController() : checkInFailController()
              break;
            case EnumService.QuestionLogic.OtherValueOperationType.LessThenEqualTo:
              this.workPermitAnswer.scoreAchieved <= this.workPermitAnswer.totalScore ? checkInSuccessController() : checkInFailController()
              break;
            case EnumService.QuestionLogic.OtherValueOperationType.EqualTo:
              Number(this.workPermitAnswer.scoreAchieved) === this.workPermitAnswer.totalScore ? checkInSuccessController() : checkInFailController()
              break;
            case EnumService.QuestionLogic.OtherValueOperationType.NotEqualTo:
              this.workPermitAnswer.scoreAchieved != this.workPermitAnswer.totalScore ? checkInSuccessController() : checkInFailController()
              break;
            default:
              break;
          }
        } else {
          this.translateService
            .get([
              "PAGESPECIFIC_TEXT.SIGN_OFF.YOU_SIGNOFF_OFF_SUCCESSFULLY",
              "PAGESPECIFIC_TEXT.SIGN_OFF.SIGNOFF",
            ])
            .subscribe((res) => {
              this.navCtrl.navigateForward([checkInSuccessPage], {
                queryParams: {
                  message:
                    res[
                    "PAGESPECIFIC_TEXT.SIGN_OFF.YOU_SIGNOFF_OFF_SUCCESSFULLY"
                    ],
                  nextPage,
                  pageTitle: res["PAGESPECIFIC_TEXT.SIGN_OFF.SIGNOFF"],
                },
              });
            });
        }
      } else {
        if (isWorkPermitCurrentCheckin || isworkPermitActivity) {
          this.translateService
            .get([
              "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NOT_PASSED",
              "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NO_PERMIT",
              "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NOT_ELIGIBLE_FOR_WORK_PERMIT",
              "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.WORK_PERMIT",
            ])
            .subscribe((res) => {
              this.navCtrl.navigateForward([checkInFailPage], {
                queryParams: {
                  title:
                    res[
                    "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NOT_PASSED"
                    ],
                  errorTitle:
                    res[
                    "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NO_PERMIT"
                    ],
                  errorMessage:
                    res[
                    "PAGESPECIFIC_TEXT.FORM_LIST.SPECIFIC_FORMS.WORK_PERMIT_FORM.NOT_ELIGIBLE_FOR_WORK_PERMIT"
                    ],
                  nextPage,
                  pageTitle:
                    res["PAGESPECIFIC_TEXT.PAGESPECIFIC_TEXT.FORM_LIST"],
                },
                replaceUrl: true,
              });
            });
        } else {
          this.translateService
            .get([
              "PAGESPECIFIC_TEXT.SIGN_OFF.YOU_CANNOT_SIGNOFF",
              "PAGESPECIFIC_TEXT.SIGN_OFF.NOT_QUALIFIED",
              "PAGESPECIFIC_TEXT.SIGN_OFF.SIGNOFF",
            ])
            .subscribe((res) => {
              this.navCtrl.navigateForward([checkInFailPage], {
                queryParams: {
                  title: res["PAGESPECIFIC_TEXT.SIGN_OFF.YOU_CANNOT_SIGNOFF"],
                  errorTitle: res["PAGESPECIFIC_TEXT.SIGN_OFF.NOT_QUALIFIED"],
                  errorMessage: errorMessage,
                  nextPage,
                  pageTitle: res["PAGESPECIFIC_TEXT.SIGN_OFF.SIGNOFF"],
                },
                replaceUrl: true,
              });
            });
        }
      }
    };

    const onErrorCallBack = (error) => {
      this.translateService
        .get([
          "PAGESPECIFIC_TEXT.SIGN_OFF.YOU_CANNOT_SIGNOFF",
          "PAGESPECIFIC_TEXT.SIGN_OFF.SIGNOFF",
        ])
        .subscribe((res) => {
          this.navCtrl.navigateForward([checkInFailPage], {
            queryParams: {
              title: res["PAGESPECIFIC_TEXT.SIGN_OFF.YOU_CANNOT_SIGNOFF"],
              errorTitle: "",
              errorMessage: error.message || error,
              nextPage,
              pageTitle: res["PAGESPECIFIC_TEXT.SIGN_OFF.SIGNOFF"],
            },
            replaceUrl: true,
          });
        });
    };

    const useOfflinePath = this.offlineMode || !!this.signOffDetailsPostData?.formFilledOffline;
    console.log('[SIGN-OFF ARCHIVE DEBUG] submitPersonalModeSignoffData path:', {
      useOfflinePath,
      offlineMode: this.offlineMode,
      formFilledOffline: this.signOffDetailsPostData?.formFilledOffline,
      formSubmitDataId: this.signOffDetailsPostData?.formSubmitDataId,
      formVersionID: this.signOffDetailsPostData?.formVersionID,
      documentID: this.signOffDetailsPostData?.documentID,
      hasFormContent: !!this.signOffDetailsPostData?.formContent,
    });
    if (useOfflinePath) {
      const utcDateTime = moment()
        .utc()
        .format(StaticDataService.dateTimeFormatForDb);
      this.signOffDetailsPostData.signOffDate = utcDateTime;

      const signOffData: any = {
        userId:
          this.signOffDetailsPostData?.userId ||
          StaticDataService.userDefaultGuid,
        documentID: this.signOffDetailsPostData.documentID || 0,
        documentVersionID: this.signOffDetailsPostData.documentVersionID || 0,
        formVersionID: this.signOffDetailsPostData.formVersionID || 0,
        latitude: this.signOffDetailsPostData.latitude || "",
        longitude: this.signOffDetailsPostData.longitude || "",
        locationID: this.signOffDetailsPostData?.locationID || 0,
        projectID: this.signOffDetailsPostData.projectID || 0,
        inventoryItemID: this.signOffDetailsPostData.inventoryItemID || 0,
        signOffDate: this.signOffDetailsPostData.signOffDate || "",
        digitalInkSignatureImageVideoFileId:
          this.signOffDetailsPostData.digitalInkSignatureImageVideoFileId || "",
        userSignaturePhotoImageVideoFileId:
          this.signOffDetailsPostData.userSignaturePhotoImageVideoFileId || "",
          formSubmitDataId: this.signOffDetailsPostData.formSubmitDataId || "",
          idempotencyKey: this.signOffDetailsPostData.idempotencyKey || crypto.randomUUID(),
      };

      const isHybridOnlineFormSignOff =
        !!this.signOffDetailsPostData?.formSubmittedOnline &&
        !this.signOffDetailsPostData?.formFilledOffline;
      if (isHybridOnlineFormSignOff) {
        signOffData.formSubmittedOnline = 1;
        signOffData.signOffPayload = JSON.stringify({
          formContent: this.signOffDetailsPostData.formContent || "",
          answerNotificationList:
            this.signOffDetailsPostData.answerNotificationList || [],
          groupUniqueID: this.signOffDetailsPostData.groupUniqueID || "",
          createdActivityList:
            this.signOffDetailsPostData.createdActivityList || [],
          formScore: this.signOffDetailsPostData.formScore ?? 0,
          maxFormScore: this.signOffDetailsPostData.maxFormScore ?? 0,
          formPerScore: this.signOffDetailsPostData.formPerScore ?? 0,
          _FormSection: this.signOffDetailsPostData._FormSection || [],
        });
      }

      // Network-cut fallback: save full payload snapshot so sync can replay without saveFormAnswers
      if ((this.signOffDetailsPostData as any)._isNetworkCutFallback && this._networkCutPayloadJson) {
        signOffData.fullPayloadJson = this._networkCutPayloadJson;
        delete (this.signOffDetailsPostData as any)._isNetworkCutFallback;
        this._networkCutPayloadJson = null;
        console.log('[SIGN-OFF ARCHIVE DEBUG] Network-cut fallback — saved fullPayloadJson to SignOffDetails');
      }

      console.log('[SIGN-OFF ARCHIVE DEBUG] inserting SignOffDetails:', signOffData);

      this.offlineManagerService
        .insertSignOffDetail(signOffData)
        .then((res) => {
          const signOffDetailId = res?.insertId || res;
          console.log('[SIGN-OFF ARCHIVE DEBUG] SignOffDetails inserted:', {
            signOffDetailId,
            formSubmitDataId: signOffData.formSubmitDataId,
            formVersionID: signOffData.formVersionID,
          });

          this.observablesService.publishSomeData(
            EnumService.ObserverKeys.OFFLINE_DATA_SYNC_NEEDED,
            true
          );

          // Remove all form images directory if there was form filled
          try {
            this.filehandlerService
              .removeDirectory(
                this.filehandlerService.offlineFilesDirectory(),
                StaticDataService.formImagesFolderName
              )
              .then(() => { })
              .catch(() => { });
          } catch (error) { }

          //Add sign off form/document in archive list

          if (!this.offlineManagerService.offlineDeviceDetailData) {
            console.warn(
              '[SIGN-OFF ARCHIVE DEBUG] Skipping archive insert — offlineDeviceDetailData is missing'
            );
            onSuccessCallBack(true);
            return;
          }

          const createdDateStr = UtilService.todayCompanyDate(
            this.offlineManagerService.offlineDeviceDetailData.timeDifference,
            false
          ).format(StaticDataService.dateTimeFormatForDb);
          const signedByName =
            (this.dedicatedModeUserDetail.firstName || "") +
            " " +
            (this.dedicatedModeUserDetail.middleName
              ? this.dedicatedModeUserDetail.middleName + " "
              : "") +
            (this.dedicatedModeUserDetail.lastName || "");

          if (this.signOffDetailsPostData.documentID) {
            const documentDetail: any = this.signOffDocumentDetail;

            const documentTitle =
              "Document Sign-Off for " +
              documentDetail?.documentTitle +
              " by " +
              signedByName;

            const archiveDocumentData = {
              documentID: this.signOffDetailsPostData.documentID,
              documentTitle: documentTitle,
              documentFileName: "",
              createdDate: createdDateStr,
              formattedCreatedDate: "",
              timeDifference: "",
              todayDate: "",
              signedByName: signedByName,
              inventoryItemID: this.signOffDetailsPostData.inventoryItemID || 0,
              locationID: this.signOffDetailsPostData.locationID || 0,
              projectID: this.signOffDetailsPostData.projectID || 0,
              signOffDetailId: signOffDetailId || 0,
            };
            this.offlineManagerService
              .insertDeviceArchivedDocuments(archiveDocumentData)
              .then(() => {
                onSuccessCallBack(true);
              })
              .catch((err) => {
                console.error('insertDeviceArchivedDocuments failed:', err);
              });
          } else if (this.signOffDetailsPostData.formVersionID) {
            const formBuilderDetails: any = this.formBuilderDetails;

            const formTitle =
              "Form Sign-Off for " +
              formBuilderDetails.title +
              " by " +
              signedByName;

            const archiveFormData = {
              createdDate: createdDateStr,
              documentID: formBuilderDetails.formId,
              documentTitle: formTitle,
              formattedCreatedDate: "",
              timeDifference: "",
              todayDate: "",
              signedByName: signedByName,
              inventoryItemID: this.dedicatedModeLocationUse?.inventoryItemID || 0,
              locationID: this.dedicatedModeLocationUse?.locationID || 0,
              projectID: this.dedicatedModeLocationUse?.projectID || 0,
              formSubmitDataId: this.signOffDetailsPostData.formSubmitDataId || 0,
              signOffDetailId: signOffDetailId || 0,
            };
            console.log('[SIGN-OFF ARCHIVE DEBUG] inserting DeviceArchivedForms:', archiveFormData);
            this.offlineManagerService
              .insertDeviceArchivedForms(archiveFormData)
              .then(() => {
                console.log('[SIGN-OFF ARCHIVE DEBUG] DeviceArchivedForms insert succeeded');
                onSuccessCallBack(true);
              })
              .catch((err) => {
                console.error('insertDeviceArchivedForms failed:', err);
              });
            } else {
            console.warn('[SIGN-OFF ARCHIVE DEBUG] No archive insert — neither documentID nor formVersionID set:', {
              documentID: this.signOffDetailsPostData.documentID,
              formVersionID: this.signOffDetailsPostData.formVersionID,
            });
            }
        }).catch((err) => {
          console.error('[SIGN-OFF ARCHIVE DEBUG] insertSignOffDetail failed:', err);
        });
    } else {
      const utcDateTime = moment().utc().format("DD.MM.YYYY HH:mm:ss");
      this.signOffDetailsPostData.signOffDate = utcDateTime;
      if (this.currentInformSignaturesData.length > 0) {
        this.signOffDetailsPostData.inFormSignatureSignoffList = this.currentInformSignaturesData;
        setTimeout(() => {
          this.currentInformSignaturesData = [];
        }, 500);
      }
      this.utilService.presentLoadingWithOptions();

      //Scoring safety checks
        this.makeScoresSafe()
      // Generate idempotency key before the call so it is shared by both the live attempt and any sync replay
      if (!this.signOffDetailsPostData.idempotencyKey) {
        this.signOffDetailsPostData.idempotencyKey = crypto.randomUUID();
      }
      const liveIdempotencyHeader = `InsertPersonalModeSignOffDetails_${this.signOffDetailsPostData.userId}_${this.signOffDetailsPostData.idempotencyKey}`;
      // Snapshot the full payload before the API call so we can save it on network failure
      try {
        this._networkCutPayloadJson = JSON.stringify(this.signOffDetailsPostData);
      } catch (e) {
        this._networkCutPayloadJson = null;
      }
      apiService
        .insertPersonalModeSignOffDetails(this.signOffDetailsPostData, { 'x-idempotency-key': liveIdempotencyHeader })
        .subscribe(
          (response: Response) => {
            this._networkCutPayloadJson = null;
            this.utilService.hideLoading();

            // Remove all form images directory if there was form filled
            try {
              this.filehandlerService
                .removeDirectory(
                  this.filehandlerService.offlineFilesDirectory(),
                  StaticDataService.formImagesFolderName
                )
                .then(() => { })
                .catch(() => { });
            } catch (error) { }

            if (
              response.StatusCode ===
              EnumService.ApiResponseCode.RequestSuccessful
            ) {
              this.formattedId = response.Result.formatId;
              this.isReviewal = response.Result.isReviewal;
              this.isFormattedId = true;
              onSuccessCallBack(true);
            } else {
              onSuccessCallBack(false, response.Message);
            }
            this.scoreData = {}
          },
          (error) => {
            this.scoreData = {}
            this.utilService.hideLoading();
            if (error.status === 0) {
              // Network lost mid-request — save full payload so sync can replay without saveFormAnswers
              this.signOffDetailsPostData.formFilledOffline = true;
              (this.signOffDetailsPostData as any)._isNetworkCutFallback = true;
              this.submitPersonalModeSignoffData(apiService);
            } else {
              this._networkCutPayloadJson = null;
              onErrorCallBack(error);
            }
          }
        );
    }
  };
  makeScoresSafe(){
      if(this.signOffDetailsPostData.formPerScore === undefined || this.signOffDetailsPostData.formPerScore.toString().toUpperCase() == "NAN"){
          this.signOffDetailsPostData.formPerScore = 0
        }
      if(this.signOffDetailsPostData._FormSection != undefined){
      for(const section of this.signOffDetailsPostData._FormSection as any){
          if(this.scoreData.enabled){
            if(section.FormSection_[0].PerSectionScore === undefined ||section.FormSection_[0].PerSectionScore.toString().toUpperCase() == "NAN"){
              section.FormSection_[0].PerSectionScore = 0
            }
            if(section.FormSection_[0].FormPerScore === undefined ||section.FormSection_[0].toString().toUpperCase() == "NAN"){
            section.FormSection_[0].FormPerScore = 0
            }
            if(section.FormSection_[0].FormScore === undefined ||section.FormSection_[0].FormScore.toString().toUpperCase() == "NAN"){
              section.FormSection_[0].FormScore = 0
            }
            if(section.FormSection_[0].MaxFormScore === undefined || section.FormSection_[0].MaxFormScore.toString().toUpperCase() == "NAN"){
              section.FormSection_[0].MaxFormScore = 0
            }
            if(section.FormSection_[0].maximumSectionScore === undefined || section.FormSection_[0].maximumSectionScore.toString().toUpperCase() == "NAN"){
              section.FormSection_[0].maximumSectionScore = 0
            }
          } else{
            //TODO: set these to null when the null handling is ready
            section.FormSection_[0].PerSectionScore = 0
            section.FormSection_[0].FormPerScore = 0
            section.FormSection_[0].FormScore = 0
            section.FormSection_[0].MaxFormScore = 0
            section.FromSection_[0].AchievedSectionScore = 0
            section.FormSection_[0].maximumSectionScore = 0
            try{this.signOffDetailsPostData.formPerScore  = 0}catch{}
            try{this.signOffDetailsPostData.formScore = 0}catch{}
            try{this.signOffDetailsPostData.maxFormScore = 0}catch{}
          }
        }
      }
  }
  /**
   * This function is use for generate sigoff html file for developers test, it can call only in development mode
   */
  generatePersonalModeSignoffHtmlFileForTest = async (
    apiService: ApiService
  ) => {
    const onSuccessCallBack = (status, resData = "") => {
      if (status) {
        let blob = new Blob([resData], {
          type: "text/html;charset=utf-8",
        });

        const fileName = "SignOffDetailHtml.html";

        if (UtilService.isWebApp() || UtilService.isLocalHost()) {
          var a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = fileName;
          a.click();
        } else {
          const writeDirectory = this.platform.is("android")
            ? this.file.externalRootDirectory + "/Download"
            : this.file.documentsDirectory;

          this.file
            .writeFile(writeDirectory, fileName, blob, {
              replace: true,
            })
            .then((res) => {
              console.log("Write file success");
              this.socialSharing
                .share("", "", writeDirectory + "/" + fileName)
                .then((res) => { })
                .catch((error) => {
                  this.utilService.showAlert(error.message);
                });
            })
            .catch((error) => {
              console.log("Write file failed", error);
            });
        }
      } else {
        this.translateService
          .get([
            "PAGESPECIFIC_TEXT.SIGN_OFF.YOU_CANNOT_SIGNOFF",
            "PAGESPECIFIC_TEXT.SIGN_OFF.NOT_QUALIFIED",
            "PAGESPECIFIC_TEXT.SIGN_OFF.SIGNOFF",
          ])
          .subscribe((res) => {
            this.utilService.showAlert(
              resData,
              res["PAGESPECIFIC_TEXT.SIGN_OFF.NOT_QUALIFIED"]
            );
          });
      }
    };

    const onErrorCallBack = (error) => {
      this.translateService
        .get([
          "PAGESPECIFIC_TEXT.SIGN_OFF.YOU_CANNOT_SIGNOFF",
          "PAGESPECIFIC_TEXT.SIGN_OFF.SIGNOFF",
        ])
        .subscribe((res) => {
          this.utilService.showAlert(
            error.message || error,
            res["PAGESPECIFIC_TEXT.SIGN_OFF.YOU_CANNOT_SIGNOFF"]
          );
        });
    };

    if (!this.offlineMode) {
      const utcDateTime = moment().utc().format("DD.MM.YYYY HH:mm:ss");
      this.signOffDetailsPostData.signOffDate = utcDateTime;

      this.utilService.presentLoadingWithOptions();

      apiService
        .insertPersonalModeSignOffDetailsTest(this.signOffDetailsPostData)
        .subscribe(
          (response: Response) => {
            this.utilService.hideLoading();
            if (
              response.StatusCode ===
              EnumService.ApiResponseCode.RequestSuccessful
            ) {
              onSuccessCallBack(true, response.Result);
            } else {
              onSuccessCallBack(false, response.Message);
            }
          },
          (error) => {
            this.utilService.hideLoading();

            if (
              error.status === EnumService.ApiResponseCode.RequestSuccessful
            ) {
              onSuccessCallBack(true, error.error?.text);
            } else {
              onErrorCallBack(error);
            }
          }
        );
    }
  };

  /**
   * Navigate to the induction item type screen
   * @param userId for personal mode, it will get on the time of login
   * @param inductionContentItemIndex index of induction item
   */

  inductionNavigationProcess = (userId = null, inductionContentItemIndex) => {
    if (this.checkInDetail) {
      const inductionItems = this.checkInDetail.checkInInductionItems;
      if (
        inductionItems &&
        inductionContentItemIndex < inductionItems.length - 1
      ) {
        const inductionContentItem =
          inductionItems[inductionContentItemIndex + 1];
        if (
          inductionContentItem.contentType ===
          EnumService.InductionContentTypes.FORM
        ) {
          if (this.dedicatedMode) {
            const onSuccess = (result) => {
              this.viewFormFor = EnumService.ViewFormForType.Induction;
              this.signOffFormDetail = result as SignOffFormDetail;
              this.inductionContentItemIndex = inductionContentItemIndex + 1;
              this.navCtrl.navigateForward(
                UtilService.InductionContentTypeScreenIdentify(
                  inductionContentItem.contentType,
                  this.dedicatedMode
                ),
                {
                  queryParams: {
                    inductionContentItemIndex: this.inductionContentItemIndex,
                  },
                  replaceUrl: true,
                }
              );
            };

            if (this.offlineMode) {
              this.offlineManagerService
                .getSignOffFormDetail(inductionContentItem.formID)
                .then((response) => {
                  onSuccess(response);
                });
            } else {
              this.utilService.presentLoadingWithOptions();
              this.apiServiceRerence
                .getDedicatedModeSignOffFormDetail(inductionContentItem.formID)
                .subscribe(
                  (response: Response) => {
                    this.utilService.hideLoading();
                    if (
                      response.StatusCode ===
                      EnumService.ApiResponseCode.RequestSuccessful
                    ) {
                      onSuccess(response.Result);
                    }
                  },
                  (error) => {
                    this.utilService.hideLoading();
                  }
                );
            }
          } else {
            const entityIds = this.utilService.getRelevantEntityId(
              this.checkInForLocation?.locationID
            );
            const LocationID = entityIds?.LocationID;
            const ProjectID = entityIds?.ProjectID;
            const InventoryID = entityIds?.InventoryID;

            this.utilService.presentLoadingWithOptions();
            this.apiServiceRerence
              .getSignOffFormDetail(
                userId,
                inductionContentItem.formID,
                LocationID,
                ProjectID,
                InventoryID
              )
              .subscribe(
                (response: Response) => {
                  this.utilService.hideLoading();
                  if (
                    response.StatusCode ===
                    EnumService.ApiResponseCode.RequestSuccessful
                  ) {
                    this.viewFormFor = EnumService.ViewFormForType.Induction;
                    this.signOffFormDetail =
                      response.Result as SignOffFormDetail;
                    this.inductionContentItemIndex =
                      inductionContentItemIndex + 1;
                    this.navCtrl.navigateForward(
                      UtilService.InductionContentTypeScreenIdentify(
                        inductionContentItem.contentType,
                        this.dedicatedMode
                      ),
                      {
                        queryParams: {
                          inductionContentItemIndex:
                            this.inductionContentItemIndex,
                        },
                        replaceUrl: true,
                      }
                    );
                  }
                },
                (error) => {
                  this.utilService.hideLoading();
                }
              );
          }
        } else {
          this.inductionContentItemIndex = inductionContentItemIndex + 1;
          this.navCtrl.navigateForward(
            UtilService.InductionContentTypeScreenIdentify(
              inductionContentItem.contentType,
              this.dedicatedMode
            ),
            {
              queryParams: {
                inductionContentItemIndex: this.inductionContentItemIndex,
              },
              replaceUrl: true,
            }
          );
        }
      } else if (
        this.checkInDetail.checkInInduction.isDigitalSignOff ||
        this.checkInDetail.checkInInduction.isSignatureSignOff
      ) {
        this.signOffFor = EnumService.SignOffType.INDUCTION;
        this.navCtrl.navigateForward(["/signoff-digitalink"]);
      } else if (this.checkInDetail.checkInInduction.isPhotoSignOff) {
        this.signOffFor = EnumService.SignOffType.INDUCTION;
        if (this.dedicatedMode) {
          if (this.dedicatedModeCapturedSelfieForCheckinProcess) {
            if (this.offlineMode) {
              this.checkInPostData.userSignaturePhotoImageVideoFileId =
                this.dedicatedModeCapturedSelfieForCheckinProcess;
            } else {
              this.checkInPostData.userSignaturePhoto =
                this.dedicatedModeCapturedSelfieForCheckinProcess;
            }

            if (this.checkinoutDmAs === EnumService.CheckInType.AS_GUEST) {
              this.submitInductionCheckInDataGuest(this.apiServiceRerence);
            } else {
              this.submitInductionCheckInData(this.apiServiceRerence);
            }
          } else {
            this.dedicatedModeCapturePhotoFor =
              EnumService.DedicatedModeCapturePhotoForType.Signoff;
            this.navCtrl.navigateForward(["/checkinout-photoidentity-dm"]);
          }
        } else {
          this.navCtrl.navigateForward(["/signoff-photo"]);
        }
      } else {
        this.submitInductionCheckInData(this.apiServiceRerence);
      }
    }
  };

  dedicatedModeDocumentSignOffProcess = (photoName = null) => {
    this.signOffDetailsPostData.userId = this.dedicatedModeUserDetail?.userId;
    if (
      this.signOffDocumentDetail.isDigitalSignOff ||
      this.signOffDocumentDetail.isSignatureSignOff
    ) {
      this.navCtrl.navigateForward(["/signoff-digitalink"]);
    } else if (this.signOffDocumentDetail.isPhotoSignOff) {
      this.dedicatedModeCapturePhotoFor =
        EnumService.DedicatedModeCapturePhotoForType.Signoff;
      this.navCtrl.navigateForward(["/checkinout-photoidentity-dm"]);
    } else {
      this.submitPersonalModeSignoffData(this.apiServiceRerence);
    }
  };

  dedicatedModeFormSignOffProcess = (photoName = null) => {
    this.navCtrl.navigateForward("/form-cover-dm");
  };

  dedicatedModeWorkPermitSignOffProcess = (photoName = null) => {
    this.navCtrl.navigateForward("/form-cover-dm");
  }


  getPersonalModeFolderFiles(folders: checkInFormItem[], preservedFolders = []): Observable<any> {
    return new Observable(subscriber => {
      const currentID = this.utilService.getEntityIdFromId(this.currentSelectedCheckinPlace);
  
      if (!this.checkinEntityFolderFiles.some(folder => folder.id === currentID)) {
        const user = this.accountServiceRef.userValue;
        const filesInFolders = preservedFolders;
        const nestedFolders = [];
  
        const promises = folders.map(async (folder) => {
          let id ={number:0,type:""} ;
          if (folder.folderID != 0 && folder.folderID != null) {
            id = {number:folder.folderID,type:"doc"};
          } else if (folder.formFolderID != 0 && folder.formFolderID != null) {
            id = {number:folder.formFolderID,type:"form"};
          }
  
          if (id.number != 0) {
            if (id.type === "form"){
              const response = await this.apiServiceRerence.getPersonalModeAvailableForms(user?.userId, user?.companyID, id.number).toPromise();
              for (const entry of response.Result) {
                filesInFolders.push(entry);
                if ((entry.folderID != 0 && entry.folderID != null) || (entry.formFolderID != 0 && entry.formFolderID != null)) {
                  nestedFolders.push(entry);
                }
              }
            } else if (id.type === "doc"){
              const response = await this.apiServiceRerence.getPersonalModeAvailableDocuments(user?.userId, user?.companyID, id.number).toPromise();
              for (const entry of response.Result) {
                filesInFolders.push(entry);
                if ((entry.folderID != 0 && entry.folderID != null) || (entry.formFolderID != 0 && entry.formFolderID != null)) {
                  nestedFolders.push(entry);
                }
              }
            }
          }
        });
  
        Promise.all(promises).then(() => {
          //itterate for nested folders
          if (nestedFolders.length > 0) {
            this.getPersonalModeFolderFiles(nestedFolders, filesInFolders).subscribe();
          } else {
            this.checkinEntityFolderFiles.push({ id: currentID, files: filesInFolders });
            const cachedFolder = this.checkinEntityFolderFiles.find(folder => folder.id === currentID);
            subscriber.next(cachedFolder);
            //subscriber.next(filesInFolders);
            subscriber.complete();
          }
        }).catch(err => {
          console.log("error occured:" , err)
          subscriber.error(err);
        });
      } else {
        const cachedFolder = this.checkinEntityFolderFiles.find(folder => folder.id === currentID);
        //console.log("sending cache: ", cachedFolder)
        subscriber.next(cachedFolder);
        subscriber.complete();
      }
    });
  }
  
}
